{
  "common": {
    "address": "Aadress",
    "id": "ID",
    "yes": "Jah",
    "no": "Ei",
    "all": "Kõik",
    "mixed": "Segatud",
    "unknown": "Teadmata",
    "read_more_button": "Loe lähemalt",
    "click_to_learn_more": "Vajuta, et lugeda lähemalt",
    "none": "Puudub",
    "other": "Muu",
    "edit": "Muuda",
    "date": "Kuupäev: {date}",
    "kw": "kW",
    "kwh": "kWh",
    "mwh": "MWh",
    "gwh": "GWh",
    "eur": "€",
    "months_abbrev": {
      "1": "Jaan",
      "2": "Veebr",
      "3": "Märts",
      "4": "Apr",
      "5": "Mai",
      "6": "Juuni",
      "7": "Juuli",
      "8": "Aug",
      "9": "Sept",
      "10": "Okt",
      "11": "Nov",
      "12": "Dets"
    },
    "next": "Edasi",
    "back": "Tagasi",
    "save": "Salvesta",
    "saving": "Salvestan",
    "optional": "Valikuline",
    "saved_successfully": "Salvestatud edukalt",
    "unsaved_changes_confirm": "Sul on salvestamata muudatusi. Kas lahkuda lehelt ja need ära visata?",
    "clear": "Tühjenda",
    "filter": "Filtreeri",
    "search": "Otsi",
    "select": "Vali",
    "select_all": "Vali kõik",
    "clear_all": "Tühjenda valik",
    "pricing_loading_messages": {
      "retrieving_market_levels": "Laen turuhindu...",
      "applying_sourcing_criteria": "Rakendan hankekriteeriume...",
      "calculating_fees": "Arvutan tasusid..."
    },
    "selected": "valitud",
    "total_volume": "Kogumaht",
    "last_updated": "Viimati uuendatud",
    "certificate": "Sertifikaat",
    "volume": "Maht",
    "technology_label": "Tehnoloogia",
    "uploaded": "Üles laetud",
    "not_uploaded": "Ei ole üles laetud",
    "any_file_format": "Sobivad kõik failivormingud",
    "pdf_file_format": "Sobivad failid peavad olema .pdf formaadis",
    "invalid_file_error": "See fail ei ole korrektne, palun laadige üles korrektne fail.",
    "invalid_file_contact_support": "Kui arvate, et tegemist on veaga ja see dokument on tõepoolest kehtiv, palun võtke ühendust meie klienditoega. Selleks klõpsake ekraani all paremas nurgas olevale vestlusmullile või valige ülemisest menüüst 'Võta meiega ühendust'.",
    "coming_soon": "Tulekul!",
    "contactSupport": "Võta ühendust klienditoega",
    "loading": "Laeb",
    "uploading": "Laadib üles...",
    "pending": "Ootel",
    "rejected": "Tagasi lükatud",
    "active": "Aktiivne",
    "status": "Staatus:",
    "add": "Lisa",
    "creating": "Lisamine...",
    "create_device": "Lisa seade",
    "not_specified": "Määramata",
    "page_navigation": "Lehekülgede navigeerimine",
    "previous_page": "Eelmine lehekülg",
    "next_page": "Järgmine lehekülg",
    "remove": "Eemalda",
    "delete": "Kustuta",
    "deleted": "(kustutatud)",
    "add_another_unit": "Lisa veel üks ühik",
    "saved": "Salvestatud",
    "retry": "Proovi uuesti",
    "download": "Lae alla",
    "close": "Sulge",
    "open_pdf": "Ava PDF",
    "success": "Edukas",
    "unexpected_error": "Ootamatu viga, proovi hiljem uuesti!",
    "select_option": "Vali",
    "year": "Aasta",
    "years": "Aastat",
    "month": "Kuu",
    "months": "Kuud",
    "day": "Päev",
    "select_month": "Vali kuu",
    "select_day": "Vali päev",
    "full_name": "Täisnimi",
    "name": "Nimi",
    "start_date": "Algus",
    "end_date": "Lõpp",
    "email": "E-post",
    "company_search": {
      "label": "Ettevõtte otsing",
      "description": "Otsi ettevõtet nime, registrikoodi või käibemaksukoodi järgi",
      "placeholder": "Sisesta ettevõtte nimi, registrikood või käibemaksukood",
      "ai_extracted": "AI ekstraktitud",
      "custom_entry": "Kohandatud sisestus",
      "unavailable": "Ettevõtte otsing ei ole saadaval, sisesta ettevõtte andmed käsitsi"
    },
    "counterparty_picker": {
      "company_label": "Ettevõtte nimi",
      "account_label": "Registrikonto number",
      "account_invalid": "Kontonumber tohib sisaldada ainult tähti ja numbreid",
      "account_invalid_aib": "Peab olema korrektne EECS-i identifikaator (2 numbrit, X ja 7 tähemärki)",
      "account_invalid_rego": "Peab olema Ofgemi kontonumber (GEN, PAR, SUP või AGE, millele järgneb 7 numbrit)",
      "account_invalid_rgp": "Peab olema TGE liikmekood (tähed ja numbrid, nt RESENENC)",
      "account_unrecognized_warning": "Ei ole äratuntav kontonumbri vorming - registri riiki ei saa automaatselt tuvastada.",
      "internal_account_label": "Registri sisekonto number",
      "internal_account_help": "Valikuline. Vajalik ainult registrites, mis kasutavad alamkontosid.",
      "internal_account_placeholder": "Valikuline alamkonto ID"
    },
    "eecs_name_mismatch": {
      "both": "Ettevõtte nimi ja EECS ei kattu. {name} vastab EECS-ile: {expectedEecs} ja {eecs} vastab ettevõttele {expectedName}",
      "eecs_only": "Ettevõtte nimi ja EECS ei kattu. Ettevõttele {name} ei leitud EECS-i ja {eecs} vastab ettevõttele {expectedName}",
      "name_only": "Ettevõtte nimi ja EECS ei kattu. {name} vastab EECS-ile: {expectedEecs} ja EECS-ile {eecs} ei leitud ettevõtet",
      "unknown_counterparty": "Kontrolli ettevõtte nime ja kontonumbrit lepingust."
    },
    "no_results": "Otsing ei andnud tulemusi",
    "partial_results": "Kuvatakse {total} vastest esimesed {shown} — täpsusta otsingut",
    "technology": {
      "solar": "Päike",
      "wind": "Tuul",
      "hydro": "Vesi",
      "biomass": "Biomass",
      "nuclear": "Tuumaenergia",
      "mixed": "Segu"
    },
    "country": {
      "AD": "Andorra",
      "AE": "Araabia Ühendemiraadid",
      "AF": "Afganistan",
      "AG": "Antigua ja Barbuda",
      "AI": "Anguilla",
      "AL": "Albaania",
      "AM": "Armeenia",
      "AO": "Angola",
      "AQ": "Antarktika",
      "AR": "Argentina",
      "AS": "Ameerika Samoa",
      "AT": "Austria",
      "AU": "Austraalia",
      "AW": "Aruba",
      "AX": "Ahvenamaa",
      "AZ": "Aserbaidžaan",
      "BA": "Bosnia ja Hertsegoviina",
      "BB": "Barbados",
      "BD": "Bangladesh",
      "BE": "Belgia",
      "BF": "Burkina Faso",
      "BG": "Bulgaaria",
      "BH": "Bahrein",
      "BI": "Burundi",
      "BJ": "Benin",
      "BL": "Saint-Barthélemy",
      "BM": "Bermuda",
      "BN": "Brunei",
      "BO": "Boliivia",
      "BQ": "Kariibi Madalmaad",
      "BR": "Brasiilia",
      "BS": "Bahama",
      "BT": "Bhutan",
      "BV": "Bouvet’ saar",
      "BW": "Botswana",
      "BY": "Valgevene",
      "BZ": "Belize",
      "CA": "Kanada",
      "CC": "Kookossaared",
      "CD": "Kongo DV",
      "CF": "Kesk-Aafrika Vabariik",
      "CG": "Kongo Vabariik",
      "CH": "Šveits",
      "CI": "Elevandiluurannik",
      "CK": "Cooki saared",
      "CL": "Tšiili",
      "CM": "Kamerun",
      "CN": "Hiina",
      "CO": "Colombia",
      "CR": "Costa Rica",
      "CU": "Kuuba",
      "CV": "Roheneemesaared",
      "CW": "Curaçao",
      "CX": "Jõulusaar",
      "CY": "Küpros",
      "CZ": "Tšehhi",
      "DE": "Saksamaa",
      "DJ": "Djibouti",
      "DK": "Taani",
      "DM": "Dominica",
      "DO": "Dominikaani Vabariik",
      "DZ": "Alžeeria",
      "EC": "Ecuador",
      "EE": "Eesti",
      "EG": "Egiptus",
      "EH": "Lääne-Sahara",
      "ER": "Eritrea",
      "ES": "Hispaania",
      "ET": "Etioopia",
      "FI": "Soome",
      "FJ": "Fidži",
      "FK": "Falklandi saared",
      "FM": "Mikroneesia",
      "FO": "Fääri saared",
      "FR": "Prantsusmaa",
      "GA": "Gabon",
      "GB": "Ühendkuningriik",
      "GD": "Grenada",
      "GE": "Gruusia",
      "GF": "Prantsuse Guajaana",
      "GG": "Guernsey",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GL": "Gröönimaa",
      "GM": "Gambia",
      "GN": "Guinea",
      "GP": "Guadeloupe",
      "GQ": "Ekvatoriaal-Guinea",
      "GR": "Kreeka",
      "GS": "Lõuna-Georgia ja Lõuna-Sandwichi saared",
      "GT": "Guatemala",
      "GU": "Guam",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HK": "Hongkongi erihalduspiirkond",
      "HM": "Heardi ja McDonaldi saared",
      "HN": "Honduras",
      "HR": "Horvaatia",
      "HT": "Haiti",
      "HU": "Ungari",
      "ID": "Indoneesia",
      "IE": "Iirimaa",
      "IL": "Iisrael",
      "IM": "Mani saar",
      "IN": "India",
      "IO": "Briti India ookeani ala",
      "IQ": "Iraak",
      "IR": "Iraan",
      "IS": "Island",
      "IT": "Itaalia",
      "JE": "Jersey",
      "JM": "Jamaica",
      "JO": "Jordaania",
      "JP": "Jaapan",
      "KE": "Keenia",
      "KG": "Kõrgõzstan",
      "KH": "Kambodža",
      "KI": "Kiribati",
      "KM": "Komoorid",
      "KN": "Saint Kitts ja Nevis",
      "KP": "Põhja-Korea",
      "KR": "Lõuna-Korea",
      "KW": "Kuveit",
      "KY": "Kaimanisaared",
      "KZ": "Kasahstan",
      "LA": "Laos",
      "LB": "Liibanon",
      "LC": "Saint Lucia",
      "LI": "Liechtenstein",
      "LK": "Sri Lanka",
      "LR": "Libeeria",
      "LS": "Lesotho",
      "LT": "Leedu",
      "LU": "Luksemburg",
      "LV": "Läti",
      "LY": "Liibüa",
      "MA": "Maroko",
      "MC": "Monaco",
      "MD": "Moldova",
      "ME": "Montenegro",
      "MF": "Saint-Martin",
      "MG": "Madagaskar",
      "MH": "Marshalli Saared",
      "MK": "Põhja-Makedoonia",
      "ML": "Mali",
      "MM": "Myanmar (Birma)",
      "MN": "Mongoolia",
      "MO": "Macau erihalduspiirkond",
      "MP": "Põhja-Mariaanid",
      "MQ": "Martinique",
      "MR": "Mauritaania",
      "MS": "Montserrat",
      "MT": "Malta",
      "MU": "Mauritius",
      "MV": "Maldiivid",
      "MW": "Malawi",
      "MX": "Mehhiko",
      "MY": "Malaisia",
      "MZ": "Mosambiik",
      "NA": "Namiibia",
      "NC": "Uus-Kaledoonia",
      "NE": "Niger",
      "NF": "Norfolk",
      "NG": "Nigeeria",
      "NI": "Nicaragua",
      "NL": "Holland",
      "NO": "Norra",
      "NP": "Nepal",
      "NR": "Nauru",
      "NU": "Niue",
      "NZ": "Uus-Meremaa",
      "OM": "Omaan",
      "PA": "Panama",
      "PE": "Peruu",
      "PF": "Prantsuse Polüneesia",
      "PG": "Paapua Uus-Guinea",
      "PH": "Filipiinid",
      "PK": "Pakistan",
      "PL": "Poola",
      "PM": "Saint-Pierre ja Miquelon",
      "PN": "Pitcairni saared",
      "PR": "Puerto Rico",
      "PS": "Palestiina alad",
      "PT": "Portugal",
      "PW": "Belau",
      "PY": "Paraguay",
      "QA": "Katar",
      "RE": "Réunion",
      "RO": "Rumeenia",
      "RS": "Serbia",
      "RU": "Venemaa",
      "RW": "Rwanda",
      "SA": "Saudi Araabia",
      "SB": "Saalomoni Saared",
      "SC": "Seišellid",
      "SD": "Sudaan",
      "SE": "Rootsi",
      "SG": "Singapur",
      "SH": "Saint Helena",
      "SI": "Sloveenia",
      "SJ": "Svalbard ja Jan Mayen",
      "SK": "Slovakkia",
      "SL": "Sierra Leone",
      "SM": "San Marino",
      "SN": "Senegal",
      "SO": "Somaalia",
      "SR": "Suriname",
      "SS": "Lõuna-Sudaan",
      "ST": "São Tomé ja Príncipe",
      "SV": "El Salvador",
      "SX": "Sint Maarten",
      "SY": "Süüria",
      "SZ": "Svaasimaa",
      "TC": "Turks ja Caicos",
      "TD": "Tšaad",
      "TF": "Prantsuse Lõunaalad",
      "TG": "Togo",
      "TH": "Tai",
      "TJ": "Tadžikistan",
      "TK": "Tokelau",
      "TL": "Ida-Timor",
      "TM": "Türkmenistan",
      "TN": "Tuneesia",
      "TO": "Tonga",
      "TR": "Türgi",
      "TT": "Trinidad ja Tobago",
      "TV": "Tuvalu",
      "TW": "Taiwan",
      "TZ": "Tansaania",
      "UA": "Ukraina",
      "UG": "Uganda",
      "UM": "Ühendriikide hajasaared",
      "US": "Ameerika Ühendriigid",
      "UY": "Uruguay",
      "UZ": "Usbekistan",
      "VA": "Vatikan",
      "VC": "Saint Vincent ja Grenadiinid",
      "VE": "Venezuela",
      "VG": "Briti Neitsisaared",
      "VI": "USA Neitsisaared",
      "VN": "Vietnam",
      "VU": "Vanuatu",
      "WF": "Wallis ja Futuna",
      "WS": "Samoa",
      "XK": "Kosovo",
      "YE": "Jeemen",
      "YT": "Mayotte",
      "ZA": "Lõuna-Aafrika Vabariik",
      "ZM": "Sambia",
      "ZW": "Zimbabwe",
      "BE_BRU": "Belgia (Brüssel)",
      "BE_FED": "Belgia (Föderaalne)",
      "BE_FLA": "Belgia (Flandria)",
      "BE_WAL": "Belgia (Valloonia)",
      "other": "Muu"
    },
    "done": "Valmis",
    "company": "Ettevõte",
    "companies": "Ettevõtted",
    "search_companies": "Otsi ettevõtteid",
    "select_companies": "Vali ettevõtted",
    "documents": "Dokumendid",
    "contracts": "Lepingud",
    "devices": "Seadmed",
    "hide_admin_options": "Peida admini valikud",
    "show_admin_options": "Näita admini valikud",
    "actions": {
      "title": "Tegevused",
      "send": "Saada",
      "receive": "Võta vastu",
      "portfolios": "Portfellid",
      "buy": "Osta",
      "buy_and_cancel": "Osta ja tühista",
      "sell": "Müü",
      "cancel": "@:common.cancel",
      "confirm_send": "Kinnita saatmistellimus",
      "confirm_sell": "Kinnita müügi seadistamine",
      "accept": "Nõustu"
    },
    "eacs_in_inventory": "päritolutunnistust laos",
    "settings": "Seaded",
    "action_items": "Tegevus vajalik",
    "type_here": "Kirjutage oma sõnum siia...",
    "cancel": "Tühista",
    "confirm": "Kinnita",
    "continue": "Jätka",
    "step": "Samm",
    "placeholderText": "Kohatäide tekst - palun andke võimalusel täpsem kontekst.",
    "production_period": "Tootmisperiood",
    "production_year": "Tootmisaasta"
  },
  "primevue": {
    "startsWith": "Algab",
    "contains": "Sisaldab",
    "notContains": "Ei sisalda",
    "endsWith": "Lõpeb",
    "equals": "Võrdub",
    "notEquals": "Ei võrdu",
    "noFilter": "Filtrit pole",
    "lt": "Väiksem kui",
    "lte": "Väiksem või võrdne",
    "gt": "Suurem kui",
    "gte": "Suurem või võrdne",
    "dateIs": "Kuupäev on",
    "dateIsNot": "Kuupäev ei ole",
    "dateBefore": "Kuupäev enne",
    "dateAfter": "Kuupäev pärast",
    "clear": "Tühjenda",
    "apply": "Rakenda",
    "matchAll": "Sobita kõik",
    "matchAny": "Sobita ükskõik milline",
    "addRule": "Lisa reegel",
    "removeRule": "Eemalda reegel",
    "today": "Täna"
  },
  "ppa_strategy": {
    "customize_strategy_title": "Kohanda PPA reservi",
    "creating_new_ppa_instructions": "Loon uusi PPA reservi juhiseid",
    "about_ppa_strategy": "PPA reservi kohta",
    "no_ppa_instructions": "PPA reservi juhised seadmata",
    "ppa_agreement": "PPA Leping",
    "projected_total": "Prognoositud kokku",
    "delivered": "Tarnitud",
    "no_documents": "Dokumente pole lisatud",
    "fixed_yearly_allocation": "Fikseeritud aastane jaotus",
    "percentage_allocation": "{percentage}% toodangust",
    "next_delivery": "Järgmine tarne"
  },
  "language": {
    "en": "Inglise keel",
    "et": "Eesti keel",
    "lv": "Läti keel",
    "lt": "Leedu keel",
    "sv": "Rootsi keel"
  },
  "settings": {
    "title": "Seaded",
    "select_language": "Vali keel",
    "name": "Nimi",
    "email": "E-post",
    "phone": "Telefoninumber",
    "email_cannot_be_changed": "E-posti muutmiseks kutsu uus meeskonnaliige Ettevõtte seadete lehelt",
    "receive_transaction_emails": "Saa müügiteavituste e-kirju",
    "receive_transaction_emails_hint": "E-kirjad teie päritolutunnistuste müükide kohta koos teenustasu arvetega. Määrake ettevõtte seadetes arvete e-post, et teie raamatupidaja saaks arved kätte ka siis, kui see on välja lülitatud."
  },
  "app": {
    "development_environment": "See on arenduskeskkond",
    "staging_environment": "See on proovikeskkond",
    "managing_client_account": "Haldad kliendi kontot: {email}",
    "stop_managing": "Lõpeta haldamine",
    "log_in": "Logi sisse",
    "log_out": "Logi välja",
    "error_occurred": "Juhtus viga",
    "error_message_code": "Veateate kood: {errorCode}",
    "contact_support": "Palun võtke ühendust kasutajatoega, et viga lahendada. Selleks vajutage palun ekraani all paremas nurgas olevale jutumullile või valige ülevalt menüüst 'Võta meiega ühendust'."
  },
  "signup": {
    "choose_company_country": "Teie tootmisseadme riik",
    "select_country_placeholder": "Vali riik",
    "legal": {
      "byJoining": "Liitumisel nõustute",
      "membershipAgreement": "Soldera Platvormilepinguga.",
      "personalDataNote": "Teie isikuandmeid töödeldakse vastavalt meie",
      "privacyPolicy": "privaatsuspoliitikale."
    },
    "modal": {
      "hello_button": "Alusta registreerimist",
      "hello": "👋 Tere tulemast!",
      "soldera_faq": "Soldera kodulehelt",
      "lv": {
        "section1": "Rõõm näha, et oled otsustanud liituda Solderaga. Kui Sul on veel küsimusi, võib põhilistele küsimustele leida vastuseid",
        "section2": "Allpool oleva teabe täitmisega annate Solderale juurdepääsu teie päritolutunnistuste haldamiseks AST infosüsteemis. Samuti palume teil allkirjastada dokumendid Dokobit süsteemis. Need dokumendid luuakse automaatselt teie esitatud andmete põhjal. Kui tekib probleeme, kirjutage meile paremas alanurgas või helistage meie Eesti esindajale +372 26417883"
      },
      "ee": {
        "section1": "Tere tulemast",
        "section2": "Rõõm näha, et oled otsustanud liituda Solderaga. Kui Sul on veel küsimusi, võib põhilistele küsimustele leida vastuseid",
        "section3": "Kui Sa veel ei saa päritolutunnistusi",
        "section4": "Aitame Sul koostada ja esitada kõik vajalikud dokumendid päritolutunnistuste saamiseks. Esimeseks sammuks on võrgulepingu üleslaadimine. See on dokument, mida nõuab Elering ja mis sisaldab enamikku andmeid, mida on vaja päritolutunnistuste saamiseks.",
        "section5": "Pärast võrgulepingu üleslaadimist anname Sulle ülevaate Sinu andmetest ja küsime puuduolevad andmed. Kui oled kõik andmed kinnitanud, koostame Sinu jaoks vajalikud dokumendid (sealhulgas meievahelise lepingu), palume Sul need allkirjastada ja esitame need seejärel Eleringile.",
        "section6": "Kui Sa juba saad päritolutunnistusi",
        "section7": "Kui soovid, et hakkaksime Sinu eest haldama päritolutunnistuste müüki, palun vajuta siia või võrgulepingu leheküljel asuvale lingile. Meil on vaja tootmisseadme omaniku ja allkirjastaja andmeid. Nende põhjal koostame vastavad volikirjad ja sõlmime Sinuga lepingu."
      }
    },
    "message_rate_limited_title": "Liiga palju sõnumeid",
    "message_rate_limited": "Olete lühikese aja jooksul saatnud mitu sõnumit. Palun oodake tund enne uue sõnumi saatmist või kirjutage aadressil support@soldera.org.",
    "new_country": {
      "ask_for_message": "Kaalume laienemist sellesse riiki.",
      "ask_for_message_2": "Lihtsustage oma päritolutunnistuste protsessi - alates väljastamisest ja aruandlusest kuni müügini. Võtke meiega ühendust oma elektritootmisrajatise lühikirjeldusega ja näitame teile, kuidas neid ülesandeid automatiseerida.",
      "send_message": "Saada sõnum",
      "message_sent": "Sõnum saadetud",
      "success_message": "Teie sõnum on edukalt saadetud!",
      "error_message": "Sõnumi saatmine ebaõnnestus, proovige hiljem uuesti!",
      "placeholder": "Sisestage oma sõnum siia"
    },
    "grid_contract_upload": {
      "title": "Võrgulepingu ülesse laadimine",
      "description": "Me vajame Sinu tootmisseadme kehtivat võrgulepingut, et täita ja esitada vajalikud dokumendid registreerimiseks.",
      "link_text": "Juhul, kui Sinu tootmisseade juba saab päritolutunnistusi Eleringist, palun vajuta siia.",
      "upload_prompt": "Vajuta siia, et laadida üles võrguleping.",
      "supported_formats": "Hetkel toetame ainult .pdf formaadis dokumente.",
      "existing_contract_error": "Seade {eic} on juba registreeritud. {link}",
      "manage_devices_link": "Halda seadmeid siit.",
      "wrong_file_error": "Tundub, et laadisite üles faili, mis ei ole võrguleping. Lisateavet võrgulepingute leidmise kohta leiate allpool.",
      "contact_support": "Kui arvate, et tegemist on veaga ja esitatud dokument on tõepoolest võrguleping, palume võtta ühendust meie kasutajatoega. Selleks vajutage palun ekraani all paremas nurgas olevale jutumullile või valige ülevalt menüüst 'Võta meiega ühendust'.",
      "finding_contract_title": "Kust leida võrgulepingut?",
      "elektrilevi_contract_info": "Elektrileviga sõlmitud võrgulepingu leidmiseks",
      "elektrilevi_contract_link_text": "vajuta siia, et siseneda nende iseteenindusse.",
      "vkg_contract_info": "VKG Elektrivõrkudega sõlmitud võrgulepingu leidmiseks",
      "vkg_contract_link_text": "vajuta siia, et siseneda nende iseteenindusse."
    },
    "multiple_upload": {
      "title": "Dokumentide üleslaadimine",
      "description": "Palun laadige üles järgmised dokumendid, et jätkata registreerimist.",
      "lt_inspection_report": "Viimane tehniline ülevaatus",
      "lt_inspection_report_where_to_find": "Palun leidke see dokument <a href=\"https://www.epaslaugos.lt/portal/service/92420/16020\" target=\"_blank\"> riigi iseteenindusportaalist </a>",
      "lt_property_limit_scheme": "Tootmisseadme asukoha piiride diagramm",
      "lt_property_limit_scheme_where_to_find": "Palun otsige seda dokumenti tootmisseadme paigaldamise dokumentatsiooni hulgast",
      "lt_power_of_attorney": "Volikiri (nt JAR ESI)",
      "lt_power_of_attorney_where_to_find": "Sobivad kõik dokumendid, mis tõestavad teie volitust esindada seotud ettevõtet. Kui tootmisseadmel on mitu omanikku, volikiri peab sisaldama kõigi omanike allkirju.",
      "where_to_find_this_document": "Kust leida seda dokumenti?",
      "lt_invalid_power_of_attorney": "Palun laadige üles kehtiv volikiri.",
      "UF_lv_document_of_device_auxiliaries": "Seadme abisüsteemide dokument",
      "UF_lv_document_of_device_auxiliaries_where_to_find": "See dokument peaks sisaldama teavet kõigi abisüsteemide või seadmete kohta, mis toetavad teie tootmisseadme tööd",
      "UF_lv_grid_connection_scheme": "Võrguühenduse skeem",
      "UF_lv_grid_connection_scheme_where_to_find": "See dokument tuleb saada teie võrguoperaatorilt (PVO või JVO). See näitab, kuidas teie tootmisseade on võrku ühendatud ja sisaldab asjakohaseid mõõtepunkte",
      "UF_lv_power_of_attorney": "Volikiri",
      "UF_lv_power_of_attorney_where_to_find": "Tootmisseadme omaniku(ke) allkirjastatud volikiri (juhul kui Konto omanik ei ole omanik või ei ole tootmisseadme ainus omanik)"
    },
    "add_generator_component": {
      "title": "Tootmisseadme andmed",
      "subsidy_title": "Tootmisseadme riigitoetused",
      "subsidy_question": "Kas see tootmisseade on saanud riigipoolset toetust?",
      "elering_support": "Eleringi tootmistoetus",
      "battery_section_title": "Salvestusseade (aku)",
      "battery_question": "Kas tootmisseade on seotud salvestusseadmega?",
      "battery_details": "Sisesta salvestusseade andmed",
      "unit_power": "Ühikvõimsus (kW)",
      "capacity": "Mahtuvus (kWh)",
      "ppa_section_title": "Otsemüügi leping (PPA)",
      "ppa_question": "Kas tootmisseadme elektrit müüakse pikaajalise otsemüügi lepinguga (PPA-ga)?",
      "ppa_include_certificates_question": "Kas see PPA sisaldab päritolutunnistuste müüki?",
      "ppa_details": "Sisesta PPA andmed",
      "ppa_start_date": "Alguskuupäev",
      "ppa_mwh": "@:common.mwh",
      "ppa_client_name": "Kliendi ettevõtte nimi",
      "ppa_country": "Riik",
      "enter_subsidies": "Sisesta toetused",
      "add_subsidy": "Lisa toetus",
      "device_technology_title": "Tootmisseadme tehnoloogia",
      "device_technology_description": "Palun vali tootmisseadme tehnoloogia",
      "device_technology_solar": "Päikeseenergia",
      "device_technology_wind": "Tuuleenergia",
      "device_technology_hydro": "Hüdroenergia",
      "device_technology_mixed": "Eri tehnoloogiad ühe mõõtmispunkti taga"
    },
    "add_subsidy_component": {
      "subsidy_provider": "Toetuse andja",
      "decision_date": "Otsuse kuupäev",
      "subsidy_plan": "Toetuskava",
      "amount": "Summa",
      "placeholder_provider": "Nt: Kredex, PRIA",
      "placeholder_plan": "Nt: Mitmekesistamise toetus",
      "investment": "Investeeringutoetus",
      "objective": "Riigiabi eesmärk",
      "placeholder_number": "Nt: 1234567890",
      "placeholder_objective": "Nt: Taastuvenergia",
      "production": "Tootmistoetus",
      "select_type": "Vali toetuse tüüp",
      "subsidy_number": "Toetusskeemi number",
      "subsidy_type": "Toetusskeemi tüüp"
    },
    "contact_review_component": {
      "signer_title": "Allkirjastaja isikuandmed",
      "generator_owner_title": "Tootmisseadme omaniku andmed",
      "generator_owner_subtext": "Palun sisesta tootmisseadme omaniku andmed täpselt nii, nagu need on võrgulepingus. Omanik võib olla kas Sina või Sinu ettevõte.",
      "select_company": "Vali omanik",
      "add_new_company": "Uus omanik"
    },
    "role_selection": {
      "title": "Vali oma roll",
      "subtitle": "Alustamiseks vali palun, kumb kirjeldab sind paremini",
      "corporate_title": "Olen ettevõte",
      "corporate_perfect_if": "Sobib kui:",
      "corporate_benefit1": "Vajad AI-põhist ESG, CBAM, CSRD ja SBTi aruandluse automatiseerimist",
      "corporate_benefit2": "Soovid hankida taastuvenergiat(EAC-sid) otse tootjatelt parima hinnaga",
      "corporate_benefit3": "Tahad vähendada vastavuskulusid rohkem kui 50%",
      "corporate_benefit4": "Vajad tsentraliseeritud rahvusvahelisi auditiaruandeid",
      "producer_title": "Olen energiatootja",
      "producer_perfect_if": "Sobib kui:",
      "producer_benefit1": "Omad või opereeriid tuule-, päikese-, hüdro- või biomassi rajatisi",
      "producer_benefit2": "Tahad maksimeerida tulu Päritolutunnistustest (GO)",
      "producer_benefit3": "Vajad automatiseeritud registri haldust ja GO kauplemist",
      "producer_benefit4": "Tahad forward-müüke tulu stabiliseerimiseks",
      "help_title": "Ei tea, kumb tee sobib?",
      "help_description": "Sul on segajuhtum? Ettevõte koos mõne tootmisüksusega? Kirjelda meile oma ettevõtet ja aitame valida õige tee.",
      "help_button": "Aita mind valida",
      "help_form_label": "Kirjelda oma ettevõtet",
      "help_form_placeholder": "Näiteks: 'Oleme tootmisettevõte 2 MW katusepaneelidega. Vajame peamiselt vastavusabi, aga tahame ka oma väikest tootmist hallata.'",
      "help_submit": "Saada päring",
      "help_success": "Täname! Võtame varsti ühendust, et aidata sul õige tee valida."
    },
    "corporate": {
      "title": "Ettevõtte registreerimine",
      "rate_limit_error": "Ettevõtete loomise limiit on täis. Kui liidad suurt portfelli, võta palun ühendust {supportEmail}.",
      "description": "Automatiseeri ESG/CBAM/CSRD vastavust AI-ga ja hangi EAC-sid otse taastuvenergiatootjatelt",
      "form_title": "Ettevõtte andmed",
      "company_name": "Ettevõtte nimi",
      "registry_code": "Registrikood",
      "address": "Aadress",
      "phone_number": "Telefoninumber",
      "vat": "KMKR number",
      "vat_optional": "Valikuline",
      "country": "Riik",
      "select_country": "Vali riik",
      "submit": "Lõpeta registreerimine",
      "platform_agreement_checkbox_label": "Vajutades nupule Nõustun nõustute {link}."
    },
    "international": {
      "submit": "Saada",
      "confirmation_title": "Täname registreerumast!",
      "confirmation_message": "Meie meeskond võtab teiega peagi ühendust, et konto seadistamine lõpule viia.",
      "duplicate_company_error": "Selle registrikoodiga ettevõte on selles riigis juba olemas. Meie meeskond võtab teiega ühendust, et liitumine lõpule viia."
    },
    "generator_license_review": {
      "title": "Tootmisseadme litsentsinumber",
      "description": "Palun leidke litsentsinumber, mis on seotud tootmisseadme tootmis- või arendusloaga.",
      "directions": "Loa numbri leidmiseks võite seda otsida <a href=\"https://www.licencijavimas.lt/lis-epp-app/public/licenceSearch\" target=\"_blank\">Leedu litsentside infosüsteemis</a>.",
      "licenseHints": "Võimalikud litsentsinumbrid Litgridilt"
    },
    "user_type": {
      "select_title": "Vali omaniku tüüp",
      "select_description": "Palun vali, kas registreerid seadme omanikuna eraisiku või ettevõttena.",
      "private": {
        "button": "Registreeri eraisikuna",
        "description": "Vali see, kui registreerid oma kodu päikesepaneele või muid isiklikke taastuvenergia seadmeid."
      },
      "company": {
        "button": "Registreeri ettevõttena",
        "description": "Vali see, kui registreerid ettevõtte või organisatsiooni nimel, millele kuuluvad taastuvenergia seadmed."
      },
      "selection_prefix": "Oled valinud:",
      "selected_private": "Registreeri eraisikuna",
      "selected_company": "Registreeri ettevõttena"
    },
    "contract_review_component": {
      "data_review_title": "Andmete ülevaade",
      "data_review_subtext": "Palun vaadata veel viimast korda üle, et kõik andmed on korrektselt sisestatud",
      "data_signer_title": "Allkirjastaja isikuandmed",
      "data_company_title": "Tootmisseadme omaniku andmed",
      "data_generator_title": "Tootmisseadme andmed",
      "documents_review_title": "Dokumentide ülevaade",
      "documents_review_subtext": "Järgmisel lehel palume Sul allkirjastada komplekt dokumente süsteemis Dokobit. Dokumendid on automaatselt koostatud Sinu andmete põhjal. Siin on ülevaade, et mis dokumendid ootavad allkirjastamist:",
      "self_uploaded_file_text": "Teie poolt ülesse laetud dokument, mis pannakse kaasa allkirjstatavate dokumentide ümbrikku.",
      "documents_signed": "Dokument allkirjastatud",
      "documents_remaining": "{count} dokumenti on jäänud allkirjastada",
      "ee": {
        "origin_certificate_account_application_title": "Avaldus päritolutunnistuste konto avamiseks",
        "origin_certificate_account_application_description": "Dokument, mis väljendab soovi avada Eleringis päritolutunnistuste konto. See dokument volitab lisaks Solderat nende päritolutunnistuste haldamiseks.",
        "type_conditions_title": "Päritolutunnistuste kasutamise tüüptingimused",
        "type_conditions_description": "Eleringi kehtestatud <a href=\"https://elering.ee/sites/default/files/public/Taastuvenergia/Elektrienergia%20p%C3%A4ritolutunnistuste%20kasutamise%20t%C3%BC%C3%BCptingimused%20(kehtiv%20alates%2004.08.2025).pdf\" target=\"_blank\"> tüüptingimused </a> ja reeglid päritolutunnistuste turul toimingute tegemiseks. ",
        "authorization_application_title": "Avaldus päritolutunnistuste konto volituse andmiseks",
        "authorization_application_description": "Dokument, mis väljendab soovi anda Solderale volitus päritolutunnistuste haldamiseks Eleringi infosüsteemis.",
        "investment_support_confirmation_title": "Kinnituskiri investeeringutoetuse saamise/mittesaamise kohta",
        "investment_support_confirmation_description": "Dokument, mis kinnitab Eleringile antud toetused teie tootmisseadmele.",
        "network_contract_title": "Võrguleping",
        "network_contract_description": "Sinu üleslaaditud võrguleping, mida Elering vajab tootmisseadme registreerimiseks.",
        "device_registration_form_title": "Seadme registreerimise vorm",
        "device_registration_form_description": "Eleringi nõutav vorm teie tootmisseadme andmete esitamiseks.",
        "soldera_membership_agreement_title": "Soldera platvormileping",
        "soldera_membership_agreement_description": "Leping teie ja Soldera vahel, mis sätestab koostöö tingimused.",
        "elering_data_title": "Eleringi andmed",
        "elering_data_description": "Dokument teie andmete esitamiseks Eleringile, et hõlbustada tootmisseadme registreerimist."
      },
      "lv": {
        "lv_account_authorization_form_title": "Avaldus päritolutunnistuste konto volituse andmiseks",
        "lv_account_authorization_form_text": "Dokument, mis väljendab soovi anda Solderale volitus päritolutunnistuste haldamiseks. See dokument võimaldab Solderal juurdepääsu Sinu päritolutunnistustele AST infosüsteemis.",
        "lv_soldera_membership_agreement_title": "Soldera platvormileping",
        "lv_soldera_membership_agreement_text": "Leping teie ja Soldera vahel, mis sätestab koostöö tingimused. Nõutav juhul, kui varasemalt pole lepingut sõlmitud. Sisaldab viiteid Soldera privaatsuspoliitikale, kauplemise korrale ja põhitingimustele, mis on kättesaadavad Soldera veebilehel.",
        "lv_new_device_application_text": "Tootmisseadme registreerimisvorm, mille esitatud teabe on kontrollinud sõltumatu akrediteeritud tootmisaudiitor",
        "lv_new_device_application_title": "Tootmisseadme registreerimisvorm",
        "lv_ast_terms_and_service_title": "AST kasutustingimused ja teenused",
        "lv_ast_terms_and_service_text": "AST informatsiooni süsteemi kasutustingimused ja reeglid.",
        "lv_soldera_account_holder_registration_form_title": "Grexeli kontohalduri registreerimisvorm",
        "lv_soldera_account_holder_registration_form_text": "Dokument, mis väljendab soovi registreeruda Grexeli kontohalduriks. See dokument võimaldab Solderal juurdepääsu teie päritolutunnistustele AST infosüsteemis."
      },
      "lt": {
        "lt_request_for_go_contract_title": "Avaldus päritolutunnistuste teenuslepingu sõlmimiseks",
        "lt_request_for_go_contract_description": "Dokument, mis väljendab soovi sõlmida Litgridiga leping päritolutunnistuste konto avamiseks.",
        "lt_soldera_membership_agreement_title": "Soldera platvormileping",
        "lt_soldera_membership_agreement_text": "Teie ja Soldera vaheline leping, mis sätestab koostöö tingimused. Vajalik, kui varasem leping puudub. Sisaldab viiteid Soldera privaatsuspoliitikale, kauplemisreeglitele ja põhitingimustele, mis on saadaval Soldera veebisaidil.",
        "lt_authotization_application_title": "Päritolutunnistuste konto volituse taotlus",
        "lt_authorization_application_text": "Dokument, mis väljendab soovi volitada Solderat haldama päritolutunnistusi Litgridi infosüsteemis.",
        "lt_litgrid_terms_service_title": "Litgridi teenusetingimused",
        "lt_litgrid_terms_service_description": "Litgridi infosüsteemi kasutustingimused.",
        "lt_device_registration_title": "Litgridi seadme registreerimise vorm",
        "lt_device_registration_description": "Dokument, mida Litgrid nõuab uue seadme registreerimiseks."
      },
      "se": {
        "se_account_authorization_form_title": "Energimyndigheten'i volituse vorm",
        "se_account_authorization_form_text": "See vorm volitab Solderat registreerima teie konto Energimyndigheten'is (Rootsi Energiaamet) ja haldama teie päritolutunnistusi.",
        "se_access_cesar_freja_eid_authorization_application_title": "Energimyndigheten'i Cesar konto ligipääsu vorm",
        "se_access_cesar_freja_eid_authorization_application_text": "See vorm volitab Solderat saama ligi teie kontole Energimyndigheten'is (Rootsi Energiaamet) ja haldama teie päritolutunnistusi.",
        "se_soldera_membership_agreement_title": "Soldera platvormileping",
        "se_soldera_membership_agreement_text": "See leping sõlmib teie liikmelisuse Solderaga ning sätestab meie platvormi ja teenuste kasutamise tingimused.",
        "se_application_for_go_title": "Päritolutunnistuste taotlus",
        "se_application_for_go_text": "Taotlusvorm tootmisseadme registreerimiseks päritolutunnistuste saamiseks Rootsi Energiaametis.",
        "se_appendix_production_units_title": "Tootmisüksuste lisa",
        "se_appendix_production_units_text": "Üksikasjalik teave teie tootmisüksuste kohta, mis registreeritakse päritolutunnistuste saamiseks.",
        "se_application_for_eecs_go_title": "EECS päritolutunnistuste taotlus",
        "se_application_for_eecs_go_text": "Taotlus Euroopa energiasertifikaatide süsteemi (EECS) päritolutunnistuste registreerimiseks.",
        "se_application_for_special_account_title": "Erikonto taotlus",
        "se_application_for_special_account_text": "Taotlus erikonto avamiseks Rootsi Energiaameti päritolutunnistuste haldamise süsteemis.",
        "se_application_for_cesar_access_title": "Cesar süsteemi juurdepääsu taotlus",
        "se_application_for_cesar_access_text": "Taotlus juurdepääsuks Cesar süsteemile, mida kasutatakse päritolutunnistuste haldamiseks Rootsis."
      },
      "fi": {
        "fi_soldera_membership_agreement_title": "Soldera platvormileping",
        "fi_soldera_membership_agreement_text": "See leping sõlmib teie liikmelisuse Solderaga ning sätestab meie platvormi ja teenuste kasutamise tingimused.",
        "fi_authorization_application_title": "Päritolutunnistuste konto volituse taotlus",
        "fi_authorization_application_text": "See dokument volitab Solderal haldama teie päritolutunnistusi.",
        "fi_transfer_application_title": "Päritolutunnistuste konto üleandmise taotlus",
        "fi_transfer_application_text": "See dokument üleandab teie tootmisüksuste Solderale, et haldada teie päritolutunnistusi ja säästa registri konto tasu."
      },
      "generic": {
        "soldera_membership_agreement_title": "Soldera platvormileping",
        "soldera_membership_agreement_text": "See leping sõlmib teie liikmelisuse Solderaga ning sätestab meie platvormi ja teenuste kasutamise tingimused.",
        "authorization_application_title": "Päritolutunnistuste konto volituse taotlus",
        "authorization_application_text": "See dokument volitab Solderal haldama teie päritolutunnistusi."
      },
      "es": {
        "es_soldera_membership_agreement_title": "Soldera Platvormileping",
        "es_soldera_membership_agreement_text": "See leping sätestab teie liikmelisuse Solderaga ning kirjeldab meie platvormi ja teenuste kasutamise tingimusi.",
        "es_account_authorization_form_title": "Volituse taotlus",
        "es_account_authorization_form_text": "See dokument volitab Solderat haldama teie päritolutunnistusi."
      },
      "pl": {
        "pl_authorization_application_title": "Volituse taotlus",
        "pl_authorization_application_text": "See dokument volitab Solderat haldama teie päritolutunnistusi Poolas.",
        "pl_soldera_membership_agreement_title": "Soldera platvormileping",
        "pl_soldera_membership_agreement_text": "See leping kehtestab teie liikmesuse Solderaga ja kirjeldab meie platvormi ja teenuste kasutamise tingimusi Poolas."
      }
    },
    "navsteps": {
      "next": "Edasi",
      "back": "Tagasi",
      "to_signature_page": "Allkirjastama",
      "se": {
        "step1": "Algus",
        "authorization": {
          "contact_review": "Kontaktandmed",
          "contract_review": "Lepingu ülevaade"
        },
        "new_device": {
          "contact_review": "Kontaktandmed",
          "generator_review": "Generaatori andmed",
          "contract_review": "Lepingu ülevaade",
          "grid_review": "Võrguettevõtja andmed"
        },
        "contract_review": "Lepingu ülevaade"
      },
      "ee": {
        "authorization": {
          "1": "Algus",
          "2": "Kontaktandmed",
          "3": "Lepingu ülevaade"
        },
        "new_device": {
          "1": "Võrguleping",
          "2": "Tootmisseade",
          "3": "Kontaktandmed",
          "4": "Lepingu ülevaade"
        }
      },
      "lv": {
        "new_device": {
          "1": "Algus",
          "2": "Konto andmed",
          "3": "Seadme dokumendid",
          "4": "Seadme andmed",
          "5": "Ettevõtte info",
          "6": "Allkirjastamine"
        },
        "authorization": {
          "1": "Algus",
          "2": "Konto andmed",
          "3": "Allkirjastamine"
        },
        "step1": "Tere tulemast",
        "step2": "Kontaktandmed"
      },
      "lt": {
        "choose_onboarding": "Liitumisviis",
        "contact_review": "Konto andmed",
        "multiple_upload": "@:common.documents",
        "generator_license": "Litsentsi number",
        "contract_review": "Allkirjastamine"
      },
      "fi": {
        "flow_selection": "Liitumisviis",
        "contact_details": "Kontaktandmed",
        "contract_review": "Lepingu ülevaade"
      },
      "default": {
        "contact_review": "Kontaktandmed",
        "contract_review": "Lepingu ülevaade"
      },
      "es": {
        "step1": "Tere tulemast",
        "step2": "Kontaktandmed",
        "step3": "Lepingu ülevaade",
        "authorization": {
          "1": "Algus",
          "2": "Konto andmed",
          "3": "Allkirjastamine"
        }
      },
      "pl": {
        "step1": "Tere tulemast",
        "step2": "Kontaktandmed",
        "step3": "Lepingu ülevaade",
        "authorization": {
          "1": "Alusta",
          "2": "Konto andmed",
          "3": "Allkirjastamine"
        }
      }
    },
    "lv": {
      "authorization": {
        "title": "Kas te olete varem juba päritolutunnistusi tootnud?",
        "description": "Soldera on automatiseeritud päritolutunnistuste müügiagent. Selleks, et Solderaga hakata maksimeerima enda päritolutunnistuste tulu tee allolev valik",
        "add_authorization": "Olen varem tootnud päritolutunnistusi",
        "create_new_account": "Ava uus Päritolugarantiide konto AST-s",
        "create_new_account_description": "Vali see valik, kui sa ei saa Päritolugarantiisid ja soovid registreerida uue seadme AST infosüsteemis.",
        "add_authorization_description": "Vali see valik, kui sa juba saad Päritolugarantiisid ja soovid volitada Solderat neid haldama. Saame sind hiljem aidata registreerida AST-s rohkem seadmeid.",
        "not_sure": "Pole kindel?",
        "contact_support": "Võta ühendust meie klienditoega",
        "existing_account_title": "Registreeri uus seade olemasolevale omanikule",
        "alternative_instructions": "Kui soovid avada uue konto seadme omanikule, keda sa pole veel Solderas registreerinud, järgi allolevaid juhiseid."
      },
      "do_you_have_subsidy": "Kas te olete saanud või saate riigiabi?",
      "generator_review": {
        "device_address": {
          "title": "Tootmisseadme aadress"
        },
        "device_eic": {
          "title": "Mõõtepunkti ID (EIC kood)"
        },
        "device_grid_operator": {
          "options": {
            "grid_operator_dso": "JVO võrk",
            "grid_operator_tso": "PVO võrk"
          },
          "title": "Võrguühendus"
        },
        "device_name": {
          "title": "Tootmisseadme nimi"
        },
        "device_power": {
          "title": "Paigaldatud võimsus (kW)"
        },
        "device_power_in_permit": {
          "title": "Süsteemioperaatori loas määratud võimsus (kW)"
        },
        "device_technology": {
          "options": {
            "device_technology_hydro": "Hüdro",
            "device_technology_solar": "Päikese",
            "device_technology_wind": "Tuule"
          },
          "title": "Tehnoloogia"
        },
        "grid_contract_start_date": {
          "title": "Esimene käikulaskmise kuupäev"
        },
        "lat": {
          "title": "@:ecolabels.table.latitude"
        },
        "lng": {
          "title": "@:ecolabels.table.longitude"
        },
        "only_device_output": {
          "title": "Arvesti vastab elektrienergia netoväljundile"
        }
      }
    },
    "lt": {
      "authorization": {
        "title": "Kas teil on juba päritolutunnistusi?",
        "description": "Et pakkuda teile parimat kogemust, peame teadma, kas te juba saate päritolutunnistusi. See aitab meil määrata teile sobivaimad järgmised sammud.",
        "add_authorization": "Jah, mul on päritolutunnistused.",
        "add_authorization_description": "Valige see võimalus, kui te juba saate päritolutunnistusi ja soovite volitada Solderat neid haldama. Saame teid hiljem aidata Litgridis rohkem seadmeid registreerida.",
        "create_new_account": "Ei, mul ei ole päritolutunnistusi.",
        "create_new_account_description": "Valige see võimalus, kui te ei saa päritolutunnistusi ja soovite registreerida uue seadme Litgridi infosüsteemis.",
        "not_sure": "Pole kindel?",
        "contact_support": "Abi saamiseks võtke ühendust meie klienditoega",
        "existing_account_title": "Registreeri uus seade olemasolevale omanikule",
        "alternative_instructions": "Kui soovid avada uut kontot seadme omanikule, keda Sa ei ole veel Solderas registreerinud, järgi allolevaid juhiseid."
      },
      "extra_info": {
        "title": "Täiendav informatsioon ettevõtte kohta",
        "description": "Palun esitage järgmine Litgridi nõutav teave."
      }
    },
    "se": {
      "authorization": {
        "title": "Kas te olete varem juba päritolutunnistusi tootnud?",
        "description": "Soldera on automatiseeritud päritolutunnistuste müügiagent. Selleks, et Solderaga hakata maksimeerima enda päritolutunnistuste tulu, tee allolev valik",
        "add_authorization": "Ma saan EECS päritolutunnistusi",
        "create_new_account": "Ava uus päritolutunnistuste konto Rootsi Energiaametis",
        "create_new_account_description": "Vali see valik, kui sa ei saa päritolutunnistusi ja soovid registreerida uue seadme Rootsi Energiaameti infosüsteemis.",
        "add_authorization_description": "Vali see valik, kui sa saad EECS päritolutunnistusi ja soovid volitada Solderat neid haldama. Saame sind hiljem aidata registreerida Rootsi Energiaametis rohkem seadmeid.",
        "not_sure": "Pole kindel?",
        "contact_support": "Võta ühendust meie klienditoega",
        "existing_account_title": "Registreeri uus seade olemasolevale omanikule",
        "alternative_instructions": "Kui soovid avada uue konto seadme omanikule, keda sa pole veel Solderas registreerinud, järgi allolevaid juhiseid.",
        "add_eecs_conversion": "Ma saan riiklikke päritolutunnistusi",
        "add_eecs_conversion_description": "Vali see valik, kui sa saad riiklikke päritolutunnistusi ja soovid hakata saama EECS päritolutunnistusi (Euroopa ülekantavad päritolutunnistused) riiklike asemel."
      },
      "generator_review": {
        "production_unit": "Tootmisüksuse andmed",
        "cesar_application": "Cesari taotlus",
        "go_application": "Päritolutunnistuste taotlus",
        "investment_support_question": "Kas see tootmisüksus on saanud investeeringutoetust?",
        "investment_support_options": {
          "yes": "Jah",
          "no": "Ei",
          "do_not_know": "Ei tea"
        },
        "basic_information": "Põhiandmed",
        "metering_information": "Mõõtmise andmed",
        "investment_support": "Investeeringutoetus",
        "grid_area_id": {
          "title": "Võrgupiirkonna ID",
          "description": "Sisesta võrgupiirkonna ID (kolm tähte või 'IKN')"
        },
        "grid_production_device_id": {
          "title": "Tootmisseadme ID",
          "description": "Sisesta unikaalne 18-kohaline tootmisseadme ID"
        },
        "grid_eidel_id": {
          "title": "Ediel ID",
          "description": "Sisesta Svenska Kraftnät'iga suhtlemiseks määratud ID number"
        },
        "device_name": {
          "title": "Seadme nimi"
        },
        "device_power": {
          "title": "Seadme võimsus (kW)",
          "description": "Sisesta paigaldatud võimsus kilovattides"
        },
        "device_power_in_permit": {
          "title": "Seadme võimsus loas (MW)"
        },
        "device_eic": {
          "title": "Seadme EIC kood"
        },
        "device_address": {
          "title": "Seadme aadress"
        },
        "lat": {
          "title": "@:ecolabels.table.latitude"
        },
        "lng": {
          "title": "@:ecolabels.table.longitude"
        },
        "only_device_output": {
          "title": "Ainult seadme väljund"
        },
        "device_grid_operator": {
          "title": "Võrguoperaator",
          "grid_operator_tso": "TSO",
          "grid_operator_dso": "DSO"
        },
        "grid_contract_start_date": {
          "title": "Võrgulepingu alguskuupäev"
        },
        "property_designation": {
          "title": "Kinnistu tähis",
          "description": "Sisesta kinnistu tähis"
        },
        "technology": {
          "title": "Tehnoloogia",
          "description": "Vali tootmistehnoloogia",
          "options": {
            "BTN_Land based": "Maismaa tuuleenergia",
            "BTN_Ocean based": "Avamere tuuleenergia",
            "BTN_Sun": "Päikeseenergia",
            "BTN_Water": "Hüdroenergia",
            "BTN_Thermal": "Soojusenergia"
          }
        },
        "thermal_subtype": {
          "title": "Soojusenergia tehnoloogia tüüp",
          "description": "Vali konkreetne soojusenergia tehnoloogia tüüp",
          "options": {
            "BTN_Industrial back pressure": "Tööstuslik vasturõhk",
            "BTN_Condensing power": "Kondensatsioonielekter",
            "BTN_Gas engine": "Gaasimootor"
          }
        },
        "thermal_is_chp": {
          "title": "Kas see on CHP üksus?",
          "description": "Märgi, kui tegemist on koostootmisüksusega (CHP)"
        },
        "investment_support_amount": {
          "title": "Investeeringutoetuse summa",
          "description": "Sisestage saadud investeeringutoetuse summa"
        },
        "investment_support_date": {
          "title": "Investeeringutoetuse kuupäev",
          "description": "Sisestage investeeringutoetuse saamise kuupäev"
        },
        "grid_metered_by_hour": {
          "title": "Võrk mõõdetud tunni kaupa",
          "description": "Valige, kas võrk on mõõdetud tunni kaupa"
        },
        "grid_concession": {
          "title": "Võrgukontrollõigus",
          "description": "Valige, kas võrgukontrollõigus on olemas"
        },
        "holding_percentage": {
          "title": "Omandi protsent",
          "description": "Sisesta oma omandi protsent"
        },
        "metering_location": {
          "title": "Mõõtmise asukoht",
          "description": "Vali, kus toimub toodangu mõõtmine",
          "options": {
            "Directly_after_generator": "Otse pärast generaatorit",
            "After_auxiliary_equipment": "Pärast abiseadmeid",
            "After_net_pumping_equipment": "Pärast pumpamisseadmeid",
            "Directly_before_grid_connection": "Otse enne võrguühendust"
          }
        },
        "commissioning_date": {
          "title": "Kasutuselevõtu kuupäev",
          "description": "Sisesta kasutuselevõtu kuupäev"
        },
        "correction_factor_info": {
          "title": "Paranduskoefitsient",
          "description": "Deklareeritakse standardne paranduskoefitsient. Kui paigaldatud võimsus on üle 10 MW, võtke kohandatud paranduskoefitsiendi deklareerimiseks ühendust klienditoega"
        },
        "postal_address": {
          "title": "Postiaadress",
          "description": "Sisesta täielik tänavaadress"
        },
        "postal_code": {
          "title": "Postiindeks",
          "description": "Sisesta postiindeks"
        },
        "city": {
          "title": "Linn",
          "description": "Sisesta linna nimi"
        },
        "company_address": "Ettevõtte aadress",
        "invoice_address": "Arve aadress",
        "same_as_company_address": "Arve aadress on sama mis ettevõtte aadress",
        "grid_owner_name": {
          "title": "Võrguettevõtja nimi",
          "description": "Sisesta võrguettevõtja nimi"
        },
        "grid_owner_corporate_id": {
          "title": "Võrguettevõtja registrikood",
          "description": "Sisesta võrguettevõtja registrikood"
        },
        "invoice_co_address": {
          "title": "Arve C/O aadress",
          "description": "Sisesta arve C/O aadress (kui on)"
        },
        "invoice_contact_telephone": {
          "title": "Arve kontaktisiku telefoninumber",
          "description": "Sisesta arve kontaktisiku telefoninumber"
        },
        "invoice_email": {
          "title": "Arve e-post",
          "description": "Sisesta e-posti aadress kuhu arve saadetakse"
        },
        "specific_name": {
          "title": "Arve kontaktisiku nimi",
          "description": "Sisesta arve kontaktisiku nimi"
        },
        "reference_number": {
          "title": "Arve viitenumber",
          "description": "Sisesta arve viitenumber"
        },
        "invoice_country": {
          "title": "Arve riik",
          "description": "Sisesta arve aadressi riik"
        }
      }
    },
    "fi": {
      "flow_selection": {
        "title": "Uue ettevõtte lisamine",
        "choose_onboarding": "Vali onboarding",
        "description": "Kui teil on registris juba tootmisseadmeid, siis kanname need enda registrikontole ja haldame neid teie eest. Kui teil ei ole ühtegi registreeritud seadet, võtke meiega ühendust, et arutada oma võimalusi.",
        "not_sure": "Vajad abi?",
        "contact_support": "Võta ühendust meie klienditoega",
        "transfer": {
          "title": "Kannan tootmisseadmed üle Soldera kontole",
          "description": "Kanname teie tootmisseadmed meie registrikontole ja haldame neid teie eest."
        },
        "authorization": {
          "title": "Anna Solderale juurdepääs oma registrikontole",
          "description": "Meil on juurdepääs teie registrikontole ja haldame teie eest sertifikaate. Sertifikaadid jäävad teie kontole."
        }
      },
      "quickfill": {
        "search": "Otsi ettevõtet, mis on juba Fingridis registreeritud",
        "search_placeholder": "Otsi ettevõtet",
        "error": "Ettevõtete laadimine ebaõnnestus",
        "quickfill_helper": "Leia ettevõte, mis on juba registreeritud Fingridis",
        "manual_entry": "Sisesta andmed käsitsi"
      }
    },
    "fallback": {
      "flow_selection": {
        "title": "Uue ettevõtte lisamine",
        "intro": "Soldera on nr. 1 platvorm päritolutunnistuste haldamiseks. Optimeerige kasumlikkust, vähendades samal ajal halduskoormust. Teenindame tööstuse liidreid ja tuhandeid taastuvenergia tootmispunkte üle Euroopa.",
        "description": "Valige autoriseerimise valik, kui teil on juba tootmisseadmed registris. Kui teil ei ole ühtegi registreeritud seadet, võtke meiega ühendust, et arutada oma võimalusi.",
        "not_sure": "Vajad abi?",
        "contact_support": "Võta ühendust meie klienditoega",
        "authorization": {
          "title": "Volitage Soldera oma tootmisseadmete haldamiseks",
          "description": "Me haldame teie tootmisseadmeid teie eest."
        }
      }
    },
    "es": {
      "authorization": {
        "title": "Kas teil on juba päritolutunnistusi?",
        "description": "Teie kogemuse kohandamiseks peame teadma, kas saate juba päritolutunnistusi. See aitab meil määrata teile parimad järgmised sammud.",
        "add_authorization": "Jah, mul on päritolutunnistused.",
        "add_authorization_description": "Valige see suvand, kui saate juba päritolutunnistusi ja soovite volitada Solderat neid haldama.",
        "create_new_account": "Ei, mul ei ole päritolutunnistusi.",
        "create_new_account_description": "Valige see suvand, kui te ei saa päritolutunnistusi ja soovite registreerida uue seadme registri infosüsteemis.",
        "not_sure": "Pole kindel?",
        "contact_support": "Abi saamiseks võtke ühendust meie klienditoega",
        "existing_account_title": "Registreeri uus seade olemasolevale omanikule",
        "alternative_instructions": "Kui soovite avada uue konto seadme omanikule, keda te pole veel Solderas registreerinud, järgige allolevaid juhiseid."
      },
      "extra_info": {
        "title": "Lisateave ettevõtte kohta",
        "description": "Palun esitage järgmine registri nõutav teave."
      }
    },
    "pl": {
      "authorization": {
        "title": "Kas teil on juba päritolutunnistused?",
        "description": "Teie kogemuse kohandamiseks ja parima teenuse tagamiseks andke palun teada oma praegune seis päritolutunnistustega.",
        "add_authorization": "Jah, mul on päritolutunnistused.",
        "add_authorization_description": "Teil on olemasolevad päritolutunnistused ja soovite lisada Solderale volituse neid hallata.",
        "not_sure": "Ma ei ole oma staatuses kindel.",
        "contact_support": "Võta ühendust tugiteenusega"
      }
    }
  },
  "bulk_buy": {
    "upload_description": "Laadi üles dokumendid, et eraldada ettevõtte andmed ja tühistamise nõuded mitme üksuse jaoks",
    "upload_description_new": "Laadi üles oma jätkusuutlikkuse aruanne ja tarbimisandmed. AI täidab kõik väljad Sinu eest.",
    "quick_info": "Kiirinfo",
    "upload_hint": "Laadi üles üks või mitu dokumenti, et automaatselt eraldada ettevõtte andmed",
    "manual_add_hint": "Või lisa ettevõtted käsitsi, täites alumise tühja rea",
    "purchase_settings": "Ostu seaded",
    "overview": "Ülevaade",
    "purchase_mode": {
      "CHEAPEST": "Odavaim",
      "GHG": "GHG",
      "RE100": "RE100",
      "ADVANCED": "Premium valikud",
      "OTHER": "Muu"
    },
    "ghg_description": "SBTi, ERI, CDB",
    "re100_description": "Tuul + päike, seadme vanus ≤ 15 aastat",
    "cheapest_description": "Kõige säästlikumad valikud",
    "premium_description": "Eritellimusel hankimise nõuded",
    "go_source": "EAC päritolu",
    "technology": "Tehnoloogia",
    "ecolabel": "Ökomärgis",
    "vintage": "Aasta",
    "support": "Toetusmeetme staatus",
    "cod_requirement": "COD nõue",
    "matching_mode": {
      "yearly": "Aastapõhine sobitamine",
      "monthly": "Kuupõhine sobitamine",
      "hourly": "24/7 tunnine sobitamine (Premium)"
    },
    "destination_companies": "Kasusaajad",
    "destination_companies_description": "Iga rida esindab ettevõtet, kes saab PT tühistamise enda nimel.",
    "companies": "@:common.companies",
    "no_companies": "Kasusaajaid pole veel lisatud. Alustamiseks laadi üles dokumendid või lisa ettevõtted käsitsi.",
    "company_name": "Kasusaaja",
    "country": "Kasusaaja riik",
    "registry_code": "Ettevõtte ID",
    "volume": "Tarbimine (MWh)",
    "match_origin": "Vasta päritolule",
    "price": "Indikatiivne hind",
    "tooltip_company_name": "Juriidiline isik, kes nimetatakse tühistamisavalduse kasusaajaks — osapool, kes nõuab taastuvenergia tarbimist.",
    "tooltip_country": "Riik, kus kasusaaja asub ja tarbib elektrit. See määrab, kus sertifikaadid tuleb tühistada.",
    "tooltip_registry_code": "Ettevõtte registrikood — mitte käibemaksukohustuslase number. Ilmub tühistamisavaldusele.",
    "tooltip_address": "Kasusaaja registreeritud aadress või rajatise aadress. Kasutatakse tühistamisavalduses tuvastamiseks.",
    "tooltip_volume": "Aastane elektritarbimine, mida katta taastuvenergia sertifikaatidega, megavatt-tundides (MWh). 1 MWh = 1 sertifikaat.",
    "tooltip_price": "Indikatiivne hind praeguste turuhindade ja valitud hankeparameetrite alusel — indikatiivne, mitte siduv pakkumine. Arvutamiseks vajuta 'Küsi hinnapakkumist'.",
    "eac_type": "EAC tüüp",
    "tooltip_eac_type": "Kasusaaja riigis kasutatav sertifikaadiskeem. Määratakse riigi põhjal automaatselt; meie registritest väljaspool olevate riikide puhul vali ise.",
    "pricing_idle": "Arvutamata",
    "rfq_notice": "Soldera korraldab hinnapäringu (RFQ)",
    "global_cancellation_settings": "Üldised tühistamise seaded",
    "period_start": "Perioodi algus",
    "period_end": "Perioodi lõpp",
    "beneficiary_type": "Soodustatud isiku tüüp",
    "beneficiary_types": {
      "ELECTRICITY_SELLER": "Elektrimüüja",
      "CONSUMER": "Tarbija",
      "CONVERSION_PLANT_OPERATOR": "Muundamisjaama operaator"
    },
    "summary": "Kokkuvõte",
    "total_volume": "Kogumaht",
    "total_price": "Indikatiivne koguhind",
    "illiquid_companies": "ühtegi ettevõtet ei hinnastata RFQ kaudu | 1 ettevõte hinnastatakse RFQ kaudu | {count} ettevõtet hinnastatakse RFQ kaudu",
    "confirm_order": "Kinnita tellimus",
    "ask_for_quotes": "Küsi hinnapakkumisi",
    "cancellation_details_title": "Tühistamise üksikasjad",
    "beneficiary_name": "Soodustatud isiku nimi",
    "residency": "Residentsus",
    "company_address": "Ettevõtte aadress",
    "address": "@:common.address",
    "cancellation_purpose": "Tühistamise eesmärk",
    "cancellation_purpose_text": "Tühistamise eesmärk",
    "operation_notes_placeholder_consumer": "Tarbimise tõend",
    "operation_notes_placeholder_seller": "Elektrivarustus",
    "cancellation_purposes": {
      "DISCLOSURE": "Avalikustamine",
      "GRID_LOSSES": "Võrgukaod",
      "SELF_CONSUMPTION": "Omatarve",
      "SUPPORT_SCHEME": "Toetusskeem",
      "OTHER": "Muu"
    },
    "operation_notes": "Operatsiooni märkused",
    "confirm_title": "Kinnita ostu ja tühistamise tellimus",
    "order_summary": "Tellimuse kokkuvõte",
    "illiquid_warning": "ühtegi ettevõtet ei hinnastata hinnapäringu (RFQ) kaudu | 1 ettevõte hinnastatakse hinnapäringu (RFQ) kaudu | {count} ettevõtet hinnastatakse hinnapäringu (RFQ) kaudu",
    "total_known_price": "Teadaolev koguhind",
    "cancellation_not_supported_title": "Tühistamine ei ole otseselt toetatud",
    "cancellation_not_supported_description": "Järgmised ettevõtted asuvad registrites, kus me ei saa tühistamist otse teha. Valige kuidas soovite edasi minna:",
    "cancellation_option_agent": "Soldera korraldab tühistamise kohalikus registris täieliku vastavuse tagamiseks",
    "cancellation_option_any_registry": "Tühista mis tahes AIB registris (standardne tühistamishind)",
    "companies_with_pricing": "Teadaoleva hinnaga ettevõtted ({count})",
    "confirm_and_submit": "Kinnita ja esita tellimused",
    "quoted_pricing": "Pakkumishind",
    "base_price": "Baashind",
    "price_per_mwh": "Hind MWh kohta",
    "no_pricing_info": "Selle tellimuse kohta pole hinnainfot saadaval",
    "cancellation_fee": "Tühistamistasu",
    "minimum_cancellation_fee": "Minimaalne tühistamistasu",
    "brokerage_fee": "Hanketasu",
    "incl_brokerage": "sisaldab €{amount}/MWh hanketasu",
    "incl_cancellation": "sisaldab €{amount}/MWh tühistamistasu",
    "incl_min_cancellation": "sisaldab €{amount} min. tühistamistasu",
    "eac_source": "EAC päritolu",
    "matching": "Sobitamine",
    "cancellation_settings": "Tühistamise seaded",
    "purchase_settings_title": "Ostu seaded",
    "purchase_mode_label": "Ostu režiim",
    "pricing_error": "Hinna arvutamine ebaõnnestus. Palun proovige uuesti või võtke ühendust klienditoega.",
    "volume_required": "Maht peab olema vähemalt 1 MWh",
    "country_required": "Hinna arvutamiseks on vajalik riik",
    "intro": "Ostke taastuvenergia sertifikaate ja tühistage need oma kasusaajate nimel — ühe sammuna. Valige, kuidas sertifikaate hangitakse, lisage iga kasusaaja allpool ja kinnitage.",
    "accelerator_title": "Alusta dokumendist",
    "sourcing_preference_description": "Kuidas hangime sertifikaadid iga kasusaaja jaoks.",
    "sourcing_cheapest_title": "Odavaim",
    "sourcing_cheapest_desc": "Kõige kuluefektiivsemad saadaolevad valikud",
    "sourcing_ghg_title": "GHG",
    "sourcing_ghg_desc": "Vastab SBTi, ERI ja CDP aruandluskriteeriumidele",
    "sourcing_re100_title": "RE100",
    "sourcing_re100_desc": "Tuul + päike, COD ≤ 15 aastat",
    "sourcing_other_title": "Muu",
    "sourcing_other_desc": "Kirjeldage oma hankenõuet",
    "custom_requirement_label": "Kohandatud hankenõue",
    "custom_requirement_placeholder": "Kirjeldage, mida vajate — konkreetne tehnoloogia, riik, aastakäik, ökomärgised või mõni muu hankenõue. Meie tiim võtab teiega ühendust kohandatud pakkumisega.",
    "custom_requirement_advisory": "Kohandatud nõuded hinnastatakse hinnapäringu (RFQ) kaudu — meie hanketiim vastab indikatiivse pakkumisega, tavaliselt ühe tööpäeva jooksul.",
    "shared_cancellation_settings": "Ühised tühistamise seaded",
    "add_beneficiary": "Lisa kasusaaja",
    "add_another_beneficiary": "Lisa veel üks kasusaaja",
    "no_beneficiaries_title": "Kasusaajaid pole veel lisatud",
    "no_beneficiaries_description": "Laadige üles dokument, et need automaatselt täita, või lisage esimene kasusaaja käsitsi.",
    "total_consumption": "Kogutarbimine",
    "estimated_cost": "Indikatiivne maksumus",
    "add_at_least_one_beneficiary": "Lisage vähemalt üks kasusaaja",
    "ask_for_quote": "Küsi pakkumist",
    "fetching_quotes": "Pakkumiste laadimine…",
    "review": "Vaata üle",
    "request_custom_quote": "Küsi kohandatud pakkumist",
    "custom_quote_reassurance": "Soldera korraldab hinnapäringu (RFQ) ja vastab indikatiivse pakkumisega enne, kui midagi ostetakse.",
    "manual_quote": "Hinnastatakse RFQ kaudu",
    "by_quote": "RFQ alusel",
    "priced_subline": "{known}/{total} MWh hinnastatud · {perMwh}/MWh",
    "rfq_reassurance": "Hinnastatud read esitatakse täitmisele pakutud hinnaga. Ülejäänud koguste jaoks korraldab Soldera hinnapäringu (RFQ) meie tarnijate võrgustikus ja vastab indikatiivse pakkumisega — tavaliselt ühe tööpäeva jooksul. RFQ ridade eest ei osteta midagi enne, kui pakkumise kinnitate.",
    "review_order_title": "Vaata ostu- ja tühistamistellimus üle",
    "average_unit_price": "Keskmine ühikuhind",
    "indicative_bid_note": "Kõik kuvatud hinnad on indikatiivsed ja põhinevad praegusel turutasemel — tegemist ei ole siduva pakkumisega. Lõplik hind kinnitatakse tellimuse täitmisel.",
    "quotes_indicative_note": "Kõik pakkumised on indikatiivsed — lõplik hind kinnitatakse tehingu täitmisel.",
    "market_levels_as_of": "Turuhinnad seisuga {date}",
    "quote_reference": "Viide {id}",
    "quote_reference_label": "Pakkumise viide",
    "consumption_period": "Tarbimisperiood",
    "cancellation_mode_selection_aria": "Tühistamisviisi valik",
    "remove_beneficiary_row_aria": "Eemalda kasusaaja rida {index}"
  },
  "dashboard": {
    "issuance_chart": {
      "title": "Väljastamise graafik",
      "description": "Viimase 12 kuu jooksul väljastatud MWh tootmisseadme kohta.",
      "y_axis": "Väljastatud MWh",
      "y_axis_log": "Väljastatud MWh (logaritmiline)",
      "scale_absolute": "Absoluutne",
      "scale_log": "Logaritmiline",
      "zero_marker_note": "Logaritmiline skaala ei saa näidata nulli: väljastamiseta kuud on põhijoonel tähistatud märgiga ✕.",
      "no_data": "Viimase 12 kuu kohta väljastamise andmed puuduvad",
      "load_failed": "Väljastamise graafikut ei õnnestunud laadida. Palun proovi uuesti."
    },
    "devices_in_registry": "Registris hallatavad seadmed",
    "no_devices_in_registry": "Registris pole seadmeid",
    "add_device_description": "Lisa oma esimene seade, et alustada sertifikaatide haldamist",
    "add_first_device": "Lisa esimene seade",
    "add_registry_device": "Lisa registriseade",
    "add_registry_device_description": "Lisa uus seade käsitsi oma registrisse sertifikaatide haldamiseks",
    "select_company": "Vali ettevõte",
    "action_required": "Toiming nõutav",
    "consolidated_view": "Konsolideeritud ülevaade",
    "consolidated_view_description": "Vaata kõiki ettevõtteid koos",
    "company_id_label": "ID: {id}",
    "market": {
      "base_price": "Baashind"
    },
    "consolidated": {
      "overview_for": "Ülevaade konto {email} kohta",
      "devices_overview": "{count} seadet kokku {power} kW",
      "back_to_dashboard": "Tagasi töölauale",
      "pending_payouts": "Raha ootel",
      "paid_out_30d": "Väljamaksed (30p)",
      "projected_production": "Tootmise prognoos",
      "projected_production_description": "Tootmismahu prognoos seadmete võimsuse põhjal",
      "projected_production_by_company": "Tootmise prognoos ettevõtte kaupa",
      "projected_production_by_company_description": "Järjestatud prognoositud toodangu järgi",
      "production_volume": "Tootmismaht",
      "production_volume_description": "Summad on näidatud MWh ühikutes",
      "production_volume_table": {
        "month": "Kuu",
        "quarter": "Kvartal",
        "monthly": "Kuus",
        "quarterly": "Kvartalis",
        "total": "Kokku",
        "current": "Praegune"
      },
      "production_distribution": "Tootmisallikate ennustatud jaotus",
      "production_distribution_description": "Viimased 12 kuud",
      "production_devices": "Tootmisseadmed",
      "production_devices_description": "{deviceCount} seadet {companyCount} ettevõttes",
      "production_devices_table": {
        "company_name": "Ettevõte",
        "total": "Kokku",
        "technology": "Tehnoloogia",
        "device_count": "Seadmeid",
        "device_id": "ID",
        "device_name": "Nimi",
        "capacity": "Võimsus",
        "status": "Staatus",
        "no_devices": "Seadmeid pole kuvamiseks",
        "view_projection": "Vaata prognoosi",
        "view_breakdown": "Vaata koondülevaadet",
        "scheduled_transactions_tooltip": "registris seadistatud automaatsed ülekanded"
      },
      "company_filter_hint": "Vali ettevõtted, kelle andmeid koondvaates uurida",
      "selector_no_companies": "Ettevõtteid pole",
      "selector_all_companies": "Kõik ettevõtted",
      "selector_countries_companies": "{countries} riiki · {companies} ettevõtet",
      "selector_company_count": "Ettevõtteid pole | 1 ettevõte | {count} ettevõtet",
      "selector_selected_count": "{selected}/{total} valitud",
      "selector_only": "ainult",
      "selector_show_only": "Näita ainult {country}",
      "selector_remove_country": "Eemalda {country}",
      "no_companies_selected_title": "Ühtegi ettevõtet pole valitud",
      "no_companies_selected_hint": "Vali ülal vähemalt üks ettevõte või riik, et näha andmeid."
    },
    "buyer": {
      "consolidated_view": "Ostja koondvaade",
      "go_cancelled": "Energia atribuudi sertifikaadid tühistatud",
      "certificates_this_year": "sertifikaate sel aastal",
      "membership_agreement": "Platvormileping",
      "agree_to_terms": "Nõustun tingimustega",
      "terms_accepted": "Tingimustega nõustutud edukalt",
      "manage_inventory": "Osta ja tühista",
      "platform_agreement_clickwrap_intro": "Nupule Nõustun vajutades nõustute {link}",
      "platform_agreement_link_text": "Soldera Platvormilepinguga"
    },
    "corporate": {
      "sections": {
        "energy_attribute_certificates": "Energia atribuudi sertifikaadid"
      }
    },
    "companies": "@:common.companies",
    "sign_document": "Allkirjasta dokument",
    "continue_registration": "Jätka registreerimist",
    "add_company_or_device": "Lisa ettevõte või seade",
    "add_company_access": "Lisage ettevõtte juurdepääs",
    "company_id": "Ettevõtte ID",
    "company_ids_placeholder": "Ettevõtte ID(d) - üksik või komadega eraldatud",
    "add_company": "Lisa ettevõte",
    "internal_role": "Sisemine roll",
    "user": "Kasutaja",
    "super_admin": "Super Administraator",
    "sales_admin": "Müügiadministraator",
    "fee_model": "Tasumudel",
    "standard": "Standard",
    "special_free": "Eri tasuta",
    "special_5pct": "Eri 5%",
    "special_1eur_per_mw": "Eri 1€/MW",
    "registry_excluded_devices": "Registrist välja jäetud seadmed (komadega eraldatud)",
    "allowed_invite_domains_label": "Lubatud kutsete domeenid (komadega eraldatud)",
    "allowed_invite_domains_help": "Meeskonnakutseid saab saata ainult nende domeenide e-posti aadressidele. Jäta tühjaks, et lubada kõik domeenid.",
    "is_test_company": "Kas testettevõte?",
    "hosted_account_regions_label": "Majutatud kontode piirkonnad (PT vastuvõtt)",
    "hosted_account_regions_help": "Vali, milliste riikide registrikontosid ettevõte võib kasutada PT vastuvõtmiseks Soldera majutatud kontodele.",
    "save_changes": "Salvesta muudatused",
    "all_trackings": "Kõik jälgimised",
    "referrer_company_id": "Soovitaja ID",
    "utm_source": "UTM Allikas",
    "utm_medium": "UTM Vahend",
    "utm_term": "UTM Tingimus",
    "utm_content": "UTM Sisu",
    "utm_campaign": "UTM Kampaania",
    "created_at": "Loodud",
    "admin_only_transfer_and_delete_company": "AINULT ADMIN: Kõigi varade ülekandmine teisele ettevõttele ja ettevõtte KUSTUTAMINE:",
    "transfer_to": "Ülekanne: {name} - {id}",
    "transfer": "Kanna üle",
    "nda_signed_link": "The link to the NDA contract we signed with the client",
    "client_nda_signed_link_title": "Eritingimuste dokumendid",
    "client_nda_signed_link": "Soldera ja {name} vahelistele eritingimustele pääsete ligi vajutades siia",
    "custom_percentage": "Kohandatud protsent",
    "custom_percentage_hint": "Toetatud on kohandatud protsendid vahemikus 5 kuni 20",
    "automaticReporting": {
      "title": "Automaatne toodangu aruandlus",
      "requiresAction": "Vajab tegevust",
      "lastUpdated": "Viimati uuendatud:",
      "lastDeclaredMonth": "Viimane deklareeritud tootmiskuu:",
      "lastDeclaredAmount": "Viimane deklareeritud kogus:",
      "helpNeeded": "Vajame teie abi, et tagada ESO-s oleva õige tootmisseadme sidumine Litgridi Grexeli registris oleva õige seadmega.",
      "missingAssociation": "Puudub seos mõõtepunktiga",
      "automaticallyDeclared": "Automaatselt deklareeritud",
      "declaredFor": "Deklareeritud kuu:",
      "amount": "Kogus:",
      "pendingApproval": "Ootab kinnitamist"
    },
    "sales_transactions": {
      "title": "Tehingute ajalugu",
      "description": "Päritolutunnistuste hinnad on volatiilsed ja võivad muutuda iga päev. Allpool leiate ülevaate kõigist teie tehingutest.",
      "description_link": "Objektiivseks võrdluseks oma tehingute ja turuhindade vahel soovitame tutvuda meie artikliga päritolutunnistuste avalike hinnasignaalide kohta.",
      "no_sales_transactions": "Tulevikus leiad siit oma tehingute ajaloo koos pakkumiste infoga!",
      "notificationInfo": "Anname Sulle emaili kaudu teada, kui müügitehingud on toimunud.",
      "date": "Tehingu kuupäev",
      "item": "Ese",
      "final_unit_price": "Ühikuhind",
      "amount": "Kogus",
      "offer_range": "Pakkumiste vahemik",
      "final_country": "Võitnud pakkumise riik",
      "status": "Staatus",
      "processing_explanation": "Soldera ootab vastaspoolelt raha laekumist. Kui see on laekunud, teavitame teid tehingust.",
      "completed": "Lõpetatud",
      "processing": "Töös",
      "pending_sales_details": "Müügiandmete ootel",
      "export_xlsx": "Ekspordi Excelisse",
      "view_aggregated": "Koondvaade",
      "view_by_company": "Ettevõtete kaupa",
      "view_by_power_plant": "Elektrijaamade kaupa",
      "power_plant": "Elektrijaam",
      "revenue": "Tulu",
      "soldera_fees": "Soldera tasud (ilma KM-ta)",
      "registry_fees": "Registri tasud (ilma KM-ta)",
      "fees_pending": "Tasud ootel"
    },
    "income_estimate": {
      "view_estimate": "Vaata tuluprognoosi"
    },
    "companyData": {
      "automatic_sale_with_highest_offer": "Automaatne müük kõrgeima pakkumisega",
      "fresh_production_sale_above_minimum_price": "Värske toodangu müük üle miinimumhinna {price}€/MWh",
      "modify": "Muuda",
      "money_pending": "Raha ootel",
      "transaction_history": "Tehingute ajalugu",
      "origin_certificates": "Päritolutunnistusi",
      "view_details": "Vaata lähemalt",
      "hide_details": "Peida lähemalt",
      "submit_invoice": "Esita arve",
      "invoice_history": "Arvete ajalugu",
      "documents": "@:common.documents",
      "continue_authorization_creation": "Jätka avaldust",
      "thank_you_for_joining": "Täname, et astusid Soldera liikmeks!",
      "thank_you_message": "Võtame Teie eest registriga ühendust ja korraldame kogu asjaajamise. Nüüd ei ole muud teha, kui oodata, kuni register oma toimingud ära teeb, ja me müüme Sinu tunnistused maha. Kui müük on toimunud, saadame Sulle teavituse ja palume Sul arve genereerida, et saaksime raha üle kanda.",
      "add_companies_or_devices_while_waiting": "Seni, kuni ootad, on Sul võimalus lisada ettevõtteid või seadmeid",
      "add_companies_while_waiting": "Seni, kuni ootad, võid lisada ettevõtteid",
      "invite_a_friend": "Kutsu sõber",
      "invite_a_friend_message": "Tunned kedagi, kellel võiks samuti Solderast kasu olla? 30% iga kutsutud sõbra esimese aasta tasudest lähevad Sulle!",
      "click_to_copy_link": "Vajuta siia, et kopeerida link, mida sõbrale saata",
      "production_settings": "Tootmisseaded",
      "measurement_points": "Mõõtmispunktid",
      "documents_signed_with_soldera": "Solderaga sõlmitud liikmeleping",
      "other_documents": "Muud Dokumendid",
      "device_contract": "Seadme {deviceName} leping",
      "contract_between_company_and_soldera": "Leping {companyName} ja Soldera vahel",
      "company_contract": "Leping {companyName}'ga",
      "link_copied": "Link on edukalt kopeeritud!",
      "link_copied_fallback": "Link copied to clipboard (fallback method).",
      "link_copy_failed": "Failed to copy link. Please copy it manually.",
      "update_min_price_success": "Miinimumhinna uuendamine õnnestus!",
      "new_min_price_effective_immediately": "Uus miinimumhind hakkab kehtima kohe",
      "update_min_price_failed": "Failed to update min price",
      "invoice_submission_success": "Arve esitamine õnnestus!",
      "invoice_paid_within_7_days": "Arve on edukalt esitatud ja on tasutud järgmise 7 päeva jooksul.",
      "fetch_pending_invoice_items_failed": "Failed to fetch pending invoice items",
      "fetch_certificates_failed": "Failed fetch certificates",
      "team": {
        "title": "Meeskond",
        "invite_title": "Kutsu meeskonda",
        "not_trusted_tooltip": "Meeskonnaliikmete lisamine on saadaval pärast konto aktiveerimist. Võta ühendust support@soldera.org.",
        "delete": "Kustuta",
        "invite": "Kutsu",
        "send_invite_email": "Saada kutse e-post",
        "invalidName": "Nimi peab olema vähemalt 2 tähemärki pikk",
        "invalidEmail": "Vigane e-posti formaat",
        "domain_not_allowed": "Kutsuda saab ainult nende e-posti domeenide aadresse: {domains}",
        "allowed_domains_hint": "Kutsed on piiratud järgmiste e-posti domeenidega: {domains}",
        "confirmDelete": "Kas oled kindel, et soovid eemaldada {account_name} ligipääsu ettevõttele {company_name}?"
      },
      "available_guarantees_of_origin": "Saadaval päritolutunnistused",
      "manage_inventory": "Halda inventari",
      "projected_production": "Prognoositud tootmine",
      "manage_production_strategy": "Halda tootmisstrateegiat",
      "invoice_management": "Arvete haldamine",
      "cancellation_documents": "Tühistamise dokumendid",
      "add_device": "Lisa seade",
      "no_devices": "Seadmeid pole",
      "add_device_message": "Lisa oma ettevõttele seade, et hakata tootmist haldama."
    },
    "devices": "Registreeritud seadmed",
    "generator": {
      "license_number": "Seade litsentsinumbriga {license_number}",
      "hide_documents": "Peida seotud dokumendid",
      "show_documents": "Näita seotud dokumente"
    },
    "documents": {
      "last_updated": "Viimati uuendatud",
      "section_title": "{document_count} dokumenti",
      "expand": "Vaata kõiki {document_count} dokumenti",
      "collapse": "Peida dokumendid",
      "hide_details": "Peida dokumendid konteineris",
      "show_details": "Näita dokumente konteineris",
      "document_title": "{document_name}",
      "other_document": "Dokument uuendatud {updated_at}",
      "show_associated_device": "Näita seotud seade",
      "hide_associated_device": "Peida seotud seade",
      "no_documents": "Dokumente pole veel",
      "no_documents_message": "Teie üleslaaditud või saadud dokumendid kuvatakse siin"
    },
    "portfolio": {
      "no_portfolio_data_title": "Portfelli andmed pole veel saadaval",
      "no_portfolio_data_subtitle": "Teie portfelli andmed kuvatakse siia, kui oleme teie registri andmed kätte saanud.",
      "all_portfolios": "Kõik portfellid",
      "total_volumes": "Kogumahud",
      "available_volumes": "Saadaval mahud",
      "expired_volumes": "Aegunud mahud",
      "sold_volumes": "Müüdud mahud",
      "monthly_technology_breakdown": "Kuude kaupa tehnoloogia järgi",
      "monthly_sales_status": "Kuude kaupa müügistaatuse järgi",
      "company_breakdown": "Mahud ettevõtete kaupa",
      "guarantees_of_origin_in_portfolios": "Päritolutunnistused portfellides",
      "projected_production": "Prognoositud tootmine",
      "pending_payouts": "Ootel väljamaksed",
      "production_devices": "Tootmisseadmed",
      "documents": "@:common.documents",
      "recipient_eecs_account_number": "Vastuvõtja EECS kontonumber",
      "recipient_internal_account_number": "Registri sisemine konto number",
      "recipient_internal_account_help": "Valikuline. Vajalik ainult registrites, mis kasutavad alamkontosid.",
      "recipient_internal_account_placeholder": "Valikuline alamkonto ID",
      "certificatesTableTitle": "Portfelli sertifikaadid",
      "sendGoChatWelcome": "Tere! Kuidas saan Teid täna aidata päritolutunnistuste saatmisel?",
      "sendGoChatWelcomeWithCerts": "Tere! Näen, et olete valinud {count} sertifikaati. Millised on vastuvõtja andmed?",
      "sendGoChatAssistant": "GO saatmise assistent",
      "sendGoChatPlaceholder": "Küsige GO saatmise kohta, sisestage vastuvõtja andmed või lisage fail...",
      "sendGoChatInputPlaceholder": "Sisestage vastuvõtja andmed või MWh kogus...",
      "sendGoOrderSummary": "Saatmisorderi kokkuvõte",
      "selected_certificates": "Valitud sertifikaadid",
      "selected_certificates_summary": "Valitud sertifikaatide kokkuvõte",
      "disabledReasonPortfolio": "Seda sertifikaatide kimpu ei saa saata, kuna see on juba eraldatud {portfolio} portfelli jaoks",
      "disabledReasonStatus": "See sertifikaat pole valitud staatuses saadaval.",
      "disabledReasonUnknown": "See sertifikaat pole valitud portfellis saadaval.",
      "recipientRegistryId": "Vastuvõtja registri ID",
      "recipientCountry": "Vastuvõtja riik",
      "recipientCompanyName": "Vastuvõtja ettevõtte nimi",
      "certificatesToSend": "Saadetavad sertifikaadid",
      "noCertificatesSelected": "Saatmist ootavaid sertifikaate pole valitud.",
      "totalMwhToSend": "Kokku MWh saatmiseks",
      "totalMwhInTable": "Valitud MWh",
      "sendGoDropFile": "Lohistage fail siia andmete ekstraheerimiseks",
      "sendGoUploadingFile": "Laadin üles {name}...",
      "sendGoUploadSuccess": "Edukalt üles laaditud {name}.",
      "sendGoSuccessMessage": "Saatmise tellimus edukalt esitatud!",
      "fileUpload": {
        "title": "Dokumendi üleslaadimine",
        "description": "Laadige üles dokument vastuvõtja andmete automaatseks eraldamiseks",
        "dropzone": "Lohistage dokument siia või klõpsake sirvimiseks",
        "supportedFormats": "Toetatud formaadid: PDF, Word, Excel jne.",
        "analyzing": "Dokumendi analüüs...",
        "extractionComplete": "Analüüs lõpetatud! Leidsin vastuvõtja informatsiooni.",
        "apply": "Rakenda eraldatud andmeid",
        "reset": "Lähtesta",
        "uploadPrompt": "Lohistage leping siia või klõpsake üleslaadimiseks",
        "drop_prompt": "Laske fail üleslaadimiseks lahti",
        "uploadAnother": "Laadige üles teine fail",
        "analysisSuccessTitle": "Leping edukalt analüüsitud.",
        "analysisSuccessMessage": "Faili andmed on eraldatud ja vormile rakendatud.",
        "analysisNoMatchTitle": "Sobivaid sertifikaate ei leitud.",
        "analysisNoMatchMessage": "Dokumendi kriteeriumid (tehnoloogia, seade või tootmisperiood) ei vasta ühelegi teie saadaolevale sertifikaadile, seega ei saanud midagi valida. Palun vaadake päring või filtrid üle.",
        "analysisShortfallTitle": "Sobivaid sertifikaate ei jätku.",
        "analysisShortfallMessage": "Soovitud {requested} MWh-st õnnestus sobivatest sertifikaatidest valida vaid {selected} MWh. Enne kinnitamist vaadake puudujääk üle."
      },
      "no_certificates_to_display": "Vastavalt filtritele sertifikaate ei leitud.",
      "disabled_reason_portfolio": "Sertifikaat on portfellis '{portfolio}'.",
      "disabled_reason_status_sold": "Seda sertifikaati ei saa valida, kuna see on müüdud.",
      "disabled_reason_status_ongoing_sale": "Seda sertifikaati ei saa valida, kuna müük on pooleli.",
      "disabled_reason_status_expired": "Seda sertifikaati ei saa valida, kuna see on aegunud.",
      "disabled_reason_status_non_transferrable": "Seda sertifikaati ei saa valida, kuna see pole ülekantav.",
      "disabled_reason_status_reserved": "Seda sertifikaati ei saa valida, kuna see on reserveeritud muudeks toiminguteks.",
      "disabled_reason_status_waiting_for_sale": "Seda sertifikaati ei saa valida, kuna see ootab müüki.",
      "disabled_reason_status_pending": "Seda sertifikaati ei saa valida, kuna see ootab süsteemi poolt tegevust.",
      "disabled_reason_status_unknown": "Seda sertifikaati ei saa valida selle staatuse tõttu: {status}.",
      "disabled_reason_unknown": "Ei saa valida",
      "recipient_registry_id": "Vastuvõtja registri ID",
      "recipient_country": "Vastuvõtja riik",
      "recipient_company_name": "Vastuvõtja ettevõtte nimi",
      "certificates_to_send": "Saadetavad sertifikaadid",
      "no_certificates_selected": "Saatmist ootavaid sertifikaate pole valitud.",
      "total_mwh_to_send": "Kokku MWh saatmiseks",
      "available_certificates_title": "Saadaolevad sertifikaadid ooteportfellis",
      "table": {
        "more_certificates": "{count} sertifikaati veel",
        "select_columns": "Vali veerud",
        "columns_selected": "{count} veergu valitud",
        "filters": {
          "search_company": "Otsi ettevõtet",
          "search_accounts": "Otsi kontosid",
          "search_portfolio": "Otsi portfelli / projekti",
          "search_device": "Otsi seadet",
          "month_placeholder": "YYYY-MM",
          "cod_age_year_placeholder": "Aasta",
          "cod_age_add_condition": "Lisa tingimus",
          "active": "@:common.active"
        },
        "filter_chips": {
          "group_label": "Aktiivsed filtrid",
          "label": "Filtrid",
          "none": "Puudub",
          "value": "{column}: {value}",
          "remove": "Eemalda filter „{column}”",
          "hiding": "peidetud {values}",
          "count_of_total": "{shown} / {total}",
          "contains": "sisaldab „{text}”",
          "cod_age_years": "{conditions} aastat",
          "tag_default": "Vaikimisi",
          "tag_document": "Dokumendist",
          "tag_unavailable": "Laos vastet pole",
          "reset": "Taasta vaikimisi filtrid",
          "clear_all": "Tühjenda kõik"
        },
        "filtered_total": "Kokku",
        "count_cell": {
          "of": "/ {count}",
          "editor": "Sellest reast valitav MWh",
          "full_title": "Klõpsa, et valida sellest reast ainult osa",
          "full_label": "Valitud kõik {count} MWh, vali sellest reast ainult osa",
          "partial_title": "Klõpsa koguse muutmiseks",
          "partial_label": "Valitud {selected} / {count} MWh, muuda kogust"
        }
      },
      "footer": {
        "action": "Tegevus",
        "technology_amount": "Tehnoloogia ja maht",
        "production_period": "@:common.production_period",
        "production_support": "Tootmistoetus",
        "no_certificates_selected": "Sertifikaate pole valitud",
        "review_send_title": "Saatmise ülevaade",
        "review_sell_title": "Müügi ülevaade",
        "review_cancel_title": "Tühistamise ülevaade",
        "confirm_send_btn": "Saada kohe",
        "confirm_sell_btn": "Müü kohe",
        "confirm_cancel_btn": "Tühista kohe",
        "cancel_btn": "@:common.cancel",
        "missing": "Puudu",
        "overselected": "Valitud liiga palju",
        "matched": "Kattub",
        "strategy_auto_high": "Automaatne kõrge pakkumine",
        "strategy_min_price": "Värske toodang üle miinimumhinna",
        "strategy_min_price_detailed": "Miinimumhind €{price}/MWh esimesed {duration} kuud, seejärel automaatmüük turuhinnaga",
        "risk_flags": "Riskid",
        "risk_region_mismatch": "Tuvastatud piirkonna lahknevus",
        "risk_insufficient_inventory": "Ebapiisav laovaru",
        "selected_mwh": "{mwh} MWh",
        "of_available": "/ {mwh} saadaval",
        "rows": "Read",
        "rows_selected": "ühtegi pole valitud | {count} valitud | {count} valitud",
        "rows_partial": "ükski pole osaline | {count} osaline | {count} osalist",
        "rows_hidden": "ükski pole filtritega peidetud | {count} filtritega peidetud | {count} filtritega peidetud",
        "partial_hint": "Klõpsa kogusel, et valida reast osa"
      },
      "cancelGoChatAssistant": "GO tühistamise assistent",
      "cancelGoChatPlaceholder": "Kinnitage tühistatavad sertifikaadid või esitage küsimusi...",
      "cancelGoChatInputPlaceholder": "Sisestage kinnitus või põhjus...",
      "cancelGoOrderSummary": "Tühistamise kokkuvõte",
      "certificatesToCancel": "Tühistatavad / kasutuselt kõrvaldatavad sertifikaadid",
      "noCertificatesSelectedCancel": "Tühistamiseks pole sertifikaate valitud.",
      "totalMwhToCancel": "Kokku MWh tühistamiseks",
      "cancelGoChatIntro": "Olete valinud tühistamiseks {count} sertifikaati. Palun kinnitage või esitage põhjus.",
      "sellGoChatAssistant": "GO müügi assistent",
      "sellGoChatPlaceholder": "Kinnitage sertifikaadid ja müügistrateegia...",
      "sellGoChatInputPlaceholder": "Kinnitage müügistrateegia või esitage küsimusi...",
      "sellGoOrderSummary": "Müügi kokkuvõte",
      "certificatesToSell": "Müüdavad sertifikaadid",
      "noCertificatesSelectedSell": "Müügiks pole sertifikaate valitud.",
      "totalMwhToSell": "Kokku MWh müügiks",
      "sellGoChatIntro": "Olete valinud müügiks {count} sertifikaati. Palun kinnitage müügistrateegia.",
      "receiveGoChatAssistant": "GO vastuvõtmise assistent",
      "receiveGoChatPlaceholder": "Kirjeldage GO-sid, mida ootate vastu võtta...",
      "receiveGoChatInputPlaceholder": "Sisestage saatja andmed või esitage küsimusi...",
      "receiveGoOrderSummary": "Vastuvõtmise kokkuvõte",
      "senderRegistryId": "Saatja registri ID",
      "senderCountry": "Saatja riik",
      "senderCompanyName": "Saatja ettevõtte nimi",
      "expectedMwh": "Oodatav MWh",
      "receiveGoTablePlaceholder": "Oodatavad sissetulevad ülekanded kuvatakse siin.",
      "buyGoChatAssistant": "GO ostmise assistent",
      "buyGoChatPlaceholder": "Milliseid GO-sid otsite? Kirjeldage mahtu, tehnoloogiat, hinnavahemikku jne.",
      "buyGoChatInputPlaceholder": "Määrake maht, tehnoloogia, hinnavahemik...",
      "buyGoOrderSummary": "Ostupäring / Pakkumised",
      "buyVolume": "Maht (MWh)",
      "buyTechnology": "Tehnoloogia (valikuline)",
      "buyMaxPrice": "Maksimaalne hind (€/MWh, valikuline)",
      "buyOffersPlaceholder": "Teie päringule vastavad pakkumised ilmuvad siia.",
      "buyGoTablePlaceholder": "Potentsiaalsed ostetavad GO-d kuvatakse siin.",
      "sellGoSuccessMessage": "Müügi tellimus edukalt esitatud!",
      "sellGoSuccessTitle": "Müügiseadistus valmis",
      "confirmSellTitle": "Kinnita müügiseadistus",
      "confirmSellMessage": "Te olete taotlemas {mwh} MWh taastuvenergia sertifikaatide müüki Soldera turuhinna süsteemi kaudu.",
      "confirm_sell_minimum_price_message": "Te soovite müüa {mwh} MWh taastuvenergia sertifikaate, kasutades miinimumhinna strateegiat. Nii see toimib:",
      "confirm_phase_1_title": "Esimesed {duration} kuud tootmisest",
      "confirm_phase_1_description": "Sertifikaate müüakse ainult siis, kui turuhind vastab teie miinimumhinnale €{price}/MWh või ületab seda.",
      "confirm_phase_2_title": "Pärast {duration} kuud tootmisest",
      "confirm_phase_2_description": "Kõik ülejäänud sertifikaadid müüakse automaatselt kõrgeima saadaoleva turuhinnaga, et need ei kaotaks väärtust.",
      "technologies": "Tehnoloogiad",
      "production_months": "Tootmiskuud",
      "spotSalesPortfolio": "Spot portfell",
      "spotSalesPortfolioDescription": "Sertifikaadid müüakse hetke turuhinnaga",
      "spot_sales_min_price_description": "Miinimumhind kehtib esmalt, seejärel automaatmüük turuhinnaga",
      "oldCertificatesWarningTitle": "Sertifikaadi vanuse hoiatus",
      "oldCertificatesWarningMessage": "Olete valinud {count} MWh sertifikaate, mis on vanemad kui {duration} kuud nende väljastamise kuupäevast. Minimaalse hinna strateegia kehtib ainult sertifikaatidele esimese {duration} kuu jooksul pärast väljastamist. Palun eemaldage need vanemad sertifikaadid, et jätkata minimaalse hinna strateegiat.",
      "document": {
        "title": "@:common.documents",
        "company": "@:common.company",
        "status": "Staatus",
        "last_updated": "Viimati uuendatud",
        "actions": "@:common.actions.title",
        "contract_details": "Lepingu üksikasjad"
      },
      "disabled_reason_status_own_use": "Seda sertifikaati ei saa valida, kuna see on märgitud omatarbeks ja sellega ei saa kaubelda."
    }
  },
  "followup": {
    "international_self_signup": {
      "title": "Võtame teiega peagi ühendust!",
      "message": "Täname registreerumast! Meie meeskond võtab teiega ühendust, et liitumine lõpule viia ja aidata vajalikud dokumendid allkirjastada."
    },
    "latvia_manual_auth": {
      "title": "Volita Soldera Grexeli süsteemis registreerimise lõpetamiseks",
      "message": "Selleks, et Soldera saaks hakata haldama Sinu päritolutunnistusi, pead Sa manuaalselt volitama meid Grexeli süsteemis. Palun järgi allolevaid juhiseid selle protsessi lõpetamiseks.",
      "button": "Vaata volitamise juhiseid"
    },
    "latvia_sales_followup": {
      "title": "Me võtame teiega peagi ühendust!",
      "message": "Teie uued seadmed vajavad sõltumatut auditit enne, kui AST neid aktsepteerib. Võtame teiega peagi ühendust, et arutada järgmisi samme. Vahepeal saate lisada teise ettevõtte või seadme.",
      "button": "Lisa ettevõtteid või seadmeid"
    }
  },
  "validations": {
    "required": "See väli on kohustuslik.",
    "maxValue": "Väärtus ei saa olla suurem kui {max}.",
    "minValue": "Miinimumväärtus on {min}.",
    "required_and_min": "See väli on kohustuslik ja väärtus peab olema vähemalt {min}.",
    "required_and_range": "See väli on kohustuslik ja väärtus peab olema vahemikus {min} ja {max}.",
    "minLength": "See väli on hetkel '{model}' tähemärki pikk, kuid peab olema vähemalt {min} tähemärki pikk.",
    "maxLength": "See väli tohib olla kuni {max} tähemärki pikk.",
    "exactStringLength": "See väli peab olema täpselt {length} tähemärki pikk.",
    "exactDigitLength": "See väli peab olema täpselt {length} numbrit pikk.",
    "estonianPersonalID": "See väli peab sisaldama kehtivat isikukoodi.",
    "estonianCompanyCode": "See väli peab sisaldama kehtivat ettevõtte registrikoodi.",
    "estonianIDorCompanyCode": "See väli peab olema kas ettevõtte registrikood või omaniku isikukood.",
    "estonianYourPersonalIDifID": "Isikukood peab ühtima omaniku isikukoodiga.",
    "estonianDeviceEIC": "See väli peab sisaldama kehtivat seadme EIC-koodi (nt: 38ZEE-12345678-X).",
    "estonianVATNumber": "Palun sisesta kehtiv käibemaksukood.",
    "latvianCompanyNumber": "See väli peab sisaldama kehtivat ettevõtte registrikoodi.",
    "lithuanianCompanyNumber": "See väli peab sisaldama kehtivat ettevõtte registrikoodi.",
    "latvianIDorVATNumber": "See väli peab sisaldama ettevõtetel VAT koodi või eraisikutel isikukoodi",
    "latvianYourPersonalIDifID": "Isikukood peab vastama omaniku isikukoodile.",
    "latvianIDorRegistryCode": "See väli peab sisaldama ettevõtete puhul registrikoodi või eraisikute puhul isikukoodi",
    "notExampleEIC": "EIC ei tohi olla näites toodud kood, vaid peab olema seadme tegelik EIC-kood.",
    "alpha": "See väli võib sisaldada ainult tähti.",
    "personalName": "Palun sisesta nimi samal kujul, nagu see on toodud isikut tõendavas dokumendis.",
    "phoneNumber": "See väli peab sisaldama kehtivat telefoninumbrit.",
    "someSubsidies": "Juhul kui tootmisseade on saanud toetusi, tuleb need siin täpsustada.",
    "generatorExists": "Palun lae üles Sinu tootmisseadme võrguleping, et jätkata.",
    "reasonableDate": "Palun veendu, et kuupäev on korrektne.",
    "iban": "Palun sisesta kehtiv IBAN number.",
    "fileRequired": "Palun laadige see dokument üles.",
    "swedishPersonalID": "See väli peab sisaldama kehtivat Rootsi isikukoodi.",
    "swedishCompanyCode": "See väli peab sisaldama kehtivat Rootsi organisatsiooni numbrit.",
    "swedishIDorCompanyCode": "See väli peab sisaldama kas kehtivat Rootsi isikukoodi või organisatsiooni numbrit.",
    "finnishPersonalID": "See väli peab sisaldama Soome isikukoodi.",
    "finnishBusinessID": "See väli peab sisaldama Soome äriregistri registrinumbrit (Y-tunnus).",
    "finnishIDorBusinessID": "See väli peab sisaldama kas Soome isikukoodi või äriregistri registrinumbrit.",
    "integer": "See väli peab sisaldama täisarvu.",
    "required_and_integer": "See väli on kohustuslik ja peab sisaldama täisarvu.",
    "required_integer_and_min": "See väli on kohustuslik, peab sisaldama täisarvu ja väärtus peab olema vähemalt {min}.",
    "required_integer_and_range": "See väli on kohustuslik, peab sisaldama täisarvu ja väärtus peab olema vahemikus {min} ja {max}.",
    "selection_required": "Tuleb teha vähemalt üks valik.",
    "between": "Väärtus peab olema vahemikus {min} ja {max}.",
    "validRegistryCode": "Registrikood peab olema 3-20 tähemärgist (tähed, numbrid, kriipsud lubatud).",
    "validAddress": "Aadress peab olema 5-200 tähemärki pikk.",
    "validVATNumber": "Palun sisestage kehtiv käibemaksukood (formaat: XX123456789 või CHE123456789).",
    "swedishVATNumber": "Palun sisestage kehtiv Rootsi käibemaksukood (formaat: SE + 10 numbrit + 01, nt SE556229657301).",
    "validRepresentativeName": "Nimi peab olema 2-100 tähemärki pikk ja sisaldama nii ees- kui perekonnanime.",
    "validRepresentativePhone": "Telefoninumber peab olema 6-25 tähemärki pikk ja õiges formaadis.",
    "polishVATNumber": "See väli peab sisaldama kehtivat Poola KM-numbrit (PL + 10 numbrit).",
    "polishRegistryCode": "See väli peab sisaldama kehtivat Poola ettevõtte registrikoodi (10 numbrit KRS jaoks).",
    "productionValue": "Tootmisväärtus peab olema suurem kui null.",
    "dateCannotBeFuture": "Kuupäev ei saa olla tulevikus.",
    "email": "Palun sisestage kehtiv e-posti aadress.",
    "eecs_account_format": "Vigane EECS konto numbri formaat",
    "unit_price_pln_format": "Peab olema positiivne summa kuni 2 komakohaga"
  },
  "validation": {
    "pl": {
      "invalid_vat_number": "Palun sisesta kehtiv Poola KM-numbri (PL + 10 numbrit).",
      "invalid_registry_code": "Palun sisesta kehtiv Poola ettevõtte registrikood (10 numbrit KRS jaoks)."
    }
  },
  "registry_device": {
    "device_name": "Seadme nimi",
    "device_power": "Seadme võimsus",
    "supported_device": "Seade toetusega",
    "fetch_failed": "Seadmete toomine ebaõnnestus",
    "device_code": "Seade koodiga {code}",
    "technology_code": "Tehnoloogiakood",
    "commercial_operation_date": "Tööle võtu kuupäev",
    "ecolabel_approved": "Ökomärk heaks kiidetud",
    "address": "@:common.address",
    "device_eic_placeholder": "Sisesta seadme identifikaatori kood",
    "device_name_placeholder": "Sisesta seadme nimi",
    "device_power_placeholder": "Sisesta võimsus kW-des",
    "device_eic_description": "Seadme unikaalne identifikaator registris",
    "commercial_operation_date_description": "Kuupäev, mil seade hakkas tööle",
    "polish_fields": {
      "title": "Väljastamisandmete volikirja jaoks nõutav lisateave",
      "installation_address": "Paigaldusaadress",
      "installation_address_placeholder": "Sisestage seadme paigaldamise füüsiline aadress",
      "installation_address_description": "Füüsiline aadress, kuhu taastuvenergiaseade on paigaldatud",
      "metering_system_number": "Mõõtesüsteemi number",
      "metering_system_number_placeholder": "Sisestage mõõtesüsteemi identifikaator",
      "metering_system_number_description": "Mõõtesüsteemi unikaalne identifikaator",
      "metering_system_multiplier": "Mõõtesüsteemi kordaja",
      "metering_system_multiplier_placeholder": "Sisestage kordaja väärtus",
      "metering_system_multiplier_description": "Mõõtenäitudele rakendatav kordaja",
      "osd_name": "Jaotusvõrguettevõtja (OSD) nimi",
      "osd_name_placeholder": "Sisestage OSD nimi ja haru (kui on kohaldatav), nt PGE Dystrybucja S.A. Oddział Łódź",
      "osd_name_description": "Jaotusvõrguettevõtja ja teie seadmega ühendatud konkreetse haru nimi",
      "osd_address": "OSD aadress",
      "osd_address_placeholder": "Sisestage OSD aadress (vajadusel haru aadress), nt ul. Tuwima 58, 90-021 Łódź",
      "osd_address_description": "Teie seadmega ühendatud jaotusvõrguettevõtja haru aadress"
    },
    "poa": {
      "generate": "Genereeri volikiri",
      "generating": "Volikirja genereerimine...",
      "generated_successfully": "Volikiri on edukalt genereeritud",
      "description": "Genereerige volikiri, et anda Solderale luba juurdepääsuks teie seadme väljastamisandmetele",
      "missing_polish_data_error": "Sellel seadmel puudub volikirja genereerimiseks vajalik teave",
      "required_for_issuance": "Järgmine teave on vajalik väljastamisandmetele juurdepääsu volikirja genereerimiseks."
    },
    "production_estimate_override": {
      "title": "Tootmisprognoosi ülekirjutamine",
      "save": "Salvesta",
      "saving": "Salvestamine...",
      "use_manual_estimates": "Kasuta käsitsi prognoose",
      "use_automatic_estimates": "Kasuta automaatseid prognoose",
      "monthly_production_estimates": "Igakuised tootmisprognoosid",
      "automatic_vs_manual": "Automaatne vs käsitsi",
      "automatic_calculated": "Automaatne (arvutatud)",
      "automatic": "Automaatne",
      "manual": "Käsitsi",
      "override_button": "Kirjuta prognoosid üle",
      "projected_production": "Prognoositud tootmine",
      "configured_values": "Konfigureeritud väärtused",
      "calculated_values": "Arvutatud ajalooliste andmete põhjal",
      "feasibility_warning": "Uute prognooside alusel ei pruugi teie forward-kogumid enam katta võetud kohustusi: perioodil {period} on kohustusi {demand} MWh, kuid prognoos jääb {shortfall} MWh puudu. Palun vaadake oma forward-mahud üle.",
      "feasibility_warning_title": "Edasimüügi strateegia hoiatus"
    }
  },
  "account": {
    "name": "Nimi",
    "email": "Email",
    "phone_number": "Telefoninumber",
    "registry_code": "Isikukood",
    "comment": "Kommentaar"
  },
  "company": {
    "payout_currency": "Väljamakse valuuta",
    "payout_currency_hint": "Teistes valuutades väljamakseid saab lubada Soldera tugi.",
    "name": "@:common.name",
    "registry_code": "Registri- või isikukood",
    "address": "@:common.address",
    "vat": "Käibemaksukood",
    "vat_or_personal_id": "Käibemaksukood või isikukood",
    "bank_account": "Pangakonto IBAN",
    "bank_name": "Panga nimi",
    "bank_swift": "Panga SWIFT/kood",
    "invalid_vat": "Käibemaksukood peab olema tühi või kujul XX999999999 (riigi kood + 8-12 numbrit)",
    "contact_email": "Kontakti e-post",
    "invoice_email": "Arve e-post",
    "billing_email": "Arvelduse e-posti aadress",
    "billing_email_tooltip": "Arved saadetakse lisaks teie konto e-postile ka sellele aadressile. Kasulik edastamiseks raamatupidajale või finantsosakonnale.",
    "monthly_rollup": "Koonda müügiteavitused üheks kuukirjaks",
    "monthly_rollup_tooltip": "Iga müügi kohta eraldi e-kirja asemel saate ühe kokkuvõtva e-kirja iga kuu 25. kuupäeval. Arved arvete e-postile saadetakse endiselt kohe."
  },
  "document": {
    "document_container": "Dokumentide komplekt allkirjastmiseks",
    "send_elering_email": "Saada Eleringile e-mail",
    "resend_email": "Saada email",
    "signed": "Allkirjastatud",
    "awaiting_signature": "Ootab allkirjastamist",
    "download": "Lae dokument alla",
    "sign_document": "Allkirjasta dokument",
    "delete_document": "Kustuta dokument",
    "admin_delete_document": "Administraatori dokumendi kustutamine",
    "confirm_delete": "Kas olete kindel, et soovite selle dokumendi kustutada?",
    "confirm_admin_delete": "Kas olete kindel, et soovite selle dokumendi kustutada administraatorina?",
    "unfinished_document": "Lõpetamata avaldus",
    "forward_service_appendix": {
      "title": "Forward-müügi leping",
      "description": "Sätestab vaikimisi tingimused Liikme ja Soldera vahel toimuvale Forward-müügile ning esitatakse raamistik, mille alusel lepivad Pooled kokku Forward-müügi juhistes."
    }
  },
  "generator": {
    "device_name": "Inverteri mudel",
    "device_eic": "Seadme EIC",
    "device_power": "Koguvõimsus (KW)",
    "device_address": "Seadme aadress",
    "grid_contract_start_date": "Tootmise algus",
    "subsidies": "Riigitoetused",
    "battery": "Salvestusseade",
    "ppa": "Otsemüügileping",
    "no_subsidies": "Toetused puuduvad",
    "no_storage_device": "Salvestusseade puudub",
    "no_ppa": "Otsemüügileping puudub",
    "no_battery": "Salvestusseade puudub",
    "subsidy_provider": "Toetuse andja: {provider}",
    "subsidy_plan": "Toetuskava: {plan}",
    "unit_power": "Ühikvõimsus: {power}",
    "capacity": "Mahtuvus: {capacity}",
    "ppa_start_date": "Alguskuupäev: {date}",
    "ppa_mwh": "MWh: {mwh}",
    "ppa_client_name": "Kliendi ettevõte: {name}",
    "ppa_country": "Kliendi riik: {country}",
    "EIC": "EIC",
    "status": {
      "1": "Registreerimata",
      "2": "Dokument vajab allkirjastamist",
      "3": "Seade registreeritud"
    },
    "continue_registration": "Jätka seadme registreerimist",
    "sign_document": "Allkirjasta dokument",
    "edit": "Muuda",
    "properties": {
      "device_name": "Inverteri mudel",
      "solar_panel_model": "Päikesepaneelide mudel",
      "device_address": "Aadress",
      "device_power": "Võimsus",
      "battery": "Salvestusseade",
      "subsidies": "Toetused"
    },
    "unspecified": "Täpsustamata",
    "documents": "@:common.documents",
    "document_title": "Leping seadme EIC-ga: {eic}",
    "license_number": "Litsentsi nr."
  },
  "invoice": {
    "status": {
      "paid": "Makstud",
      "canceled": "Tühistatud",
      "requested": "Esitatud",
      "drafting": "Koostamisel"
    },
    "regenerate_confirmation": "Kas tõesti soovite arvet uuesti genereerida?",
    "regenerate": "Genereeri uuesti",
    "cancel_fee_only": "Tühista",
    "cancel_fee_only_confirmation": "Kas oled kindel, et soovid selle ainult-tasude arve tühistada? Arve read lähevad tagasi ootele ning nii tasu kui ka arveldusarve kustutatakse.",
    "cancel_mixed_types_disabled": "Ühes partiis ei saa tühistada kulu- ja ainult-tasude arveid korraga — vali korraga ainult üks tüüp.",
    "send_to_merit": "Saada Meritisse",
    "send_to_merit_confirmation": "Kas oled kindel, et soovid selle arve Meritisse saata?",
    "already_in_merit": "Arve on Meritisse juba registreeritud.",
    "error_downloading": "Viga arve allalaadimisel",
    "number": "Arve number",
    "status_label": "Staatus",
    "requested_date": "Esitatud kuupäev",
    "amount": "Summa"
  },
  "invoiceHistory": {
    "title": "Arvete ajalugu",
    "noInvoices": "Tulevikus leiad siit kõik oma arved!",
    "notificationInfo": "Anname Sulle emaili kaudu teada, kui müügitehingud on toimunud.",
    "export_xlsx": "Ekspordi Excelisse"
  },
  "setPriceTerms": {
    "modifyStrategyTitle": "Spot-müügi strateegia",
    "selectStrategyLabel": "Vali müügistrateegia",
    "automaticHighBid": "Kõrgeima pakkumisega automaatne müük",
    "fresh_prod_above_min_price": "Määra ajaliselt piiratud miinimumhind",
    "minimumPriceDuration": "Esimese {duration} kuu miinimumhind",
    "minimumPriceLabel": "Miinimumhind",
    "enterPrice": "Sisesta hind",
    "saveChanges": "Salvesta muudatused",
    "readMore": "Loe lähemalt",
    "duration": {
      "minimum_price_window": "Miinimumhinna aken",
      "default_hint": "Vaikimisi on 6 kuud tootmiskuupäevast",
      "limit_active_for": "Piirang kehtib {duration} kuud alates väljastamisest"
    },
    "warning": {
      "depreciation": "Hoiatus: Üle 6 kuu vanused päritolutunnistused kipuvad kiiresti odavnema, kuna lähenevad 12-kuulisele üleandmise tähtajale.",
      "noSaleAt12": "Kriitiline hoiatus: 10-12 kuu valimisel võivad teie päritolutunnistused muutuda väärtustuks, kuna päritolutunnistusi ei saa 12 kuud pärast väljastamist enam üle kanda. Juba 10-kuulisel märgil on vähe aega järel, mistõttu neid päritolutunnistusi on raske müüa."
    },
    "phases": {
      "title": "Kuidas see strateegia toimib",
      "phase_1_badge": "Faas 1",
      "phase_1_title": "Esimesed {duration} kuud tootmisest",
      "phase_1_description": "Sertifikaate hoitakse, kuni turuhind vastab teie miinimumhinnale €{price}/MWh või ületab seda. Kui hind on alla teie miinimumi, siis sertifikaate ei müüda.",
      "phase_2_badge": "Faas 2",
      "phase_2_title": "Pärast {duration} kuud tootmisest",
      "phase_2_description": "Kõik müümata sertifikaadid müüakse automaatselt kõrgeima saadaoleva turuhinnaga. See tagab, et teie sertifikaadid müüakse alati enne nende aegumist.",
      "readonly_summary": "Miinimumhind esimesed {duration} kuud, seejärel automaatmüük turuhinnaga"
    },
    "howMinimumPriceWorks": "Kuidas töötab Soldera miinimumhind",
    "contentParagraph1": "Turuhinnaga automaatne müük pakub kindlat viisi päritolutunnistuste müügiks, hajutades riski ja tagades, et need müüakse ajal, mil nende värskus on kõige rohkem hinnas.",
    "content_paragraph_2": "Me mõistame, et paljud meie liikmed sooviksid oma päritolutunnistuste müüki planeerida. Siiski esineb alati risk, et päritolutunnistuste hind ei küündi soovitud miinimumhinnani. Seega on turuhinnaga müük parem variant kui lasta päritolutunnistustel aeguda ja seeläbi müümata jätta.",
    "content_paragraph_3": "Selleks pakume võimalust seada miinimumhinna strateegia. Esimese {duration} kuu jooksul pärast päritolutunnistuste väljastamist müüme neid ainult siis, kui turuhind vastab teie miinimumhinnale või ületab seda. Pärast selle {duration}-kuulise perioodi lõppemist müüme automaatselt kõik ülejäänud päritolutunnistused praeguse turuhinnaga, et vältida nende väärtuse kaotamist. See strateegia annab teile võimaluse kasutada hinna tõusu, tagades samas, et teie päritolutunnistused müüakse alati enne nende aegumist.",
    "howMarketPriceWorks": "Kuidas töötab Soldera turuhind",
    "marketPriceContentParagraph1": "Soldera agregeerib päritolutunnistused mitmelt liikmelt suuremateks müügitehinguteks, ühendades meie kollektiivse mahu tugevama turupositsiooni ja paremate hindade saavutamiseks. Viime läbi regulaarseid müüke nutikate strateegiate ja ajastusega, mis maksimeerib tehingute sagedust. Selle protsessi lihtsustamiseks viime teie päritolutunnistused üle meie registrikontole, kus meie tarkvara käsitleb kõike automaatselt - te ei pea kunagi ostjatega läbi rääkima ega ülekandeid ise haldama.",
    "marketPriceContentParagraph2": "Enne iga müüki hangib Soldera hinnapakkumised meie laiast rahvusvaheliste ostjate võrgustikust, tagades konkurentsivõimelise hinnakujunduse meie turusuhete kaudu. Valime välja parima pakutud hinna ja viime müügi lõpule kõigi osalevate liikmete nimel. Meie automatiseeritud süsteem käsitleb kogu keerukuse, säilitades samal ajal hinnakujundusprotsessi läbipaistvuse.",
    "marketPriceContentParagraph3": "5 päeva jooksul pärast ostjalt makse saamist teavitame teid e-kirjaga tehingu üksikasjadest, sealhulgas teie osa tuludest pärast meie tasu ja tehingukulude (tavaliselt registri eksporditasud) mahaarvamist. Seejärel saate ühe klõpsuga Soldera platvormi kaudu väljamakset taotleda - kui te ei soovi arvet kohe väljastada, võite seda hiljem igal ajal teha. Soldera kannab makse teie kontole 7 päeva jooksul pärast arve saamist."
  },
  "requestInvoice": {
    "indicative_payout_explainer": "EKP kursiga {rate} ({date}). Soovituslik: väljamakse arvutatakse oma kuupäeva kursiga.",
    "submit_invoice": "Arve esitamine",
    "money_pending": "Raha ootel",
    "sales_revenue": "Müügitulu",
    "sales_vat": "Müügi käibemaks",
    "state_income_tax": "Riigi tulumaks",
    "service_fees_vat": "Teenustasud (sh KM)",
    "detailed_overview": "Täpsem ülevaade",
    "view_details": "Vaata lähemalt",
    "invoice_items": "Arve kirjed",
    "item": "Ese",
    "quantity": "Kogus",
    "unit_price": "Ühikuhind",
    "total_excl_vat": "Kokku (KM-ta)",
    "vat": "Käibemaks",
    "offset_service_fees": "Tasaarveldatud teenustasud",
    "invoice_details": "Arve andmed",
    "invoice_number": "Arve number",
    "invoice_number_placeholder": "Arve number",
    "vat_number": "Käibemaksu number",
    "vat_number_placeholder": "EE123456789",
    "bank_account_iban": "Pangakonto (IBAN)",
    "bank_account_placeholder": "EE123456789012345678",
    "contact_block_on_invoice": "Kontaktanmete plokk arvel",
    "contact_block_placeholder": "Ettevõtte nimi, \nAadress,  \nRegistrikood",
    "reference": "Viitenumber (valikuline)",
    "reference_placeholder": "Viitenumber",
    "monthly_rollup_label": "Koonda tulevased müügiteavitused üheks igakuiseks e-kirjaks (saadetakse 25. kuupäeval)"
  },
  "cancellation": {
    "list_title": "Tühistamise avaldused",
    "add_new_statement": "Lisa uus tühistamise avaldus",
    "not_trusted_tooltip": "Avalduste lisamine on saadaval pärast konto aktiveerimist. Võta ühendust support@soldera.org.",
    "no_cancellations": "Tühistamise avaldusi pole",
    "no_cancellations_info": "Teie tühistamise avaldused kuvatakse siin pärast üleslaadimist",
    "view_details": "Vaata üksikasju",
    "download_documents": "Laadi alla dokumendid",
    "download_shown": "Laadi alla kuvatud (dokumente pole) | Laadi alla kuvatud ({count} dokument) | Laadi alla kuvatud ({count} dokumenti)",
    "download_preparing": "Valmistan ette {current} / {total}…",
    "download_preparing_documents": "Valmistan dokumente ette…",
    "download_none_selected": "Praeguses valikus pole dokumente",
    "download_too_many_documents": "Korraga allalaadimiseks on liiga palju dokumente ({count}). Kitsenda filtreid nii, et neid oleks kõige rohkem {max}.",
    "download_too_many_bytes": "Valitud dokumentide kogumaht on {total} MB; piirang on {max} MB. Kitsenda filtreid ja proovi uuesti.",
    "download_too_large_title": "Valik on allalaadimiseks liiga suur",
    "bulk_download_failed": "Tühistamise avalduste allalaadimine ebaõnnestus",
    "bulk_download_no_documents_title": "Allalaaditavaid dokumente pole",
    "bulk_download_no_documents": "Ühtegi valitud dokumenti pole enam saadaval. Nimekiri värskendati.",
    "create_statement": "Loo avaldus",
    "drop_to_create": "Lohistage failid siia, et luua uus tühistamise avaldus",
    "table": {
      "id": "@:common.id",
      "created": "Loodud",
      "beneficiary_name": "Kasusaaja nimi",
      "period": "Periood",
      "mwh_cancelled": "Tühistatud MWh",
      "purpose": "Eesmärk",
      "registry": "Register",
      "registry_code": "Registrikood",
      "more_statements": "{count} avaldust veel"
    },
    "details_title": "Tühistamise avalduse üksikasjad",
    "details": {
      "basic_info": "Avalduse andmed",
      "documents": "Üleslaaditud dokumendid",
      "order_id": "Käsu ID",
      "registry_document": "Registri dokument",
      "view_registry_document": "Vaata registris",
      "period": "@:cancellation.table.period",
      "load_error": "Viga avalduse andmete laadimisel",
      "no_documents": "Dokumente pole üles laaditud",
      "download_all": "Laadi alla kõik",
      "add_documents": "Lisa dokumente",
      "upload_selected": "Laadi üles"
    },
    "upload": {
      "drop_files": "Lohistage failid siia või klõpsake sirvimiseks",
      "supported_formats": "Toetatud formaadid: PDF, DOC, DOCX, XLS, XLSX, CSV, TXT, PNG, JPG, JPEG (maksimaalselt 25MB)"
    },
    "modal": {
      "files_required": "Vähemalt üks dokument on nõutav",
      "order_selection": "Käsu valik",
      "order_selection_description": "Valige käsk automaatseks vormi täitmiseks või valige 'Ei ole' käsitsi sisestamiseks.",
      "linked_order": "Seotud käsk",
      "order_help_text": "Valige käsk automaatseks andmete täitmiseks või valige 'Ei ole' käsitsi sisestamiseks.",
      "statement_selection": "Valige avaldus",
      "no_statement_selected": "Valige avaldus",
      "statement_help_text": "Valige konkreetne avaldus valitud käsust automaatseks vormi andmete täitmiseks.",
      "statement_details": "Avalduse üksikasjad",
      "auto_fill_from_statement_notice": "Vormi andmed on automaatselt täidetud valitud avaldusest. Saate muuta mis tahes välja vastavalt vajadusele.",
      "select_statement_notice": "Valige avaldus ülaltoodud loendist vormi andmete täitmiseks.",
      "order_option": "Käsu valik {id}",
      "no_order_selected": "Käsku pole valitud",
      "upload_description_with_ai": "Laadige üles tühistamislepinguid või vastavusdokumente väljade automaatseks täitmiseks või lisage toetavaid dokumente.",
      "analyzing_document": "Dokumendi analüüs AI-ga...",
      "ai_analysis_applied": "AI analüüs on vormile rakendatud",
      "ai_populated": "AI täidetud",
      "clear_ai_data": "Tühjenda AI andmed",
      "confirm_override_ai_data": "See asendab AI-ga täidetud andmed käsu andmetega. Kas olete kindel, et soovite jätkata?",
      "analysis_complete_title": "Analüüs lõpetatud",
      "analysis_success_with_fields": "Dokument edukalt analüüsitud ja uuendatud {count} välja.",
      "analysis_success_no_fields": "Dokument edukalt analüüsitud, kuid uut teavet vormi uuendamiseks ei leitud.",
      "analysis_success_multiple_statements_with_fields": "Dokumendist leiti {total_statements} avaldust. Rakendati esimene avaldus ja uuendati {count} välja. Palun kontrollige ülejäänud avaldusi käsitsi.",
      "analysis_success_multiple_statements_no_fields": "Dokumendist leiti {total_statements} avaldust, kuid uut teavet vormi uuendamiseks ei leitud.",
      "multiple_statements_warning": "Dokumendist tuvastati mitu avaldust ({total_statements}). Vormi täitmiseks kasutati ainult esimest avaldust. Palun kontrollige ülejäänud avaldusi käsitsi.",
      "upload_documents": "Dokumentide üleslaadimine",
      "uploaded_files": "Üles laaditud failid",
      "field": {
        "operation_notes": "Töömärkused"
      }
    },
    "purpose": {
      "DISCLOSURE": "Avalikustamine",
      "GRID_LOSSES": "Võrgukaod",
      "SELF_CONSUMPTION": "Omatarbimine",
      "SUPPORT_SCHEME": "Toetuskava",
      "OTHER": "Muu"
    },
    "success": {
      "title": "Avaldus loodud!",
      "message": "Teie tühistamise avaldus on edukalt loodud."
    }
  },
  "certificateHistory": {
    "overview": "Päritolutunnistusete ülevaade",
    "productionPeriod": "@:common.production_period",
    "certificateCount": "Päritolutunnistuste arv",
    "expired": "Aegunud",
    "sold": "Müüdud",
    "awaitingSale": "Müügi ootel"
  },
  "chooseCompany": {
    "select_company": "Vali ettevõte millele volitust anda",
    "choose_company": "Vali ettevõte",
    "create_new_company": "Loo uus ettevõte"
  },
  "invoiceItem": {
    "quantity": "Kogus",
    "unit_price": "Ühikuhind",
    "total_excl_vat": "Kokku (km-ta)",
    "vat": "Käibemaks"
  },
  "tradingCenter": {
    "tradingStrategy": "Kauplemisstrateegia",
    "title": "Tootmise strateegia",
    "tabs": {
      "overview": "Ülevaade",
      "strategyCustomisation": "Kauplemisstrateegia kohandamine",
      "issuance_reporting": {
        "title": "Tootmisandmete raporteerimine"
      }
    },
    "customization": {
      "forwardSales": "Tulevikumüük",
      "spotSales": "Spot-müük",
      "ppaReserve": "PPA reserv",
      "holdPortfolio": "Isehaldus"
    },
    "overview": {
      "projectedProduction": {
        "title": "Prognoositud tootmismaht",
        "noData": "Sinu prognoositud aastatootmismahtu hakatakse siin näitama, kui me saame Sinu tootmisseadmete andmeid registrist."
      },
      "spot": {
        "title": "Spot-müük",
        "visualization": {
          "minimumPrice": {
            "title": "Üritame müüa toodangut üle miinimumhinna {price}€/MWh",
            "description": "Tootmine kaasatakse spot-müügi pakkumistesse kui oodatud hind on üle kasutaja seadistatud miinimumhinna",
            "firstMonths": "Esimesed {duration} kuud"
          },
          "highestBid": {
            "title": "Müük turuhinnaga",
            "description": "Toodang müüakse automaatselt turuhinnaga",
            "lastMonths": "Viimased {duration} kuud"
          }
        }
      }
    }
  },
  "market_insights": {
    "title": "Turuülevaade",
    "description": "Turuinfo ja analüütika taastuvenergiale",
    "sections": {
      "reports": "Turuaruanded",
      "charts": "Turuandmed ja graafikud"
    },
    "forward_outlook": {
      "title": "Soldera Forward Outlook",
      "description": "Igakuine analüüs GO turu trendidest ja olulistest uudistest, mis mõjutavad turgu"
    },
    "consulting_services": {
      "title": "Scope 2 vastavustugi",
      "description": "Soldera pakub nõudmisel vastavusteenuseid. Võtke meiega ühendust lisateabe saamiseks.",
      "button_text": "Võta meiega ühendust"
    },
    "norway_reservoir": {
      "title": "Norra veehoidlate tasemed",
      "description": "Iganädalased veehoidlate tasemed koos ajaloolise võrdluse ja prognoosidega",
      "zone_label": "Kauplemistsoon",
      "y_axis_label": "% mahutavusest",
      "loading": "Veehoidla andmete laadimine...",
      "error": "Veehoidla andmete laadimine ebaõnnestus",
      "no_data": "Valitud tsooni kohta andmed puuduvad",
      "locked_zones_hint": "Avage kõik veehoidla tsoonid — võtke meiega ühendust piirkondlike ülevaadete aktiveerimiseks",
      "info_text": "Norra on peamine päritolutunnistuste (PT) eksportija teistele AIB liikmesriikidele tänu suurele hüdroenergia tootmisele. Riigisisesed poliitikad ei soodusta PT-de kohalikku kasutamist ja tekitavad märkimisväärse ekspordiülejäägi. Seetõttu mõjutavad Norra hüdroenergia tootmisvõimsuse või sisetarbimise muutused ebaproportsionaalselt laiemat Euroopa PT turgu.\n\nAndmeid uuendatakse kord nädalas. Tegelikud veehoidlate tasemed kinnitatakse tavaliselt märksa hiljem, seetõttu pakume oma hinnanguid, et paremini prognoosida turudünaamikat.",
      "zones": {
        "norway_total": "Norra kokku"
      },
      "legend": {
        "historical_max": "Ajalooline maksimum",
        "historical_median": "Ajalooline mediaan",
        "historical_min": "Ajalooline miinimum",
        "last_year": "Eelmine aasta",
        "this_year": "Sel aastal",
        "predicted": "Prognoositud"
      }
    },
    "cumulative_re": {
      "title": "Taastuvenergia kumulatiivne toodang",
      "description": "Aastatevaheline taastuvenergia toodangu võrdlus",
      "country_label": "Riik",
      "eu_aggregate": "Euroopa Liit (Koondatud)",
      "y_axis_label": "GWh",
      "loading": "Graafiku andmete laadimine...",
      "error": "Graafiku andmete laadimine ebaõnnestus",
      "info_text": "Aastane taastuvenergia tootmine on tugev hinnatrendide indikaator – kui tootmine kasvab märkimisväärselt, kipuvad PT-de hinnad langema, sest pakkumine suureneb.\n\nAndmeid uuendatakse kord nädalas ning need ei sisalda riike, mis ei ole AIB liikmed või ei kuulu mandri-Euroopasse."
    }
  },
  "charts": {
    "xAxisLabel": "X-telg",
    "stackByLabel": "Rühmita",
    "fields": {
      "portfolio_type": "Portfelli tüüp",
      "production_month": "Tootmiskuu",
      "status": "Staatus",
      "technology_type": "Tehnoloogia",
      "company_name": "Ettevõtte nimi",
      "portfolio_name": "Portfelli nimi",
      "production_device_name": "Tootmisseade",
      "production_support": "Tootmistoetus",
      "ecolabel_tags": "Ecolabel",
      "transfer_deadline": "Ülekande tähtaeg",
      "count": "Arv",
      "certificate_id": "Sertifikaadi ID",
      "registration_authority": "Registreeriv asutus",
      "registry_region": "Praegune register",
      "issuing_region": "Päritoluregister",
      "cod_age": "COD vanus",
      "limit_price": "Miinimumhind",
      "sale_price": "Müügihind",
      "account_emails": "Kontod",
      "registry_id": "Registri ID",
      "bundle_start": "Komplekti algus",
      "bundle_end": "Komplekti lõpp"
    },
    "values": {
      "production_support": {
        "true": "Toetusega",
        "false": "Toetuseta",
        "null": "Teadmata"
      },
      "portfolio_type": {
        "FORWARD": "Tulevikumüük",
        "SPOT_MARKET_PRICE": "Spot müük",
        "SPOT_MIN_PRICE": "Spot müük miinimumhinnaga",
        "HOLD": "Isehalduslik",
        "UNALLOCATED": "Ootab tegevust",
        "VIRTUAL": "Majutatud kontod",
        "PPA": "PPA reserv",
        "OWN_USE": "Omatarbeks"
      },
      "certificate_status": {
        "ONGOING_SALE": "Müük käib",
        "SOLD": "Müüdud",
        "EXPIRED": "Aegunud",
        "NON_TRANSFERRABLE": "Mitteülekantav",
        "RESERVED": "Reserveeritud",
        "WAITING_FOR_SALE": "Ootab müüki",
        "AVAILABLE": "Saadaval",
        "CANCELLED": "Tühistatud",
        "PENDING": "@:common.pending",
        "TRANSFERRED": "Üle kantud",
        "REVOKED": "Tühistatud registri poolt",
        "OWN_USE": "Omatarbeks"
      }
    },
    "noDataMessage": "Kuvamiseks pole midagi. Palun kohandage oma filtri valikuid.",
    "panel": {
      "title": "Graafik",
      "region_label": "Tabelis olevate sertifikaatide graafik",
      "mwh": "{mwh} MWh",
      "summary_rows": "ühelgi real · saadaval {available} MWh | {count} real · saadaval {available} MWh | {count} real · saadaval {available} MWh",
      "hide": "Peida graafik",
      "show": "Näita graafikut",
      "break_down_by": "Jaota",
      "segment_label": "Filtreeri tabel: {field} {value}, {mwh} MWh",
      "segment_inline": "{label} · {mwh} MWh",
      "segment_hint": "Klõpsa lõigul, et tabel selle järgi filtreerida"
    }
  },
  "inventory": {
    "actions": {
      "title": "Varude haldamine",
      "send": {
        "success": "Saatmisoperatsioon edukalt lõpule viidud",
        "prompt": "Kuhu soovite need päritolutunnised  saata? Palun täpsustage riik, mahud ja vastuvõtja registrinumber.",
        "simulated_response": "SaValmistun teie päritolutunnistuste saatmiseks."
      },
      "receive": {
        "success": "Vastuvõtuoperatsioon edukalt lõpule viidud",
        "prompt": "Kellelt ootate päritolutunnistusi? Palun täpsustage riik, mahud ja saatja registrinumber.",
        "simulated_response": "Anname teile saabumisel teada."
      },
      "buy": {
        "success": "Ostuoperatsioon edukalt lõpule viidud",
        "prompt": "Milliseid päritolutunnistusi soovite täna osta? Palun täpsustage riik, mahud ja vastuvõtja registrinumber.",
        "simulated_response": "Otsin saadaolevaid päritolutunnistusi ostmiseks. Siin on mõned pakkumised: 500 MWh Eestist, tuuleenergia, tootmiskuupäev: jaan 2024, hind: 2,50 €/MWh; 1000 MWh Lätist, päikeseenergia, tootmiskuupäev: veebr 2024, hind: 3,00 €/MWh; 750 MWh Leedust, hüdroenergia, tootmiskuupäev: märts 2024, hind: 2,75 €/MWh"
      },
      "sell": {
        "success": "Müügioperatsioon edukalt lõpule viidud",
        "prompt": "Milliseid päritolutunnistusi soovite müüki panna? Palun täpsustage riik ja mahud.",
        "simulated_response": "Lisan teie päritolutunnistused müüki. Anname teile teada, kui ostja leitakse."
      }
    }
  },
  "errors": {
    "genericNetworkError": "Võrguviga. Palun proovige uuesti.",
    "missingCompanyId": "Viga: Ettevõtte kontekst puudub.",
    "unsupportedFileType": "Mittetoetatud failitüüp. Palun laadige üles sobiv fail.",
    "fileTooLarge": "Fail on liiga suur. Maksimaalne suurus on 25MB."
  },
  "go_cancel": {
    "beneficiary_suggestions": {
      "placeholder": "Valige või sisestage kasusaaja"
    },
    "statements_title": "Tühistamise avaldused",
    "add_statement_button": "Lisa tühistamise avaldus",
    "no_statements_yet": "Tühistamise avaldusi pole veel lisatud. Klõpsake 'Lisa tühistamise avaldus' alustamiseks.",
    "more_statements": "avaldust veel",
    "statement_number": "Avaldus #{number}",
    "remove_statement_button": "Eemalda",
    "remove_statement_row_aria": "Eemalda tühistamise avalduse rida {index}",
    "statement_form_placeholder": "Täielik tühistamise avalduse vorm kuvatakse siin.",
    "confirm_order_button": "Vaata tühistamise käsk üle",
    "portfolio_items_title": "Valige portfelli üksused tühistamiseks",
    "portfolio_table_placeholder": "PortfolioItemsTable kuvatakse siin sertifikaatide valimiseks.",
    "upload_description": "Laadige üles dokument tühistamisavalduste ja kasusaaja teabe automaatseks eraldamiseks",
    "analysis_success_with_statements": "Dokumendist eraldati {count} tühistamisavaldust.",
    "analysis_success_no_statements": "Dokumendist ei leitud ühtegi tühistamisavaldust.",
    "analysis_complete_title": "Dokumendi analüüs lõpetatud",
    "analysis_shared_fields_inconsistent_warning": "Jagatud väljad on avalduste vahel vastuolus. Kinnitage käsitsi kasusaaja tüüp, periood ja tühistamise eesmärgi mall.",
    "shared_defaults_title": "Jagatud seaded kõikidele avaldustele",
    "shared_defaults_incomplete": "Täida jagatud seaded enne tühistamise käsu ülevaatamist.",
    "table_validation_hint": "Mõned read on puudulikud või vigased. Parandage esile tõstetud väljad, et jätkata.",
    "max_statements_reached": "Maksimaalselt {max} tühistamisavaldust. Jagage vajaduse korral mitmeks tellimuseks.",
    "analysis_truncated_warning": "Dokument sisaldas {total} avaldust, kuid laaditi ainult esimesed {max}. Esitage need eraldi tellimusena, seejärel laadige ülejäänud uuesti üles.",
    "form": {
      "prior_year_cutoff_specific": "{year}. aasta tühistamised ei ole enam lubatud — tähtaeg oli {cutoffDate}",
      "beneficiary_details_title": "Kasusaaja andmed",
      "beneficiary_name": {
        "label": "Kasusaaja",
        "placeholder": "Sisestage ettevõtte või isiku nimi"
      },
      "beneficiary_type": {
        "label": "Kasusaaja tüüp",
        "CONSUMER": "Tarbija",
        "ELECTRICITY_SELLER": "Elektrimüüja",
        "CONVERSION_PLANT_OPERATOR": "Konversioonitehase operaator"
      },
      "registry_code": {
        "label": "Ettevõtte ID",
        "short_label": "Ettevõtte ID",
        "placeholder": "Sisestage ettevõtte registrikood või isikukood"
      },
      "address": {
        "label": "Aadress",
        "placeholder": "Sisestage täielik aadress",
        "required_help": "Aadress on selle riigi jaoks kohustuslik"
      },
      "registry_country_region": {
        "label": "Registri riik/regioon",
        "placeholder": "Valige registri riik või regioon",
        "mismatch_warning": "Valitud register erineb sertifikaadi asukohast"
      },
      "cancellation_details_title": "Tühistamise andmed",
      "mwh_cancelled": {
        "label": "Tarbimine (MWh)",
        "short_label": "Tühistatud MWh",
        "placeholder": "0"
      },
      "period_start": {
        "label": "Tarbimisperioodi algus"
      },
      "period_end": {
        "label": "Tarbimisperioodi lõpp",
        "invalid_date_range": "Lõppkuupäev peab olema hilisem kui alguskuupäev",
        "cutoff_help": "{year}. aasta tarbimise tühistamised tuleb esitada enne 31. märtsi {nextYear}"
      },
      "cancellation_purpose": {
        "label": "Tühistamise eesmärk",
        "DISCLOSURE": "Avalikustamine",
        "GRID_LOSSES": "Võrgukaod",
        "SELF_CONSUMPTION": "Omatarbimine",
        "SUPPORT_SCHEME": "Toetuskava",
        "OTHER": "Muu"
      },
      "cancellation_purpose_text": {
        "label": "Tühistamise eesmärk",
        "placeholder": "Sisestage tühistamise eesmärk",
        "help": "Kirjeldage lühidalt, miks need sertifikaadid tühistatakse"
      },
      "global_operation_notes": {
        "label": "Üldised märkused tühistamise käsu kohta (valikuline)",
        "placeholder": "Sisestage üldised märkused kogu tühistamise käsu kohta..."
      },
      "keep_private": {
        "label": "Hoia tühistamise avaldus privaatsena",
        "hint": "Register ei loo selle tühistamise avalduse PDF-ile avalikult ligipääsetavat linki.",
        "ppa_hint": "Kehtib ainult Grexeli platvormil olevates registrites (LV, LT, DK, HR, HU, BE-FED, SE, FR); mujal seda ei arvestata."
      }
    },
    "no_portfolio_items_available": "Hetkel ei ole portfelli üksusi tühistamiseks saadaval.",
    "tooltip_beneficiary_name": "Juriidiline isik või eraisik, kes nimetatakse tühistamisavalduse kasusaajaks.",
    "tooltip_registry_country_region": "Register, kus tühistamine tehakse.",
    "tooltip_registry_code": "Ettevõtte registrikood või eraisiku isikukood — mitte käibemaksukohustuslase number. Ilmub tühistamisavaldusele.",
    "tooltip_address": "Kasusaaja registreeritud aadress või rajatise aadress. Mõne registri puhul nõutav.",
    "tooltip_mwh_cancelled": "Tühistatavate sertifikaatide kogus megavatt-tundides (MWh). 1 MWh = 1 sertifikaat.",
    "auto_select_certificates_checkbox": "Vali sertifikaadid automaatselt",
    "order_submitted_successfully": "Tühistamise käsk edukalt esitatud!",
    "order_submission_failed": "Tühistamise käsu esitamine ebaõnnestus. Palun proovige uuesti.",
    "buy_missing_request_sent": "Taotlus puuduvate päritolutunnistuste ostmiseks on saadetud. Võtame teiega peagi ühendust.",
    "buy_missing_request_failed": "Puuduvate päritolutunnistuste taotluse saatmine ebaõnnestus. Palun proovige uuesti või võtke ühendust toega.",
    "insufficient_inventory_warning": "Hoiatus: Varudes ei ole piisavalt päritolutunnistusi, et katta avaldustes määratud kogust MWh. Teil on saadaval {availableMwh} MWh, kuid vajalik on {neededMwh} MWh.",
    "buy_missing_gos_button": "Taotle puuduvaid päritolutunnistusi",
    "autoselect_failed": "Sertifikaatide automaatne valimine ebaõnnestus. Palun valige käsitsi või proovige uuesti.",
    "review_modal_statement_title": "Tühistamine kliendile: {beneficiaryName} registris",
    "region_mismatch_warning": {
      "title": "Registri mittevastavus",
      "message": "Mõned valitud sertifikaadid asuvad praegu teises registris kui tühistamiseks valitud sihtregister. Enne tühistamise töötlemist kanname need sertifikaadid üle valitud registrisse."
    },
    "any_aib_option": "Any AIB",
    "any_aib_address_hint": "Lisage tühistamise eesmärgile {'{'}address{'}'} kohatäide Any AIB kasutamisel. Saaja asukohana märgitakse avaldusele \"Europe\".",
    "address_placeholder_missing_warning": "Tühistamise eesmärk kasutab kohatäidet {'{'}address{'}'}, kuid vähemalt ühel saajal puudub aadress. Nende ridade puhul jäetakse tekst {'{'}address{'}'} muutmata.",
    "beneficiary_type_conflict_switch": "Kõik selle tühistuse avaldused esitatakse kasusaaja tüübiga {sharedType}, kuid {names} on varem kasutanud tüüpi {rememberedType}. Muutke jagatud kasusaaja tüüp tüübiks {rememberedType} või jätkake, kui varasem tüüp on aegunud.",
    "beneficiary_type_conflict_mixed": "Kõik selle tühistuse avaldused esitatakse kasusaaja tüübiga {sharedType}, kuid need kasusaajad on varem kasutanud teist tüüpi: {details}. Jätkake, kui varasemad tüübid on aegunud.",
    "accelerator_title": "Alusta dokumendist",
    "summary_order_title": "Tühistamise käsk",
    "summary_mwh_to_cancel": "MWh tühistamiseks",
    "summary_statements": "Avaldused",
    "summary_consumption_period": "Tarbimisperiood",
    "summary_certificates_selected": "Valitud sertifikaadid",
    "summary_mwh_value": "{mwh} MWh",
    "summary_ready": "Valmis kinnitamiseks",
    "summary_status_incomplete": "Täida tühistamise andmed",
    "summary_status_select": "Vali tühistatavad sertifikaadid",
    "summary_status_match": "Vali sertifikaate kokku {mwh} MWh",
    "summary_status_insufficient": "Sobivat laoseisu pole piisavalt",
    "no_data_short": "—",
    "summary_build_title": "Koosta oma käsk",
    "summary_step_beneficiary": "Lisa kasusaaja ja tarbimine",
    "summary_step_certificates": "Vali tühistatavad sertifikaadid",
    "summary_step_review": "Vaata üle ja kinnita käsk",
    "private_pill": "Privaatne avaldus",
    "statement_options_button_aria": "Avalduse {index} seaded",
    "statement_options_button_private_aria": "Avalduse {index} seaded — hoitakse privaatsena",
    "statement_private_tooltip": "Tühistamise avaldus hoitakse privaatsena",
    "carried_selection_summary": "Ülevaate valikust ei tulnud ühtegi rida. | Ülevaate valikust tuli {count} rida ({mwh} MWh). | Ülevaate valikust tuli {count} rida ({mwh} MWh).",
    "carried_selection_summary_partial": "Ülevaate valikust ei tulnud ühtegi rida. | Ülevaate valikust tuli {count} rida ({mwh} MWh, {partial}). | Ülevaate valikust tuli {count} rida ({mwh} MWh, {partial}).",
    "carried_selection_partial": "ükski pole osaline | {count} osaline | {count} osalist",
    "carried_selection_paused": "Automaatne valik on peatatud, et see neid ei asendaks.",
    "carried_selection_use_amount": "Kasuta kogusena {mwh} MWh",
    "carried_selection_clear": "Tühjenda ja vali automaatselt",
    "table_hint": "Loetletud on ainult tühistamiseks saadaolevad sertifikaadid. Märgitud read tühistatakse täielikult; klõpsa kogusel, et tühistada reast ainult osa.",
    "filter_shortfall": "Sinu filtritele vastab ainult {available} / {needed} MWh. Rohkemate sertifikaatide nägemiseks eemalda mõni filter.",
    "filter_shortfall_unavailable": "Sinu filtritele ei vasta ükski sertifikaat, vaja on {needed} MWh. Oma sertifikaatide nägemiseks eemalda punasega märgitud filter.",
    "summary_status_filter_shortfall": "Sinu filtritele ei vasta piisavalt sertifikaate"
  },
  "go_send": {
    "insufficient_inventory_warning": "Hoiatus: Varudes pole piisavalt GO-sid, et katta saatmistaotluses määratud MWh kogust. Teil on saadaval {availableMwh} MWh, kuid vajate {neededMwh} MWh.",
    "recipient_hosted_badge": "HOSTITUD",
    "recipient_hosted_helper": "Edastatakse selle ettevõtte hostitud kontole Solderas",
    "recipient_hosted_region_note": "Regioon määratakse saatmisel iga sertifikaadi kohta eraldi",
    "recipient_search_placeholder": "Otsi ettevõtte nime, registrikoodi või EECS järgi…",
    "recipient_no_results": "Vastavaid ettevõtteid ei leitud",
    "hosted_delivery_info": "Tarnimise üksikasjad haldab Soldera ja need määratakse automaatselt iga sertifikaadi kohta saatmise ajal.",
    "mixed_registry_selection_error": "Eri registrite sertifikaate ei saa saata ühes tellimuses. Palun saada need eraldi tellimustena.",
    "unit_price_pln_label": "Ühikuhind (PLN/MWh)",
    "unit_price_pln_help": "Lepingu ühikuhind PLN/MWh. Poola register (TGE) nõuab seda ja salvestab selle ülekandele endale."
  },
  "portfolio_instructions": {
    "description": "Kirjeldus",
    "ppa_name": "PPA nimi",
    "configuration": "Seadistus",
    "allocation_configuration": "Jaotuse seadistus",
    "delivery_configuration": "Tarne seadistus",
    "allocation_mode": "Jaotusrežiim",
    "allocate_all": "Kogu toodang",
    "allocate_percentage": "Protsent",
    "whole_production_info": "Kogu valitud seadmete toodang suunatakse sellele PPA-le.",
    "allocate_fixed_amount": "Suuna kindel kogus",
    "allocate_fixed_amounts": "Kindlad kogused",
    "total_mwh_label": "Kokku MWh",
    "allocate_fixed_amounts_per_year": "Suuna kindlad kogused aastas",
    "granularity_yearly": "Aastane",
    "granularity_quarterly": "Kvartaalne",
    "granularity_monthly": "Kuine",
    "granularity": "Täpsusaste",
    "leap_year_badge": "Liigaasta",
    "current_period_limit": "Suuna kindel kogus ({amount} {unit}) perioodile {periodLabel}",
    "apply_to_all_years": "Rakenda kõigile aastatele",
    "apply_to_all_years_tooltip": "Kopeeri need väärtused kõigile teistele aastatele (osalisi kvartaleid ei kopeerita)",
    "reset_year": "Lähtesta",
    "partial_quarter_badge": "Osaline",
    "partial_period_badge": "Osaline",
    "contract_range_required_for_granularity": "Määra PPA alguse ja lõpu kuupäevad all asuvas täitmise seadistuses, et konfigureerida kuiseid/kvartaalseid piiranguid.",
    "start_date_required_for_granularity": "Kuiste ja kvartaalsete piirangute jaoks on vajalik PPA alguskuupäev.",
    "end_date_must_follow_start": "Lepingu lõppkuupäev peab olema alguskuupäeval või pärast seda.",
    "invalid_limit_durations_for_granularity": "Piirangute kestused ei vasta valitud sammule. Loo piirangud uuesti või teisenda need valitud sammu jaoks.",
    "partial_period_hint_single": "Üks periood on osaline: {firstRange}.",
    "partial_period_hint_multiple": "{count} perioodi on osalised: {firstRange} → {lastRange}.",
    "confirm_granularity_switch_title": "Muuda jaotuse täpsusaste?",
    "confirm_granularity_switch_body": "Teil on nullist erinevad väärtused. Muutmisel jagatakse need uue täpsusastme järgi. Jätkata?",
    "granularity_switch_title": "Jaga olemasolevad väärtused ümber?",
    "granularity_switch_body": "Oled sisestanud väärtused {from} tasemel. Üleminekul {to} tasemele jagatakse need uuele täpsusastmele vastavalt ümber.",
    "granularity_switch_from": "Alates",
    "granularity_switch_to": "Kuni",
    "granularity_buckets": "{count} lahtrit aastas",
    "granularity_switch_note": "Aasta kogusummad säilivad.",
    "granularity_switch_confirm": "Jaga ümber",
    "matrix_year_total": "Aasta kokku: {total}",
    "year_issues_badge": "{count} viga",
    "matrix_grand_total": "Kogusumma: {total} MWh ({count} kirjet)",
    "percentage_to_allocate": "Jaotusprotsent",
    "select_devices": "Vali seadmed",
    "search_devices_placeholder": "Otsi {count} saadaolevat seadet...",
    "search_more_devices_placeholder": "{selected} valitud • Otsi {available} saadaolevat seadet",
    "loading_devices": "Laen seadmeid...",
    "all_devices_selected": "Kõik seadmed valitud",
    "devices_blocked_by_other_ppas": "Ülejäänud seadmed on kasutusel teistes PPA portfellides",
    "no_devices_available": "Seadmeid ei ole saadaval",
    "selected_devices": "Valitud seadmed",
    "selected_devices_summary": "{count} valitud",
    "add_devices": "Lisa seadmed",
    "allocate_percentage_display": "Suuna {percent}%",
    "devices_count_display": "{count} seade(t) valitud",
    "from_all": "Kõigist seadmetest",
    "no_instructions_set": "Juhised seadmata.",
    "editing_title": "Muudan: {name}",
    "upload_ppa_document": "Lae üles PPA dokument",
    "ppa_document_formats": "Toetatud PDF, DOC, DOCX failid",
    "ppa_document_upload_error": "Sobimatu PPA dokumendi formaat",
    "fixed_amounts_per_year": "Kindlad kogused aastas",
    "period_limits": "Perioodi piirangud",
    "add_period_limit": "Lisa perioodi piirang",
    "remove_period_limit": "Eemalda perioodi piirang",
    "select_year": "Vali aasta",
    "mwh_placeholder": "Sisesta MWh piirang",
    "fixed_amount_must_be_gt_zero": "Iga jaotus peab olema suurem kui 0 MWh",
    "update_success": "Portfelli juhised edukalt uuendatud.",
    "update_success_title": "Õnnestus",
    "remove_device": "Eemalda seade {deviceName}",
    "device_assigned_to_100_percent_ppa": "Seade '{deviceId}' on määratud 100% PPA-le ja peab olema eksklusiivselt määratud",
    "device_used_in_fixed_limit_ppa": "Seade '{deviceId}' on kasutusel PPA-s fikseeritud perioodilimiitidega ja seda ei saa määrata ühelegi teisele PPA-le",
    "device_exceeds_100_percent": "Seade '{deviceId}' ületab 100% PPA-de lõikes (kokku: {totalPercentage}%)",
    "device_cannot_mix_with_exclusive_mode": "Seadet '{deviceId}' ei saa kasutada {currentMode} režiimis, kuna see on juba määratud teistele PPA-dele",
    "fixed_amounts_mode": "kindlate koguste režiim",
    "all_mode": "kogu toodangu režiim"
  },
  "hold_strategy": {
    "customize_strategy_title": "Kohanda isehallatavate sertifikaatide strateegia",
    "about_hold_strategy": "Isehallatavate sertifikaatide kohta",
    "no_hold_instructions": "Isehallatavate sertifikaatide strateegia puudub",
    "create_hold_portfolio": "Loo isehallatavate sertifikaatide strateegia",
    "hold_portfolio": "Isehallatavad sertifikaadid",
    "percentage_to_hold": "Protsent, mida suunata isehaldusesse",
    "scope_all_label": "Globaalne hoidmine (kõik seadmed)",
    "scope_all_description": "Rakendub kõigile jaotamata sertifikaatidele.",
    "scope_specific_label": "Sihtitud hoidmine (konkreetsed seadmed)",
    "scope_specific_description": "Rakendub ainult valitud seadmetele. Teised liiguvad spotti.",
    "targeted_allocation_badge": "{percentage}% {deviceCount} seadmest"
  },
  "go_buy": {
    "volume_to_buy": "Ostetav maht",
    "procurement_fee": "Hanketasu",
    "purchase_summary": "Ostu kokkuvõte",
    "price_breakdown_title": "Hinna jaotus",
    "price_breakdown_description": "Hinnad jälgivad turu kolmanda osapoole indekseid, et pakkuda teile parimat hinda turul. Mahud hangitakse üle 3000 elektrijaama käest üle Euroopa. Agregeeritud automaatne hankimine tagab parima väärtuse.",
    "premiums": "Atribuutide lisatasud",
    "upload_description": "Laadige üles dokument, mis kirjeldab teie tootmisvajadusi",
    "ask_for_quote_button": "Küsi hinnapakkumist",
    "send_purchase_request_button": "Saada ostusoov",
    "purchase_request_submitted": "Ostusoov esitatud",
    "purchase_request_submitted_detail": "{volume} MWh ostusoov edukalt esitatud.",
    "agent_quote_prompt": "Esitage ostusoov ja Soldera korraldab hinnapäringu (RFQ) — indikatiivse pakkumise saate tavaliselt ühe tööpäeva jooksul",
    "modes": {
      "re100": "RE100",
      "cheapest": "Odavaim",
      "advanced": "Täpsem",
      "re100_help": "RE100: tuul + päike, COD ≤ 15 aastat, optimeeritud hind",
      "cheapest_help": "Odavaim: optimeeritud madalaim kulu, olles samal ajal nõuetekohane",
      "advanced_help": "Täpsem: kohanda kõiki atribuute"
    },
    "form": {
      "volume": {
        "label": "Ostetav maht (MWh)"
      },
      "operation_notes": {
        "label": "Märkmed (valikuline)",
        "placeholder": "Sisestage konkreetsed nõuded või märkused selle ostu kohta..."
      }
    },
    "certificate_scheme": "Sertifikaadiskeem"
  },
  "issuance_reporting": {
    "upload_file": "Lae fail üles",
    "export": "Eksport",
    "add_new": "@:common.add",
    "filters": {
      "period_start": "Alates kuust",
      "period_end": "Kuni kuuni",
      "all_devices": "Kõik seadmed",
      "all_statuses": "Kõik staatused"
    },
    "status": {
      "pending": "@:common.pending",
      "accepted": "Vastu võetud",
      "rejected": "Tagasi lükatud",
      "completed": "Lõpetatud"
    },
    "table": {
      "device": "Seade",
      "device_code": "Seadme kood",
      "total_production": "Kogu tootmine",
      "date": "Kuupäev",
      "actions": "Toimingud"
    },
    "file_upload": {
      "import_summary": "Imporditud kirjeid: {imported}. Tagasilükatud kirjeid: {rejected}.",
      "rejected_records": "Tagasilükatud kirjed",
      "rejected_record": "Kirje {index} · {device}",
      "country_label": "Riik",
      "select_country": "Vali riik",
      "title": "Lae üles tootmisandmete aruanne",
      "description": "Palun laadige üles oma tootmisandmete aruanne tabelivormis (Excel, CSV jne)",
      "upload_prompt": "Lohistage fail siia või klõpsake failide sirvimiseks",
      "upload_another": "Lae üles veel üks fail",
      "supported_formats": "Toetatud formaadid: .xlsx, .xls, .csv. Suurtest Exceli failidest võib olla vaja eemaldada kasutamata lehed ja vormindus või jagada need väiksemateks failideks.",
      "analyzing": "Faili analüüsimine...",
      "countries": {
        "ES": {
          "label": "Hispaania"
        },
        "PL": {
          "label": "Poola"
        }
      }
    },
    "no_data_for_period": "Perioodi kohta andmed puuduvad",
    "delete_record": "Kustuta kirje",
    "confirm_delete_record": "Kas olete kindel, et soovite selle kirje kustutada? Seda toimingut ei saa tagasi võtta.",
    "delete_success": "Kirje kustutamine õnnestus",
    "update_success": "Tootmisandmete uuendamine õnnestus",
    "create_success": "Tootmisandmete kirje edukalt loodud",
    "export_success": "Andmete eksport õnnestus",
    "file_upload_success": "Fail edukalt üles laetud. Loodud {created} kirjet {total}-st töödeldud kirjest.",
    "no_data": "Tootmisandmed puuduvad",
    "no_data_description": "Alustamiseks laadige üles tootmisandmed.",
    "pl_status": {
      "title": "Väljastamisandmete staatus",
      "production_data_received": "Tootmisandmed kätte saadud",
      "waiting_for_quarterly_application_submission": "Kvartaalse taotluse esitamine on ootel",
      "application_submitted_to_tge_registry": "Taotlus esitatud",
      "tge_registry_overdue_submission_deadline": "Kvartali taotluse esitamine on hilinenud",
      "goos_issued_successfully": "Päritolutunnistused edukalt väljastatud"
    },
    "pl_status_flags": {
      "application_fee_paid": "Taotluse tasu makstud",
      "application_fee_not_paid": "Taotluse tasu maksmata",
      "communication_with_tge_initiated": "Järelpärimine algatatud",
      "automatic_written_notice": "Automaatne kirjalik teade",
      "telephone_call": "Telefonikõne"
    },
    "import_not_trusted": "Failide import on saadaval pärast konto aktiveerimist. Abi saamiseks kirjuta support@soldera.org.",
    "company_required": "Väljastamise aruannete vaatamiseks vali ettevõte."
  },
  "links": {
    "trading_procedure": "https://www.soldera.org/et/vastavus/kauplemise-kord",
    "trading_procedure_text": "Soldera kauplemise kord"
  },
  "company_orders": {
    "rfq_timeline": {
      "submitted": "Hinnapäring (RFQ) esitatud",
      "quote_expected": "Indikatiivne pakkumine oodata hiljemalt {date}",
      "approval_gate": "Enne teie kinnitust ei osteta midagi"
    },
    "title": "Tehingud",
    "order_type": "Käsu tüüp",
    "portfolio": "Portfell",
    "total_selected_mwh": "Kogus",
    "order_starter": "Käsu algataja",
    "initiated_by": "Algataja",
    "order_date": "Käsu kuupäev",
    "date": "Kuupäev",
    "export_csv": "Ekspordi käsud CSV-na",
    "created": "Loodud",
    "updated": "Uuendatud",
    "confirm_order": "Kinnita käsk",
    "edit_order": "Muuda käsku",
    "edit_order_title": "Muuda ettevõtte käsku",
    "edit_order_success": "Käsk edukalt muudetud.",
    "edit_order_error": "Käsu muutmine ebaõnnestus.",
    "edit_order_load_error": "Käsu andmete laadimine muutmiseks ebaõnnestus.",
    "mwh_mismatch_warning": "Tühistamisaktide MWh kogus ({statementsMwh}) ei vasta valitud portfelli kogusele ({portfolioMwh}). Kohandage aktide MWh väärtusi või portfelli valikut, et need langeksid kokku.",
    "order_details": "Käsu üksikasjad",
    "order_information": "Käsu info",
    "portfolio_items_summary": "Portfelli üksuste kokkuvõte",
    "total_mwh": "Kokku MWh",
    "support_status": "Toetuse staatus",
    "associated_portfolio_items": "Seotud portfelli üksused",
    "no_portfolio_items": "Selle käsuga pole seotud portfelli üksusi.",
    "processing_result": "Töötlemise tulemus",
    "order_type_details": "{type} käsu üksikasjad",
    "order_types": {
      "SEND": "@:common.actions.send",
      "RECEIVE": "Võta vastu",
      "BUY": "Osta",
      "SELL": "Müü",
      "CANCEL": "Tühista",
      "BUY_AND_CANCEL": "Osta ja tühista"
    },
    "loading_portfolio_items": "Portfelli üksuste laadimine...",
    "view": "Vaata",
    "confirm": "Kinnita",
    "reject": "Keeldu",
    "confirm_all": "Kinnita kõik",
    "confirm_all_message": "Kas oled kindel, et soovid kinnitada kõik {count} ootel käsku? Töötlemine algab automaatselt.",
    "confirm_order_message": "Kas oled kindel, et soovid selle käsu kinnitada? Töötlemine algab automaatselt.",
    "reject_all": "Keeldu kõigist",
    "batch_confirm_success": "Kinnitati edukalt {count} käsku",
    "batch_confirm_partial": "Kinnitati {success} käsku, ebaõnnestus {failed}",
    "batch_reject_success": "Keelduti edukalt {count} käsust",
    "batch_reject_partial": "Keelduti {success} käsust, ebaõnnestus {failed}",
    "status": {
      "waiting_confirmation": "Ootab kinnitust",
      "pending": "Ootel",
      "pending_agent": "Käsitsi töötlemine",
      "processing": "Töötlemisel",
      "completed": "Lõpetatud",
      "failed": "Ebaõnnestus",
      "cancelled": "Tühistatud"
    },
    "send": {
      "recipient_information": "Saaja info",
      "company_name": "Ettevõtte nimi",
      "registry_country": "Registri riik",
      "eecs_account_id": "EECS konto ID",
      "internal_account_id": "Registri sisemine konto number",
      "unit_price_pln": "Ühikuhind (PLN/MWh)",
      "operation_notes": "Tegevuse märkmed",
      "portfolio_items_title": "Valige portfelli üksused saatmiseks"
    },
    "cancel": {
      "total_statements": "Kokku avaldusi",
      "total_mwh_cancelled": "Kokku tühistatud MWh",
      "statement": "Avaldus",
      "address": "@:common.address",
      "period": "@:cancellation.table.period",
      "purpose": "Eesmärk"
    },
    "sell": {
      "sale_summary": "Müügi ettevalmistus",
      "hold_to_spot_description": "See käsk liigutab valitud päritolutunnistused teie isehallatud portfellist portfelli „@:{'charts.values.portfolio_type.SPOT_MARKET_PRICE'}“ turumüügi jaoks.",
      "hold_to_min_price_description": "See käsk liigutab valitud päritolutunnistused teie isehallatud portfellist portfelli „@:{'charts.values.portfolio_type.SPOT_MIN_PRICE'}“ (miinimumhind €{minimumPrice}/MWh).",
      "process_information": "Protsessi info",
      "source_portfolio": "Algportfell",
      "destination_portfolio": "Sihtportfell",
      "operation_type": "Operatsiooni tüüp",
      "internal_portfolio_transfer": "Sisemine portfelli ülekanne"
    },
    "buy": {
      "purchase_summary": "Ostu kokkuvõte",
      "volume": "Maht",
      "total_price": "Koguhind",
      "go_specifications": "EAC spetsifikatsioon",
      "eac_source": "EAC allikas",
      "technology": "Tehnoloogia",
      "ecolabel": "Ekomärgis",
      "vintage": "Tootmisaasta",
      "support": "Toetus",
      "operation_notes": "Tegevuse märkmed",
      "purchase_mode": "Ostu režiim",
      "cod_requirement": "COD nõue",
      "matching": "Sobitamine",
      "order_summary": "Tellimuse kokkuvõte",
      "total_price_per_mwh": "Koguhind MWh kohta",
      "uploaded_contract": "Üleslaaditud leping",
      "contract": "Leping"
    },
    "generic": {
      "no_additional_details": "Täiendav info puudub."
    },
    "transactions": {
      "no_portfolio_items": "Selle tehingu päritolutunnistuste kohta puuduvad portfelli üksuste kirjed.",
      "transaction_type": "Tehingu tüüp",
      "awaiting_confirmation": "{count} käsk ootab kinnitust | {count} käsku ootab kinnitust",
      "in_progress": "{count} töös",
      "no_transactions": "Kuvatavaid tehinguid pole",
      "load_more": "Laadi rohkem",
      "more_transactions": "veel {count} tehingut",
      "registry_transaction": "Registritehing",
      "registry_transactions": "Registritehingud",
      "not_yet_in_registry": "Registris veel nähtav ei ole",
      "occurred": "Toimus",
      "connection": "Registriühendus",
      "volume": "Kogus",
      "certificates": "Sertifikaadid",
      "volume_in_registry": "Kogus registris",
      "certificates_in_registry": "Sertifikaadid registris",
      "counterparty": "Vastaspool",
      "counterparty_account": "Vastaspoole konto",
      "counterparty_eecs": "Vastaspoole EECS",
      "event_group": "Registritehingute grupp",
      "events": "Registritehingud",
      "event_count": "Tehinguid",
      "from": "Alates",
      "to": "Kuni",
      "total": "Kokku",
      "showing": "{shown} / {total}",
      "technology": "Tehnoloogia",
      "production_month": "Tootmiskuu",
      "production_device": "Tootmisseade",
      "production_device_count": "Seadmeid: {count}",
      "event_group_label": "{label} · {count}",
      "event_types": {
        "ISSUANCE": "Väljastamine",
        "INCOMING_TRANSFER": "Sissetulev ülekanne",
        "OUTGOING_TRANSFER": "Väljaminev ülekanne",
        "CANCEL": "Tühistamine",
        "EXPIRY": "Aegumine",
        "REVOCATION": "Tagasivõtmine"
      },
      "event_row_types": {
        "ISSUANCE": "Registri väljastamine",
        "INCOMING_TRANSFER": "Registri sissetulev ülekanne",
        "OUTGOING_TRANSFER": "Registri väljaminev ülekanne",
        "CANCEL": "Registri tühistamine",
        "EXPIRY": "Registri aegumine",
        "REVOCATION": "Registri tagasivõtmine",
        "ALLOCATION": "Portfelli jaotus",
        "RETURN": "Portfelli tagastus"
      },
      "event_group_types": {
        "ISSUANCE": "Registri väljastamised",
        "INCOMING_TRANSFER": "Registri sissetulevad ülekanded",
        "OUTGOING_TRANSFER": "Registri väljaminevad ülekanded",
        "CANCEL": "Registri tühistamised",
        "EXPIRY": "Registri aegumised",
        "REVOCATION": "Registri tagasivõtmised",
        "ALLOCATION": "Portfelli jaotused",
        "RETURN": "Portfelli tagastused"
      }
    }
  },
  "hosted_accounts": {
    "receive_new_gos_title": "Võta vastu uusi päritolutunnistusi",
    "receive_new_gos_description": "Seadista uus kavatsus võtta vastu päritolutunnistusi Soldera majutatud registrikontole. Kasutame seda sissetulevate ülekannete sobitamiseks.",
    "select_country": "Vali riik, kuhu soovid päritolutunnistusi vastu võtta",
    "select_country_placeholder": "Vali riik vastuvõtmiseks...",
    "select_country_first": "Jätkamiseks vali palun riik",
    "hosted_account": "Majutatud konto",
    "account_details_heading": "Jaga neid andmeid saatjaga",
    "transfer_identification_heading": "Tuvasta sissetulev ülekanne",
    "description": "Edasta need Soldera registri andmed päritolutunnistusi saatvatele osapooltele, et ülekanne jõuaks õigele kontole.",
    "company_name": "Ettevõtte nimi",
    "eecs_account": "EECS konto",
    "amount_mwh": "Kogus (MWh)",
    "sender_company_name": "Saatja ettevõtte nimi",
    "sender_eecs_account": "Saatja EECS konto",
    "counterparty_email": "Saatja e-post",
    "optional_notes_on_email": "Märkused teavituskirjale",
    "operation_notes_placeholder": "Lisa erijuhised või märkused...",
    "create_receive_order": "Loo vastuvõtutellimus",
    "create_order": "Loo vastuvõtutellimus",
    "advanced_options": "Täpsemad valikud",
    "company_name_copied": "Ettevõtte nimi kopeeritud lõikelauale!",
    "eecs_account_copied": "EECS konto kopeeritud lõikelauale!",
    "copy_fallback": "Kopeeritud lõikelauale (varumeetod)",
    "copy_failed": "Kopeerimine ebaõnnestus. Palun tee seda käsitsi.",
    "no_regions_unlocked": "Teie organisatsioonile pole veel majutatud kontosid seadistatud.",
    "contact_us_cta": "Võta meiega ühendust",
    "contact_us_title": "Soovid vastu võtta mõnes teises riigis?",
    "contact_us_title_no_accounts": "Valmis päritolutunnistusi vastu võtma?",
    "contact_us_description": "Võta meiega ühendust, et osta rohkem majutatud kontosid.",
    "contact_us_description_no_accounts": "Võta meiega ühendust oma esimese majutatud konto seadistamiseks.",
    "contact_us_button": "Võta meiega ühendust",
    "no_accounts_configured": "Majutatud kontosid pole seadistatud. Alustamiseks võta meiega ühendust.",
    "company_id_missing": "Ettevõtte ID puudub"
  },
  "receive_order": {
    "repeating_label": "Korduv ajakava",
    "repeating_options": {
      "none": "Ühekordne",
      "monthly": "Igakuine",
      "quarterly": "Kord kvartalis",
      "half_yearly": "Poolaastane",
      "yearly": "Aastane"
    },
    "at_least_one_required": "Täida vähemalt üks nendest väljadest, et aidata meil ülekannet tuvastada"
  },
  "portfolios": {
    "title": "Portfellid",
    "description": "Vaata ja halda kõiki oma portfelli jaotusi. Nimeta ümber, eralda, ühenda või liiguta kirjeid portfellide vahel.",
    "show_items": "Kirjeid pole | Näita 1 kirjet | Näita {count} kirjet",
    "merge": "Ühenda",
    "split": "Eralda",
    "merge_modal_title": "Ühenda portfellid",
    "source_portfolio": "Lähteportfell",
    "target_portfolio": "Sihtportfell",
    "select_target_placeholder": "Vali sihtportfell...",
    "merge_confirm_warning": "Kõik kirjed portfellist {source} teisaldatakse portfelli {target}. Lähteportfell kustutatakse jäädavalt.",
    "merge_info": "Ühendamise üksikasjade nägemiseks vali sihtportfell. Lähteportfell kustutatakse pärast ühendamist.",
    "volume_and_items": "{volume} MWh • {count} kirjet",
    "split_modal_title": "Eralda portfell",
    "split_select_items": "Vali sertifikaadid teisaldamiseks",
    "split_new_name_label": "Uue portfelli nimi",
    "split_new_name_placeholder": "nt Partii B",
    "split_default_name": "Eraldatud portfellist {name} kuupäeval {date}",
    "items_selected": "Ühtegi kirjet pole valitud | 1 kirje valitud | {count} kirjet valitud",
    "confirm_merge": "Kinnita ühendamine",
    "confirm_split": "Kinnita eraldamine",
    "section_inventory": "Laoseis",
    "section_inventory_desc": "Saadaval olevad PT-d toiminguteks nagu saatmine, tühistamine jne.",
    "section_spot": "Spot-müük",
    "section_spot_desc": "PT-d, mis on müügijärjekorras spot-turul.",
    "section_ppa": "PPA",
    "section_ppa_desc": "Reserveeritud tulevaste kohustuste jaoks.",
    "section_forwards": "Tulevikutehingud",
    "section_forwards_desc": "Reserveeritud tulevikumüükide jaoks.",
    "volume_label_inventory": "Saadaval",
    "volume_label_spot": "Müügijärjekorras",
    "volume_label_ppa": "Reserveeritud",
    "volume_label_forwards": "Reserveeritud",
    "badge_own_registry": "Ühendatud",
    "badge_soldera_account": "Majutatud",
    "badge_spot_market": "Turuhind",
    "badge_spot_min": "Min {price} EUR",
    "badge_spot_min_default": "Miinimumhind",
    "badge_stx": "STX",
    "badge_ppa": "PPA",
    "badge_forward": "Tulevikutehing",
    "badge_default": "Vaikimisi",
    "tooltip_own_registry": "Päritolutunnistused ettevõtte ühendatud EECS registrikontol",
    "tooltip_soldera_account": "Päritolutunnistused Soldera majutatud kontol ettevõtte nimel",
    "tooltip_spot_market": "Müüdud kehtiva turuhinnaga",
    "tooltip_spot_min": "Müüdud ainult siis, kui turuhind vastab miinimumkünnisele",
    "tooltip_default": "Jaotamise vaikimisi portfell. Seda ei saa liita.",
    "view_ppa_config": "Seadista",
    "view_forwards": "Vaata tulevikutehinguid",
    "move_items": "Liiguta",
    "move_modal_title": "Liiguta kirjeid",
    "move_modal_desc": "Vali sihtportfell ja märgi kirjed, mida soovid liigutada.",
    "move_target": "Sihtportfell",
    "select_move_target": "Vali sihtkoht...",
    "confirm_move": "Kinnita liigutamine",
    "no_portfolios": "Selle jaotise jaoks portfelle ei leitud.",
    "empty_inventory": "Hetkel pole laoseisus PT-sid. PT-d ilmuvad siia pärast vastuvõtmist või ostmist.",
    "empty_portfolio": "Sellel portfellil pole kirjeid.",
    "show_empty": "Näita {count} tühja portfelli",
    "hide_empty": "Peida tühjad portfellid",
    "badge_own_use": "Ei ole kaubeldav",
    "tooltip_own_use": "Registris omatarbeks märgitud päritolutunnistused. Neid ei saa müüa, üle kanda ega tühistada."
  },
  "production_strategy": {
    "title": "Tootmisstrateegia",
    "overview": "Ülevaade",
    "ppa_settings": "PPA seaded",
    "self_managed_settings": "Isehallatavad seaded",
    "spot_settings": "Spot-müügi seaded",
    "issuance_report": "Väljastusaruanne",
    "forward_commitments": "Tulevikukohustused",
    "whole_year": "Järgmised 12 kuud",
    "next_year": "Järgmine aasta",
    "from_this_month_onward": "Alates sellest kuust",
    "bulk_issuance_report": "TSO deklaratsioon Excel",
    "generating_report": "Genereerin...",
    "generating_report_progress": "Genereerin... {current}/{total}",
    "report_duration_hint": "Iga ettevõtte andmed päritakse registrist ükshaaval, seega võib see aega võtta. Võid lehelt lahkuda ja hiljem tagasi tulla.",
    "download_report": "Laadi aruanne alla",
    "generate_new_report": "Genereeri uus",
    "report_generated_at": "Genereeritud {time}",
    "report_failed": "Ebaõnnestus - Proovi uuesti",
    "bulk_issuance": {
      "button_text": "Väljasta kõik päritolutunnistused",
      "title": "Väljasta kõik päritolutunnistused",
      "description": "Valige tootmisperiood ja ettevõtted väljastamiseks:",
      "production_period": "Tootmisperiood",
      "period_error": "Alguskuu peab olema väiksem või võrdne lõppkuuga",
      "companies_label": "@:common.companies",
      "no_companies": "Selle konto jaoks ei leitud HKNR ettevõtteid.",
      "confirm_all": "Kinnita kõik deklaratsioonid",
      "confirm_title": "Kinnita masskinnistamine",
      "confirm_message": "Väljastatakse päritolutunnistused {count} ettevõtte(te)le. Kui ettevõttel puuduvad seadmed, jäetakse see vahele.\n\n\"Proof of origin/Herkunftsnachweis\" tekst jäetakse vormis tühjaks.\n\"Subsidy for electricity generation/Förderung der Stromerzeugung\" jäetakse vormis nii nagu on.\n\nKas soovite jätkata?",
      "cancel_title": "Tühista masskinnistamine",
      "cancel_message": "Kas olete kindel, et soovite tühistada? Juba väljastatud sertifikaate ei saa tagasi võtta.",
      "already_processed": "Juba töödeldud ettevõtted:",
      "in_progress": "Töötlemisel",
      "status": {
        "pending": "@:common.pending",
        "in_progress": "Töötlemine...",
        "completed": "{count} paigaldis(t) esitatud",
        "skipped": "Vahele jäetud (midagi väljastada pole)",
        "error": "Viga"
      }
    },
    "yearly_allocations": "Aastased eraldised",
    "production_allocations": "Tootmise jaotused",
    "company_production": "Ettevõtte tootmine",
    "show_all_companies": "Kuva kõik ettevõtted",
    "not_available_consolidated": "Pole saadaval koondvaates",
    "ppa": "PPA",
    "agreements": "lepingut",
    "ppa_agreements": "PPA lepingud",
    "documents": "@:common.documents",
    "display_name": "Kuvatav nimi",
    "no_display_name": "Kuvatav nimi pole saadaval",
    "display_name_help": "Automaatselt genereeritud tehingu üksikasjade põhjal",
    "action_instructions": "Tegevusjuhised",
    "execution_configuration": "Teostuse seadistus",
    "delivery_method": "Tarneviis",
    "automatic": "Tee automaatselt",
    "manual": "Küsi kinnitust",
    "automatic_explainer": "süsteem teeb tehingu planeeritud kuupäeval automaatselt — käsitsi kinnitust pole vaja.",
    "manual_explainer": "planeeritud täitmisajal loob süsteem ettevõtte käsu, mis tuleb enne teostamist käsitsi kinnitada.",
    "execution_method": "Teostusviis",
    "execution_method_aria": "Teostusviis",
    "delivery_method_aria": "Tarneviis",
    "delivery_timing": "Tarneaeg",
    "execution_timing": "Teostuse ajastus",
    "yearly": "Kord aastas",
    "half_year": "Kord poolaastas",
    "quarterly": "Kord kvartalis",
    "monthly": "Kord kuus",
    "fixed_dates": "Fikseeritud kuupäevad",
    "fixed_dates_count": "{count} fikseeritud kuupäeva",
    "fixed_delivery_dates": "Fikseeritud tarnekuupäevad",
    "add_date": "Lisa kuupäev",
    "end_date": "Lõppkuupäev",
    "ppa_contract_end_date": "PPA lepingu lõppkuupäev",
    "end_date_help": "Millal PPA leping lõpeb",
    "ppa_contract_start_date": "PPA lepingu alguskuupäev",
    "start_date_help": "Millal PPA leping algab (nõutav kuiste/kvartaalsete piirangute jaoks)",
    "transaction_type": "Tehingu tüüp",
    "send": "Saada",
    "cancel": "@:common.cancel",
    "send_help": "Kanna GO-d saajale",
    "cancel_help": "Tühista GO-d kasusaaja kasuks",
    "send_details": "Saatmise üksikasjad",
    "cancel_details": "Tühistamise üksikasjad",
    "recipient_company": "Saaja ettevõte",
    "recipient_country": "Saaja riik",
    "recipient_eecs_account": "Saaja EECS konto",
    "recipient_internal_account_number": "Registri sisemine konto number",
    "recipient_internal_account_help": "Valikuline. Vajalik ainult registrites, mis kasutavad alamkontosid.",
    "recipient_internal_account_placeholder": "Valikuline alamkonto ID",
    "notes": "Märkmed",
    "notes_placeholder": "Valikulised märkmed sellele PPA-le",
    "counterparty_details": "Vastaspoole andmed",
    "transaction_type_aria": "Tehingu tüüp",
    "q4_production_execution_date": "Q4 teostuskuupäev:",
    "q1_production_execution_date": "Q1 teostuskuupäev:",
    "q2_production_execution_date": "Q2 teostuskuupäev:",
    "q3_production_execution_date": "Q3 teostuskuupäev:",
    "h1_production_delivery_date": "H1 tootmise tarnekuupäev:",
    "h2_production_delivery_date": "H2 tootmise tarnekuupäev:",
    "h3_production_delivery_date": "H3 tootmise tarnekuupäev:",
    "h4_production_delivery_date": "H4 tootmise tarnekuupäev:",
    "allocation_mode_aria": "Eraldusviis",
    "remove_recurring_date": "Eemalda korduv kuupäev",
    "analyze_files": "Analüüsi faile",
    "yearly_delivery_day": "Kuupäev 1 (Aastane tarne)",
    "half_year_delivery_days": "Poolaasta tarnekuupäevad",
    "quarterly_delivery_days": "Kvartaalsed tarnekuupäevad",
    "monthly_delivery_day": "Kuu tarnekuupäev",
    "last_day_of_month": "Kuu viimane päev",
    "recurring_delivery_dates": "Korduvad tarnekuupäevad",
    "recurring_execution_dates": "Korduvad teostuskuupäevad",
    "recurring_dates_description": "Vali päeva+kuu kombinatsioonid, mis korduvad igal aastal kuni PPA lõppkuupäevani",
    "recurring_dates_description_monthly": "Vali kuu päev, mil teostus toimub.",
    "recurring_dates_description_quarterly": "Määra iga kvartali teostuskuupäevad (näidatud kasutuskorras).",
    "recurring_dates_description_half_year": "Vali teostuskuupäevad esimese ja teise poolaasta jaoks.",
    "recurring_dates_description_yearly": "Vali üks aastane teostuskuupäev.",
    "recurring_dates_description_fixed_dates": "Lisa teostuskuupäevad, mis korduvad lepingus järjestikku.",
    "add_recurring_date": "Lisa korduv kuupäev",
    "first_half": "Kuupäev 1 - Esimene poolaasta",
    "second_half": "Kuupäev 2 - Teine poolaasta",
    "date_1_q1": "Kuupäev 1 - Q1",
    "date_2_q2": "Kuupäev 2 - Q2",
    "date_3_q3": "Kuupäev 3 - Q3",
    "date_4_q4": "Kuupäev 4 - Q4",
    "quarter_range_q1": "(Jaan-Märts)",
    "quarter_range_q2": "(Apr-Juuni)",
    "quarter_range_q3": "(Juuli-Sept)",
    "quarter_range_q4": "(Okt-Dets)",
    "thinking": "Mõtlen ...",
    "forward_sales": "Tulevikumüük",
    "forward_sales_overview": {
      "title": "Tulevikumüügi ülevaade"
    },
    "forward_pools_list": {
      "title": "Sinu aktiivsed kogumid",
      "empty": "Sinu ettevõtted ei kuulu ühtegi aktiivsesse kogumisse.",
      "load_failed": "Kogumeid ei õnnestunud laadida."
    },
    "forward_materials": {
      "description": "Soldera tulevikumüügi teenus on loodud selleks, et aidata Sul kindlustada prognoositav tulu ja vähendada hinnakõikumiste riske, ilma et peaksid ise igapäevaselt tulevikumüükide haldamisega tegelema.",
      "outlook_info_1": "Saa teada peamistest turutrendidest ja vaata, kuidas hinnad on ajalooliselt liikunud.",
      "outlook_info_2": "Mõista, kuidas Soldera tulevikumüügi teenus aitab Sul tulu kindlustada.",
      "strategy_title": "Soldera tulevikumüügi kauplemisstrateegia",
      "strategy_info": "Saa üksikasjalikku teavet, kuidas me Sinu nimel tulevikumüüke teostame.",
      "framework_title": "Tulevikumüügi raamistik",
      "framework_info": "Vaata üle kõigi Soldera kaudu tehtavate tulevikumüükide õiguslikud tingimused."
    },
    "of_projected_production_per_quarter": "prognoositud toodangust kvartalis",
    "hedged": "Maandatud",
    "already_committed": "Juba pühendunud",
    "for_upcoming_sales": "Tulevasteks müükideks",
    "self_managed_certificates": "Isehallatavad sertifikaadid",
    "self_manage": "Isehaldus",
    "allocation": "Jaotus",
    "allocated": "Jaotatud",
    "spot_sale": "Spot-müük",
    "sell_at_highest_bid": "Müü kõrgeima pakkumise eest",
    "reserved_for_ppas": "Reserveeritud PPA-dele",
    "hedged_for_forward_sales": "Maandatud tulevikumüügiks",
    "committed_forward": "Seotud forward",
    "forward_estimate": "hinnang",
    "forward_estimate_note": "Hinnanguline osa jagatud kogumist",
    "to_be_sold": "Müüki pandav",
    "to_be_sold_description": "Forward-müügiks pakutud, kuid veel müümata maht, paigutatud kuudesse, kus pärast olemasolevaid kohustusi jääb toodangut üle.",
    "sell_all_remaining_spot": "Müü kõik ülejäänud spot-turul",
    "ppa_allocation_card": "PPA jaotuse kaart",
    "forward_allocation_card": "Tulevikumüügi jaotuse kaart",
    "self_managed_allocation_card": "Isehallatavate sertifikaatide jaotuse kaart",
    "spot_allocation_card": "Spot-müügi jaotuse kaart",
    "wizard_step_action": "Tegevus",
    "wizard_step_allocation": "@:production_strategy.allocation",
    "wizard_step_execution": "Täitmine & ülevaatus",
    "wizard_step_1_hint": "Lohista leping automaatseks täitmiseks või jätka käsitsi",
    "show_all_as_one_form": "Näita kõik ühe vormina",
    "new_ppa_portfolio": "Uus PPA portfell",
    "edit_ppa_portfolio": "Muuda PPA portfelli",
    "ppa_modal_crumb": "Tootmisstrateegia · PPA",
    "step_x_of_y": "Samm {current} / {total}",
    "save_ppa": "Salvesta PPA",
    "prefill_from_document": "Eeltäida dokumendist",
    "portfolio_name_title": "Portfelli nimi",
    "portfolio_name_desc": "Kuidas see PPA kuvatakse sinu töölaudadel.",
    "contract_dates_title": "Lepingu kuupäevad",
    "contract_dates_desc": "Millal PPA leping algab ja lõpeb.",
    "action_title": "Tegevus",
    "action_desc": "Mis peaks juhtuma selle PPA GO-dega.",
    "allocation_title": "@:production_strategy.allocation",
    "allocation_desc": "Kui palju toodangut on kaetud.",
    "devices_title": "Seadmed",
    "devices_desc": "Millised jaamad annavad energiat.",
    "execution_title": "Täitmine",
    "execution_desc": "Millal ja kuidas tehingud toimuvad.",
    "review_title": "Ülevaatus",
    "review_desc": "Mis juhtub, kui salvestad.",
    "notes_title": "Märkmed",
    "notes_desc": "Lisa selle PPA kohta siseinfot.",
    "upload_ppa_to_auto_fill": "Lae üles PPA dokument automaatseks täitmiseks",
    "upload_ppa_auto_fill_subtitle": "Lohista PDF, DOC või DOCX — eraldame, mida saame. Kõike saab hiljem muuta.",
    "or_skip_and_continue": "või jäta vahele ja jätka allpool",
    "what_is_this_ppa_for": "Milleks see PPA on?",
    "send_certificates": "Saada sertifikaadid",
    "cancel_on_behalf": "Tühista kellegi nimel",
    "send_label": "@:common.actions.send",
    "send_explainer": "kannab sertifikaadid üle vastaspoole registrikontole — nad saavad need kätte ja võivad ise kasutada või tühistada.",
    "cancel_on_behalf_label": "Tühista kellegi nimel",
    "cancel_on_behalf_explainer": "tühistab sertifikaadid vastaspoole nimel — midagi ei kanta üle, sertifikaadid tarbitakse nende nimele.",
    "not_set": "Määramata",
    "no_devices_selected": "Seadmeid pole valitud",
    "review_cancel_for": "Tühistatud {name} jaoks",
    "review_cancel_generic": "Tühista kellegi nimel",
    "review_n_periods": "{count} perioodi",
    "review_devices_summary": "{count} valitud · {mw} MW",
    "review_counterparty_label": "Vastaspool",
    "review_allocation_label": "@:production_strategy.allocation",
    "review_devices_label": "Seadmed",
    "review_execution_label": "Täitmine",
    "automatic_short": "Automaatne",
    "manual_short": "Käsitsi"
  },
  "ecolabels": {
    "documents_modal": {
      "title": "Dokumendid — {name}",
      "open_hint": "Vaata ja laadi alla algselt üles laaditud dokumendid",
      "empty": "Sellel seadmel pole sulle nähtavaid dokumente.",
      "download": "Laadi alla"
    },
    "fuzzy_search_placeholder": "Otsi seadmeid nime, registreerimis-ID või aadressi järgi…",
    "renewable_types": {
      "solar": "Päike",
      "wind": "Tuul",
      "hydro": "Hüdro",
      "geothermal": "Geotermaal",
      "bioenergy": "Bioenergia",
      "marine": "Mereenergia",
      "other": "Muu"
    },
    "statuses": {
      "pending_review": "Ülevaatamisel",
      "pre_approved": "Eelkinnitatud",
      "rejected": "Tagasi lükatud",
      "approved": "Kinnitatud",
      "not_approved": "Kinnitamata"
    },
    "upload": {
      "add_manually": "Lisa seade käsitsi",
      "pending_hint": "Suured failid võivad võtta mõne minuti — vahepeal saad ridu edasi muuta.",
      "wait_for_ai": "Enne esitamist oota, kuni assistent lõpetab",
      "duplicate_of_row_named": "Rida {row} („{name}“) selles üleslaadimises",
      "open_in_catalog": "Ava kataloogis",
      "back_to_catalog": "Tagasi seadmete kataloogi",
      "title": "Esita seadmed eelkinnituseks",
      "subtitle": "Laadi üles seadmete nimekiri (tabel, registri väljavõte, e-kiri või PDF) ja vaata read enne esitamist üle.",
      "seller_company": "Müüja ettevõte",
      "no_seller_company": "Sinu kontoga pole seotud ühtegi volitatud müüjaettevõtet. Ligipääsu saamiseks võta ühendust EKOenergyga.",
      "chat_title": "Laadi üles seadmete nimekiri",
      "review_title": "Vaata eraldatud seadmed üle",
      "review_counts": "{total} rida, {selected} valitud",
      "select_all": "Vali kõik",
      "select_all_without_duplicates": "Vali kõik ilma duplikaatideta",
      "check_and_next": "Märgi ja edasi",
      "irec_relaxed_hint": "Tuvastatud I-REC seadmena Evidenti lingi / seadme koodi järgi. Tehnoloogia ja asukoht on siin valikulised — ülevaatajad kontrollivad neid Evidentis.",
      "irec_lookup_loading": "Otsime seadet Evidenti seadmeregistrist…",
      "irec_lookup_found": "Seadme andmed täideti Evidenti seadmeregistrist — kontrollige neid ja vajadusel muutke. Tehnoloogia ja asukoht on siin valikulised; ülevaatajad kontrollivad neid Evidentis.",
      "irec_lookup_not_found": "Seda koodi Evidenti seadmeregistrist ei leitud. Palun sisestage seadme nimi ja riik ise; tehnoloogia ja asukoht jäävad valikuliseks.",
      "irec_lookup_unavailable": "Evidenti seadmeregistriga ei õnnestunud ühendust saada. Palun sisestage seadme nimi ja riik ise; tehnoloogia ja asukoht jäävad valikuliseks.",
      "deselect_all": "Tühista valik",
      "empty_state": "Üleslaaditud failist eraldatud seadmed ilmuvad siia ülevaatamiseks.",
      "flags": "Kontrollid",
      "flag_ok": "OK",
      "flag_incomplete": "Puuduvad väljad",
      "all_fields": "Kõik väljad",
      "flag_duplicate": "{count} duplikaat?",
      "flag_duplicate_hint": "Leiti võimalikud duplikaadid — klõpsa vastete nägemiseks",
      "flag_reg_id": "ID: {quality}",
      "flag_reg_id_hint": "Registreerimis-ID-d ei õnnestunud tuntud registrivormingute vastu valideerida",
      "blocked_row_hint": "Rea lubamiseks täida puuduvad kohustuslikud väljad",
      "blocked_rows_note": "{count} rida on blokeeritud puuduvate kohustuslike väljade tõttu",
      "field_address_or_coordinates": "Aadress või koordinaadid",
      "missing_fields": "Puudub: {fields}",
      "duplicate_details": "Võimalikud duplikaadid",
      "duplicate_what_to_do": "Kui need on päriselt erinevad jaamad, esita lihtsalt — ülevaatajad näevad samu märgiseid. Kui rida on tõesti duplikaat, kustuta üks neist (✕).",
      "show_row": "Näita rida",
      "duplicate_of_catalog": "Olemasolev seade “{name}” ({status})",
      "duplicate_of_row": "Rida {row} selles üleslaadimises",
      "submit_selected": "Esita {count} seade(t) ülevaatamiseks",
      "submitted_title": "{count} seade(t) esitatud ülevaatamiseks",
      "submitted_flagged": "{count} võimalikku duplikaadipaari märgiti ülevaatajatele.",
      "view_submissions": "Vaata esitusi",
      "upload_more": "Laadi veel üles"
    },
    "submissions": {
      "collapse_all": "Ahenda kõik",
      "title": "Esitused",
      "subtitle_admin": "Vaata esitatud seadmed üle: kontrolli märgiseid, seejärel kinnita või lükka tagasi.",
      "subtitle_seller": "Sinu esitatud seadmepartiid ja nende ülevaatuse seis.",
      "submit_devices": "Esita seadmed",
      "empty": "Seadmete esitusi pole veel.",
      "submitted_on": "Esitatud",
      "seller": "Müüja",
      "devices": "Seadmed",
      "status": "Staatus",
      "pending_badge": "{count} ootel",
      "approved_badge": "{count} kinnitatud",
      "rejected_badge": "{count} tagasi lükatud",
      "flagged_badge": "{count} märgistatud",
      "duplicates_column": "Duplikaadid",
      "details": "Detailid",
      "duplicates_badge": "{count} võimalikku",
      "duplicates_hint": "Võimalikud duplikaadid — klõpsa ülevaatamiseks ja lahendamiseks",
      "actions": "Tegevused",
      "approve": "Kinnita",
      "reject": "Lükka tagasi",
      "rejection_reason_placeholder": "Tagasilükkamise põhjus (nähtav müüjale)…",
      "no_duplicates": "Sellel seadmel pole lahendamata duplikaadikandidaate.",
      "approved_toast": "{name} kinnitatud",
      "override_confirm": "Sellel seadmel on lahendamata suure kindlusega duplikaadid. Kas kinnitada siiski?",
      "approve_anyway": "Kinnita siiski",
      "filter_pending": "Ootab ülevaatust",
      "filter_all": "Kõik",
      "no_pending": "Ükski taotlus ei oota ülevaatust.",
      "show_all": "Näita kõiki taotlusi",
      "merged_badge": "{count} liidetud",
      "internal_notes": "Sisemärkmed",
      "internal_notes_hint": "Nähtav ainult EKOenergy tiimile — müüjad neid ei näe.",
      "note_placeholder": "Lisa tiimile märge…",
      "add_note": "Lisa märge",
      "save_changes": "Salvesta muudatused",
      "device_saved": "Seade uuendatud",
      "invalid_number_fields": "Laiuskraad, pikkuskraad või võimsus ei ole korrektne arv. Midagi ei salvestatud."
    },
    "duplicates": {
      "title": "Duplikaadid",
      "subtitle": "{pending} kandidaatpaari ootab ülevaatamist. Otsused on lõplikud.",
      "filter_pending": "Ootel",
      "scan": "Otsi duplikaate",
      "scan_started": "Duplikaatide otsing käivitatud — uued paarid ilmuvad peagi.",
      "empty": "Selles vaates pole duplikaadikandidaate. Puhas töö!",
      "load_more": "Näita rohkem ({shown} / {total})",
      "device_a": "Seade A",
      "device_b": "Seade B",
      "this_submission": "See esitus",
      "existing_device": "Olemasolev kataloogiseade",
      "newer_entry": "Uuem kirje",
      "older_entry": "Vanem kirje",
      "coordinates": "Koordinaadid",
      "not_duplicate": "Pole duplikaat",
      "keep_a": "Liida, jäta A",
      "keep_b": "Liida, jäta B",
      "merge_confirm": "Kas liita see paar ja jätta alles “{name}”? Teine kirje arhiveeritakse ja selle dokumendid tõstetakse üle.",
      "confirm_merge": "Kinnita liitmine",
      "resolved_toast": "Paar lahendatud",
      "ask_ai": "Küsi AI-lt",
      "ai": {
        "duplicate": "AI: duplikaat",
        "not_duplicate": "AI: pole duplikaat",
        "unsure": "AI: ebakindel"
      },
      "statuses": {
        "not_duplicate": "Pole duplikaat",
        "merged": "Liidetud"
      },
      "reasons": {
        "registration_id_exact": "Sama registreerimis-ID",
        "registration_id_overlap": "Registreerimis-ID-d kattuvad",
        "registration_id_suspect_overlap": "ID-d kattuvad (madal usaldus)",
        "name_exact": "Sama nimi",
        "name_exact_distinct_ids": "Sama nimi, erinevad registri ID-d",
        "name_fuzzy": "Sarnane nimi {detail}",
        "coords_within_250m": "250 m raadiuses"
      }
    },
    "title": "Ökomärgised",
    "description": "Halda ökomärgisega sertifitseeritud taastuvenergia seadmeid",
    "add_device": "Lisa seade",
    "edit_device": "Muuda seadet",
    "ai_upload": "AI üleslaadimine",
    "devices_selected": "seadet valitud",
    "bulk_delete": "Kustuta valitud",
    "export_csv": "Ekspordi CSV",
    "no_access_title": "Puudub ligipääs EKOenergy registrile",
    "no_access_contact": "Ligipääsu saamiseks võta ühendust: {0}.",
    "no_devices": "Ökomärgise seadmeid ei leitud. Alustamiseks lisa esimene seade.",
    "showing_count": "Kuvatakse: {filtered} / {total} seadmest",
    "total_count": "Seadmeid kokku: {total}",
    "devices_heading": "Ökomärgise seadmed",
    "device_saved": "Seade salvestatud",
    "device_deleted": "Seade kustutatud",
    "devices_created": "Seadmed loodud",
    "confirm_delete": "Kas soovid kindlasti kustutada {name}?",
    "confirm_bulk_delete": "Kas soovid kindlasti kustutada {count} seadet?",
    "bulk_deleted": "{count} seadet kustutatud",
    "columns_selected": "{count} veergu",
    "select_columns": "Veerud",
    "add_devices": "Lisa seadmeid",
    "add_devices_description": "Laadi dokument üles AI-põhiseks automaattäitmiseks või lisa seadmed all käsitsi.",
    "save_devices": "Salvesta kõik seadmed",
    "add_row": "Lisa rida",
    "no_rows": "Ühtegi seadet pole veel lisatud. Laadi dokument üles või lisa read käsitsi.",
    "devices_saved": "{count} seadet salvestatud",
    "filters": {
      "standard": "Standard",
      "status": "Staatus",
      "country": "Riik",
      "search": "Otsi",
      "search_placeholder": "Otsi nime järgi...",
      "capacity_placeholder": "nt 50",
      "cod_placeholder": "nt 2020"
    },
    "table": {
      "name": "@:common.name",
      "plant_ecolabel_id": "Registreerimise ID",
      "standard": "Standard",
      "status": "Staatus",
      "country": "Riik",
      "address": "@:common.address",
      "type": "Tüüp",
      "renewable_type": "Tehnoloogia",
      "latitude": "Laiuskraad",
      "longitude": "Pikkuskraad",
      "capacity": "Võimsus",
      "cod": "COD",
      "date_reviewed": "Ülevaatuse kuupäev",
      "valid_from": "Heaks kiidetud alates",
      "valid_through": "Heakskiit kehtib kuni",
      "registration_authority": "Register",
      "technology_code": "Tehnoloogiakood",
      "public_notes": "Märkused",
      "relevant_link": "Link",
      "link": "Link",
      "documents": "@:common.documents",
      "actions": "@:common.actions.title"
    },
    "form": {
      "standard": "Ökomärgise standard",
      "status": "Staatus",
      "name": "Seadme nimi",
      "plant_id": "Jaama ökomärgise ID",
      "country": "Riigikood",
      "address": "@:common.address",
      "latitude": "@:ecolabels.table.latitude",
      "longitude": "@:ecolabels.table.longitude",
      "renewable_type": "Taastuvenergia tüüp",
      "marine": "Mereenergia",
      "nuclear": "Tuumaenergia",
      "technology_code": "Tehnoloogiakood",
      "technology_code_placeholder": "nt T010000",
      "registration_authority": "Registreeriv asutus",
      "relevant_link": "Asjakohane link",
      "capacity": "Võimsus",
      "capacity_units": "Ühik",
      "cod": "Kasutuselevõtu kuupäev",
      "public_notes": "Avalikud märkused",
      "rejection_reason": "Tagasilükkamise põhjus",
      "location_hint": "Kohustuslik on kas aadress või koordinaadid.",
      "errors": {
        "name_required": "Nimi on kohustuslik.",
        "country_required": "Riik on kohustuslik.",
        "renewable_type_required": "Taastuvenergia liik on kohustuslik.",
        "latitude_range": "Laiuskraad peab olema arv vahemikus -90 kuni 90.",
        "longitude_range": "Pikkuskraad peab olema arv vahemikus -180 kuni 180.",
        "capacity_invalid": "Võimsus peab olema arv.",
        "location_required": "Sisesta kas aadress või koordinaadid (laius- ja pikkuskraad).",
        "registration_authority_required": "Registreerimisasutus on kohustuslik, kui registreerimis-ID on määratud.",
        "rejection_reason_required": "Tagasilükkamise põhjus on nõutav, kui olek on Tagasi lükatud."
      },
      "registry_device_id": "Registri seadme ID",
      "date_reviewed": "Ülevaatuse kuupäev",
      "valid_from": "Heaks kiidetud alates",
      "valid_through": "Heakskiit kehtib kuni"
    },
    "ai_autofill": "AI automaattäitmine dokumendist",
    "autofill_btn": "Automaattäida",
    "autofill_confidence": "Usaldusväärsus: {value}%",
    "upload_wizard": {
      "title": "Laadi tühistamisavaldus üles",
      "ekoenergy_logo_alt": "EKOenergy logo",
      "no_authorized_seller_title": "Hakka volitatud EKOenergy müüjaks",
      "no_authorized_seller_description": "Tühistamisavalduste üleslaadimiseks on vaja vähemalt ühte volitatud müüjaettevõtet.",
      "no_authorized_seller_cta": "Külasta EKOenergyt",
      "step1_label": "Üleslaadimine",
      "step2_label": "Tühistamise detailid",
      "step1_title": "Laadi tühistamisdokument üles",
      "step1_description": "Laadi tühistamisavaldus üles. Meie AI analüüsib seda ja seob registreeritud ökomärgise seadmetega.",
      "cancellation_source": "Tühistamise allikas",
      "upload_new_statement": "Laadi uus tühistamisavaldus üles",
      "using_existing_cancellation": "Kasutad olemasolevat tühistamist. Faili üleslaadimine ja avalduse detailide väljad on peidetud.",
      "step2_title": "Vaata üle ja määra seadmed",
      "step2_description": "Vaata üle AI leitud seadmed, lisa või eemalda seadmeid käsitsi ning kohanda MWh jaotusi.",
      "drop_file": "Lohista fail siia või klõpsa sirvimiseks",
      "seller_company": "Müüjaettevõte",
      "new_company_placeholder": "Uue ettevõtte nimi",
      "new_company_email_placeholder": "Omaniku e-post",
      "company_created": "Volitatud müüjaettevõte loodud",
      "ai_matching_failed_warning": "AI vasteotsing ebaõnnestus. Avaldus salvestati, kuid välju/seadmeid ei täidetud automaatselt.",
      "upload_and_match": "Laadi üles ja seo seadmetega",
      "analyze": "Analüüsi dokumenti",
      "analyzing": "Dokumenti analüüsitakse AI abil...",
      "ai_applied": "AI analüüs rakendatud. Vaata eeltäidetud väljad üle ja kohanda neid.",
      "ai_found_matches": "AI leidis sinu avaldusest {count} vastavat seadet.",
      "matching_devices": "Sobivaid ökomärgise seadmeid otsitakse...",
      "no_matches": "Sobivaid seadmeid automaatselt ei leitud. Saad seadmeid all käsitsi määrata.",
      "assigned_devices": "Määratud seadmed",
      "add_device_manually": "Lisa seade",
      "no_devices_assigned": "Ühtegi seadet pole veel määratud. Lisa seadmeid käsitsi või laadi avaldus uuesti üles.",
      "select_device": "Vali seade",
      "search_devices": "Otsi nime või riigi järgi...",
      "no_devices_found": "Sobivaid seadmeid ei leitud.",
      "save_and_submit": "Salvesta ja esita",
      "beneficiary_name": "Kasusaaja nimi",
      "registry_code": "Registrikood",
      "country_region": "Riik/piirkond",
      "period_start": "Perioodi algus",
      "period_end": "Perioodi lõpp",
      "mwh_cancelled": "Tühistatud MWh",
      "purpose": "Tühistamise eesmärk",
      "notes": "Märkused",
      "confirm_proceed": "Kinnita ja seo seadmetega",
      "mwh": "@:common.mwh",
      "confidence": "Usaldusväärsus",
      "total_mwh": "Dokumendi kogu MWh",
      "selected_mwh": "Valitud MWh",
      "generate_certificates": "Genereeri sertifikaadid",
      "success": "Tühistamisavaldus laaditi üles ja seadmed määrati edukalt"
    },
    "certificates": {
      "heading": "EKOenergy sertifikaadid",
      "upload_statement": "Laadi tühistamisavaldus üles",
      "no_statements": "Tühistamisavaldusi veel pole. Alustamiseks laadi üles esimene avaldus.",
      "file_name": "Avaldus",
      "uploaded": "Üles laaditud",
      "period_col": "@:cancellation.table.period",
      "total_mwh_col": "MWh kokku",
      "devices_col": "Seadmed",
      "status_col": "Staatus",
      "actions_col": "@:common.actions.title",
      "download_statement": "Laadi avaldus alla",
      "edit_statement": "Muuda avaldust",
      "manage_devices": "Halda seotud seadmeid",
      "approve": "Kinnita",
      "reject": "Lükka tagasi",
      "generate": "Genereeri sertifikaat",
      "download_certificate": "Laadi sertifikaat alla",
      "approved_success": "Avaldus kinnitati edukalt",
      "rejected_success": "Avaldus lükati tagasi",
      "confirm_reject": "Kas soovid selle avalduse kindlasti tagasi lükata?",
      "certificate_generated": "Sertifikaat genereeriti ja laaditi alla",
      "statement_uploaded": "Tühistamisavaldus laaditi edukalt üles"
    },
    "manage_devices": {
      "title": "Muuda tühistamisavaldust",
      "statement_details": "Avalduse detailid",
      "documents_section": "@:common.documents",
      "statement_document": "Tühistamisavaldus",
      "certificate_document": "Sertifikaadi PDF",
      "no_certificate_document": "Sertifikaadifail puudub",
      "add_document": "@:common.add",
      "statement_document_updated": "Avalduse dokument uuendatud",
      "certificate_document_updated": "Sertifikaadi dokument uuendatud",
      "statement_document_deleted": "Avalduse dokument eemaldatud",
      "certificate_document_deleted": "Sertifikaadi dokument eemaldatud",
      "linked_devices": "Seotud seadmed",
      "add_device": "Lisa seade",
      "no_devices": "Selle avaldusega pole ühtegi seadet seotud.",
      "select_device": "Vali seade",
      "saved": "Seadmete määrangud uuendati edukalt"
    },
    "ekoenergy": {
      "title": "EKOenergy ecolabel",
      "description": "Tootmisseadmed, mida volitatud müüjad saavad EKOenergy jaoks kasutada"
    }
  },
  "documents_table": {
    "no_documents": "Dokumente pole kuvamiseks",
    "columns": {
      "id": "@:common.id",
      "name": "@:common.name",
      "type": "Tüüp",
      "category": "Kategooria",
      "company": "@:common.company",
      "status": "Staatus",
      "created": "Loodud",
      "actions": "@:common.actions.title"
    },
    "filters": {
      "search_name": "Otsi nime järgi",
      "search_company": "Otsi ettevõtte järgi"
    },
    "type": {
      "custom_upload": "Üleslaadimine",
      "dokobit_document": "Allkirjastatud dokument"
    },
    "category": {
      "sending_gos_file_upload": "PT saatmine",
      "buy_contract_analysis": "Ostuleping",
      "cancel_contract_analysis": "Tühistamisleping",
      "ppa_contract_analysis": "PPA leping",
      "bulk_buy_analysis": "Hulgimüük",
      "ppa_instructions": "PPA juhised",
      "ppa_creation": "PPA loomine",
      "cancellation_statement": "Tühistamisavaldus",
      "issuance_data_import": "Väljaandmisandmed",
      "arbitrary_file_upload": "Failide üleslaadimine",
      "portfolio_documentation": "Portfelli dokumentatsioon",
      "other": "Muu",
      "unknown": "Teadmata"
    },
    "status": {
      "uploaded": "Üles laetud",
      "completed": "Allkirjastatud",
      "awaiting_signature": "Ootab allkirja",
      "canceled": "Tühistatud"
    },
    "actions": {
      "archive": "Arhiveeri",
      "sign": "Allkirjasta",
      "view_details": "Üksikasjad"
    },
    "details_modal": {
      "title": "Dokumendi üksikasjad",
      "contract_details": "Lepingu üksikasjad",
      "source": "Allikas"
    },
    "confirm_archive": "Kas olete kindel, et soovite selle dokumendi arhiveerida? See eemaldatakse nimekirjast.",
    "archive_success_title": "Dokument arhiveeritud",
    "archive_success_message": "Dokument on edukalt arhiveeritud.",
    "linked_cancellations": "Seotud tühistamised",
    "cancellation_id": "Tühistamine #{id}"
  },
  "ppa_summary": {
    "heading": "Eelseisvad teostused",
    "loading": "Arvutan prognoositavaid mahtusid...",
    "no_data": "Prognoosiandmed pole veel saadaval.",
    "no_data_short": "—",
    "mwh_value": "{amount} MWh",
    "next_delivery": "Järgmine teostus",
    "following_delivery": "Ülejärgmine teostus",
    "contract_ends": "Leping lõppeb",
    "send": "Saadame {date} (prognoos {amount} MWh).",
    "cancel": "Tühistame perioodi {start} -> {end} kuupäeval {date} (prognoos {amount} MWh)."
  },
  "ai_chat": {
    "certificate_criteria_conflict": "{context} sisaldavad vastuolulisi sertifikaadinõudeid ({criterion}). Laadige need üles eraldi.",
    "conflict_contexts": {
      "excel_rows": "Exceli read",
      "uploaded_documents": "Üleslaaditud dokumendid",
      "draft_and_document": "Praegune mustand ja üleslaaditud dokument"
    },
    "shared_setting_conflict": {
      "intro": "Midagi ei imporditud. Tühistamise käsul saab olla ainult üks kasusaaja tüüp, tarbimisperiood ja tühistamise eesmärk, kuid need avaldused erinevad:",
      "other_statements": "Ülejäänud avaldused ({count})",
      "more_statements": "…ja veel {count}",
      "outro": {
        "uploaded_documents": "Parandage need avaldused dokumendis ja laadige see uuesti üles, laadige need üles eraldi failidena või lisage üleslaadimisele märkus väärtusega, mis kehtib kõigile avaldustele.",
        "draft": "Mustandit ei muudetud. Öelge mulle, milline väärtus kehtib kõigile avaldustele, või lõpetage see käsk ja alustage ülejäänud avalduste jaoks uut vestlust."
      }
    },
    "document_irrelevant": "See dokument ei tundu sobivat sellega, mida siin ette valmistame, seega midagi ei imporditud. Laadige üles mõni teine dokument või küsige minult, miks see ei sobinud.",
    "title": "AI-assistent",
    "input_placeholder": "Kirjuta sõnum…",
    "send": "Saada",
    "attach": "Lisa dokument",
    "drop_files": "Lase failid lahti, et need lisada",
    "drop_files_hint": "PDF, Word, Excel, CSV või TXT · kuni {maxMb} MB",
    "drop_busy": "Lisa failid, kui vastus on saabunud",
    "new_chat": "Alusta uut vestlust",
    "thinking": "Töötan selle kallal…",
    "error_reply": "Vabandust, midagi läks töötlemisel valesti. Palun proovi uuesti.",
    "greetings": {
      "cancel": "Tere! Laadi üles tühistamisdokument (PDF, Word, Excel või CSV) ja koostan sulle avalduste mustandid. Kui olulist infot on puudu, küsin seda siinsamas. Võid ka lihtsalt sõnumiga kirjeldada, mida vajad.",
      "buy": "Tere! Laadi üles hankedokument või kirjelda, mida soovid osta (kogus, tehnoloogia, aastakäik…), ja täidan ostuseaded sinu eest.",
      "send": "Tere! Laadi üles ülekandedokument või ütle, kes peaks GO-d saama (saaja, EECS-konto, MWh kogus), ja valmistan ülekande ette.",
      "bulk_buy": "Tere! Laadi üles tarbimisaruanded või rajatiste nimekirjad ning eraldan ettevõtted, kogused ja ostuseaded. Kui olulist infot on puudu, küsin seda siinsamas.",
      "ppa": "Tere! Laadi üles PPA leping või kirjelda tarnegraafikut ja täidan tarnejuhised. Kui olulist infot on puudu, küsin seda siinsamas.",
      "ecolabels": "Tere! Laadi üles oma tühistamisavaldus (PDF, Word, Excel või CSV) või kirjelda seda ning koostan avalduse andmete mustandi ja seon seadmed sinu eest. Kui olulist infot on puudu, küsin seda siinsamas.",
      "ecolabel_devices": "Tere! Laadi üles oma seadmete nimekiri (tabel, registri väljavõte, e-kiri või PDF) ja ma eraldan iga seadme koos andmetega, kontrollin puuduvaid välju ja märgin võimalikud duplikaadid. Võid seadmeid või parandusi kirjeldada ka sõnumis."
    }
  },
  "branding": {
    "powered_by": "Teenust pakub",
    "registry_infrastructure": "Registritaristu",
    "powered_by_soldera": "Töötab Soldera registritaristul"
  },
  "cnmc": {
    "workflow_intro": "Esita kuutoodang, valmista ette CNMC väljastamisfailid ning jälgi PPA ülekandeid ja eksporti.",
    "filing_details": "Taotluse andmed",
    "prepare_issuance": "Valmista väljastamine ette",
    "recipient_name": "Saaja juriidiline nimi",
    "destination_registry": "Sihtregister",
    "choose_registry": "Vali register",
    "domestic_transfer": "Hispaania · riigisisene ülekanne",
    "recipient_r2": "CNMC tarnija tunnus (R2)",
    "eecs_account": "EECS konto",
    "market_destination": "Turukoguste ekspordi sihtkoht",
    "change_destination": "Muuda sihtkohta",
    "confirm_representation": "Mul on õigus esitada selle tootja nimel taotlusi ja olen kinnitanud esindusõiguse nõuete täitmise.",
    "accept_declarations": "Kinnitan, et neid näite saab kasutada väljastamiseks, nende suhtes pole muid avatud nõudeid ning tootja nõustub CNMC taotluse deklaratsioonide ja andmetöötlustingimustega.",
    "fields": {
      "producer_name": "Tootja juriidiline nimi",
      "street": "Tänav",
      "street_number": "Maja number",
      "staircase": "Trepikoda (valikuline)",
      "postal_code": "Postiindeks",
      "municipality": "Omavalitsus",
      "province": "Provints",
      "country": "Riik",
      "phone": "Telefon",
      "email": "E-post",
      "place": "Allkirjastamise koht",
      "representative_name": "Esindaja nimi (kui kohaldub)"
    },
    "production": "Tootmine",
    "allocation": "Jaotus",
    "review": "Ülevaatus",
    "monthly_breakdown": "Sisesta iga seade ja kuu eraldi. Päritolutunnistuste väljastamisel jäetakse murdosad välja; eri kuude koguseid ei liideta.",
    "device": "Tootmisseade",
    "month": "Tootmiskuu",
    "production_mwh": "Toodang (MWh)",
    "whole_go_total": "{count} tervet päritolutunnistust enne olemasolevate kohustuste arvestamist",
    "allocation_explanation": "Jaotuse määravad PPA juhised. Jaotuse muutmiseks uuenda PPA juhiseid ja värskenda seda mustandit.",
    "route": "Tarneviis",
    "market": "Turg",
    "routes": {
      "DOMESTIC": "Riigisisene",
      "EXPORT": "AIB eksport"
    },
    "issuance_split": "{domestic} riigisisest päritolutunnistust · {exported} päritolutunnistust AIB ekspordiks",
    "saved_draft_explanation": "Mustand on salvestatud. Kinnita partii, et kogused reserveerida ja väljastamisfailid luua.",
    "open_batch": "Ava partii",
    "batch_number": "CNMC partii #{id}",
    "needs_attention_explanation": "Soldera peab selle taotluse üle kontrollima. Esitatud taotluste jälgimine jätkub; mõjutatud kogused jäävad reserveerituks.",
    "edit_draft": "Muuda mustandit",
    "delete_draft": "Kustuta mustand",
    "delete_draft_confirmation": "Kas kustutada CNMC partii nr {id}? See kustutab jäädavalt mustandi, selle jaotuse ja tootmisnäidud. Seda ei saa tagasi võtta.",
    "confirm_and_generate": "Kinnita jaotus ja loo failid",
    "stacking_instructions": "Laadi iga väljastamise ZIP-fail CNMC-sse ja sisesta allpool selle registreerimisnumber. Ülekande- ja ekspordifailid saad ette valmistada pärast väljastamistaotluse esitamist, ka kinnitust oodates. Laadi iga tarne ZIP eraldi ja sisesta selle enda registreerimisnumber.",
    "prepare_ppa_delivery": "Valmista {name} tarne ette",
    "ppa_delivery_issuance_required": "Esita selle PPA väljastamisfail CNMC-le, seejärel sisesta ülal selle Número de Registro ja salvesta esitamine.",
    "market_export_issuance_required": "Esita AIB ekspordi väljastamisfail CNMC-le, seejärel sisesta ülal selle Número de Registro ja salvesta esitamine.",
    "prepare_market_export": "Valmista turueksport ette",
    "kinds": {
      "DOMESTIC_ISSUANCE": "Riigisisene väljastamine",
      "EXPORT_ISSUANCE": "Väljastamine AIB ekspordiks",
      "TRANSFER": "Riigisisene ülekanne",
      "EXPORT": "Eksport"
    },
    "statuses": {
      "DRAFT": "Mustand",
      "CONFIRMED": "Kinnitatud",
      "PREPARED": "Ette valmistatud",
      "SUBMITTED": "Esitatud · kontrollimata",
      "PENDING": "Ootel",
      "APPROVED": "Heaks kiidetud · ootab tõendeid",
      "COMPLETED": "Lõpetatud",
      "COMPLETE": "Valmis",
      "IN_PROGRESS": "Töös",
      "NEEDS_ATTENTION": "Vajab tähelepanu",
      "ABANDONED": "Loobutud",
      "SUPERSEDED": "Asendatud"
    },
    "source_receipts": "Algne väljastamistaotlus · Nº Registro Origen",
    "outdated_file": "See fail kasutab vanemat vormimalli. Asendage esitamata fail enne üleslaadimist; säilitage esitatud failid oma arhiivis.",
    "lookup_retry": "CNMC kontroll pole ajutiselt saadaval. Korduskatse on ajastatud; viimane teadaolev olek säilib.",
    "filing_deadline": "Taotluse tähtaeg",
    "go_expiry": "Päritolutunnistuse aegumine",
    "last_checked": "Viimati kontrollitud",
    "not_checked": "Veel kontrollimata",
    "company_order": "Ettevõtte tellimus",
    "download_zip": "Laadi ZIP alla",
    "check_status": "Kontrolli olekut",
    "record_submission": "Märgi esitatuks",
    "correction_reason": "Paranduse või tagasivõtmise põhjus",
    "abandon_batch": "Loobu partiist",
    "abandonment_reason": "Sellest partiist loobumise põhjus",
    "abandon_explanation": "Tootmise saab vabastada ainult esitamata või kinnitatult tagasi lükatud/tagasi võetud väljastamise korral. Ebaõnnestunud tarne ei vabasta väljastatud koguseid.",
    "connection": "CNMC ühendus",
    "preparation_disabled": "Selle ühenduse jaoks pole uute taotluste ettevalmistamine lubatud. Olemasolev taotluste ajalugu jääb kättesaadavaks.",
    "profile_required": "Enne väljastamise ettevalmistamist kinnita taotluse andmed.",
    "template_updated": "CNMC on seda vormi uuendanud. Enne uue faili loomist peame toe uuendama. Sinu sisestatud andmed on salvestatud.",
    "checking_templates": "CNMC vormide kontroll on pooleli. Failide loomine on võimalik pärast kontrolli.",
    "no_batches": "Väljastamispartiisid veel pole.",
    "batch": "Partii",
    "progress": "Edenemine",
    "filing_order": "Seda tellimust hallatakse CNMC taotlusvormidega. Failide allalaadimiseks, registreerimisnumbrite sisestamiseks ja edenemise kontrollimiseks ava väljastamispartii.",
    "pending_ppa": "Reserveeritud CNMC PPA tarneks",
    "cnmc_transferred": "Kinnitatud PPA tarne",
    "ppa_progress": "{reserved_go_count} PT reserveeritud · {ready_go_count} valmis esitamiseks · {transferred_go_count} üle kantud",
    "linked_filings": "CNMC taotlused",
    "order_instructions": "Laadi failid CNMC-sse ja sisesta iga registreerimisnumber seotud partiis. Registrikontrollid kinnitavad lõpetamise.",
    "awaiting_delivery_form": "Väljastamine on broneeritud. Pärast väljastamise registreerimisnumbri sisestamist koosta väljastamisaruandes ülekande- või ekspordifail.",
    "inventory_accepted": "Varad vastu võetud ja jaotatud",
    "arrival_review": "Hispaania ekspordi saabumised",
    "arrival_review_help": "Kontrolli täpset vastuvõtvat kontot, seadmete täismahte ja tootmiskuid. Jagatud saabumised ja seadmenimede vasted vajavad põhjendust. Vastuvõtmine määrab korraga omandi ja portfellid.",
    "export_verified": "Eksport kontrollitud",
    "awaiting_verification": "Ootab CNMC kontrolli",
    "receiving_account": "Vastuvõttev konto",
    "imported_at": "Imporditud",
    "production_months": "Tootmiskuud",
    "reviewed_name": "Kontrollitud seadmenimi",
    "use_registry_name": "Kasuta registri nime",
    "accept_inventory": "Võta varad vastu",
    "replace_file": "Asenda fail",
    "replace_file_help": "Loo seotud asendus praeguse toetatud malliga. Esitatud taotluste tagasilükkamine või tagasivõtmine peab esmalt olema kontrollitud. Ajaloolised failid jäävad kättesaadavaks.",
    "awaiting_issuance_receipt": "Ootab väljastamistaotluse numbrit",
    "next_action": "Järgmine samm",
    "actions": {
      "REVIEW": "Vaata jaotus üle ja kinnita",
      "SUBMIT_ISSUANCE": "Laadi väljastamisfailid üles ja sisesta iga Número de Registro | Laadi väljastamisfail üles ja sisesta selle Número de Registro | Laadi väljastamisfailid üles ja sisesta iga Número de Registro",
      "SUBMIT_DELIVERY": "Laadi tarnefailid üles ja sisesta iga Número de Registro",
      "PREPARE_DELIVERY": "Valmista tarnefailid ette",
      "WAIT_CNMC": "Ootab CNMC kinnitust",
      "WAIT_INVENTORY": "Ootab varade saabumist vastuvõtvale kontole",
      "CONTACT_SOLDERA": "Vajalik on Soldera kontroll",
      "COMPLETE": "Lõpetatud",
      "ABANDONED": "Loobutud"
    },
    "staff_review": "Soldera kontroll",
    "staff_review_help": "Pärast juhtumi lahendamist kirjelda muudatusi ja kontrolli värskeid CNMC tõendeid. Olemasolevad failid, reserveeringud ja tarnekirjed jäävad auditeerimisajalukku.",
    "resume_verification": "Jätka kontrolli",
    "load_more": "Laadi rohkem",
    "replacement_draft": "Loo asendusmustand",
    "replacement_draft_help": "Asendusmustand säilitab algsed tootmiskohustused. Enne kattuva tootmise kinnitamist lahenda ja vabasta vanad taotlused.",
    "template_check_failed": "CNMC vormi kontroll ebaõnnestus. Korduskatse on ajastatud; sinu andmed on salvestatud.",
    "next_check": "Järgmine kontroll",
    "registry_evidence": "CNMC tõendid",
    "net_production": "Tegelik netotoodang",
    "domestic_volume": "Riigisisene",
    "export_volume": "AIB eksport",
    "unallocated_fraction": "Jaotamata murdosa",
    "application_number": "Taotlus nr {id}",
    "requested": "Taotletud",
    "approved": "Heaks kiidetud",
    "delivered": "Tarnitud",
    "zip_package": "Algne töövihik ZIP-failis",
    "issuance_receipt": "Número de Registro · Expedición",
    "receipt_format": "20 numbrit ilma tühikuteta: esitamise aasta + 03 + 14 numbrit. Kasuta esitamise, mitte tootmise aastat.",
    "receipt_example": "nt 20260300000045887410",
    "transfer_receipt": "Número de Registro · Transferencia",
    "export_receipt": "Número de Registro · Exportación",
    "issuance_receipt_help": "Pärast selle väljastamise ZIP-faili esitamist kopeeri CNMC antud Número de Registro. Leiad selle jaotisest Consultas por Solicitante või menetluse üksikasjade ülaosast väljal Nº registro.",
    "delivery_receipt_help": "Pärast selle ülekande või ekspordi ZIP-faili esitamist kopeeri uus Nº registro CNMC menetluse üksikasjade ülaosast. Ära kasuta välja Nº Registro Origen (algne väljastamistaotlus) ega ekspordi Message ID-d.",
    "correct_receipt": "Paranda registreerimisnumbrit",
    "delivery_due": "Tarne valmidus",
    "issuance_stage": "1. etapp · Väljastamisvormid",
    "delivery_stage": "2. etapp · Ülekande- ja ekspordivormid",
    "download_notice": "Paketi allalaadimine ei esita seda registrile. Sisesta iga CNMC kinnitusnumber partiisse, et võimaldada seotud vormide koostamist ja jälgimist.",
    "enter_manually": "Sisesta käsitsi",
    "upload_with_ai": "Laadi üles tehisintellektiga",
    "upload_readings_help": "Tehisintellekt loeb Exceli või CSV-failist seadmete CIL-koodid, tootmiskuud ja MWh (kuni 25 MB). Vaata allolevad read üle ja vajadusel muuda neid. Suurtest Exceli failidest võib olla vaja eemaldada kasutamata lehed ja vormindus või jagada need väiksemateks failideks.",
    "readings_uploaded": "Faili {filename} näidud on allpool. Vaata need enne jätkamist üle.",
    "upload_readings_conflict": "Failis oleva seadme ja kuu kohta on tabelis juba teistsugune näit. Enne uuesti üleslaadimist eemalda see rida.",
    "invalid_readings_file": "Vali kuni 25 MB suurune Exceli (.xlsx, .xls) või CSV-fail.",
    "add_production_help": "Sisesta kuu näit käsitsi või laadi fail üles tehisintellekti abil.",
    "ppa_reserves": "Väljastamise broneeringud",
    "no_ppa_reserves": "PPA broneeringuid pole. Saadaolevad täisarvulised PT-d suunatakse turumüügiks eksporti.",
    "filing_snapshot_help": "CNMC taotluste ühised vaikeandmed. Iga partii säilitab selle koostamisel kasutatud esitamisandmed.",
    "producer": "Tootja",
    "contact_address": "Kontakt ja aadress",
    "representation": "Esindamine",
    "declarations": "Kinnitused",
    "connection_identity": "Valitud CNMC registriühendusest",
    "saved_for_connection": "Salvestatakse selle ühenduse järgmiste partiide jaoks",
    "eecs_recipient": "EECS registrikonto",
    "domestic_recipient": "Hispaania tarnija · CNMC",
    "recipient_type": "Saaja tüüp",
    "domestic_delivery_help": "Riigisisene tarne CNMC kaudu. Soldera broneerib selle osa väljastamisel ja koostab ülekandevormi. Failid esitad CNMC-s ise.",
    "export_delivery_help": "Eksport CNMC kaudu saaja EECS registrikontole. Soldera broneerib selle osa väljastamisel ja koostab ekspordivormi. Failid esitad CNMC-s ise.",
    "ppa_execution_desc": "Jaotus ja tarne CNMC kaudu.",
    "ppa_execution_help": "PPA osa ja saaja fikseeritakse väljastamise kinnitamisel. Sisesta väljastamise registreerimisnumber, et koostada väljastamisaruandes ülekande- või ekspordifail. Laadi iga fail CNMC-sse ja sisesta selle registreerimisnumber. Soldera jälgib kinnitamist ja tarnet.",
    "ppa_execution_summary": "CNMC väljastamise kaudu",
    "r2_help": "Saaja registreering CNMC-s nõuetele vastava tarnijana.",
    "ready_for_filing": "Esitamiseks valmis",
    "template_verification_pending": "CNMC vormid ootavad kontrollimist. Failide koostamine muutub kättesaadavaks pärast uusimate vormide kontrollimist.",
    "validation": {
      "r2": "Sisestage CNMC tarnija registreerimisnumber, mis algab R2-.",
      "eecs_region": "EECS-konto peab kuuluma valitud registrisse.",
      "month": "Sisestage kehtiv tootmiskuu.",
      "production_precision": "Sisestage MWh kuni 3 komakohaga."
    },
    "connection_required": "CNMC taotluste ettevalmistamiseks ühenda Hispaania tootjakonto. Abi saamiseks kirjuta support@soldera.org."
  },
  "forwards": {
    "common": {
      "mwh": "MWh",
      "mwh_value": "{value} MWh",
      "committed": "Seotud",
      "escrowed": "Tagatisel",
      "available": "Vaba",
      "planned": "Planeeritud",
      "delivered": "Tarnitud",
      "shortfall": "Katmata",
      "fill_of_total": "{filled} / {total} MWh",
      "no_window_end": "tarnetähtaeg puudub",
      "not_priced": "Hind veel määramata",
      "price_per_mwh": "{price} €/MWh",
      "price_range_per_mwh": "{min} – {max} €/MWh",
      "retry": "Proovi uuesti",
      "unknown": "Teadmata",
      "yes": "Jah",
      "no": "Ei",
      "none": "Puudub",
      "actions": "Tegevused",
      "status": {
        "draft": "Mustand",
        "confirmed": "Kinnitatud",
        "completed": "Lõpetatud",
        "cancelled": "Tühistatud",
        "archived": "Arhiveeritud",
        "escrow_remaining": "Tagatisel jäänud",
        "pay_as_produced": "Toodangupõhine"
      },
      "super_admin_only_create": "Tehinguid saab luua ainult superadministraator.",
      "support": {
        "mixed": "Segatud: toetatud või teadmata",
        "unsupported": "Toetuseta"
      },
      "period_width": {
        "month": "Kuud",
        "quarter": "Kvartalid",
        "half_year": "Poolaastad",
        "year": "Aastad"
      },
      "device_count": "{count} seadet | {count} seade | {count} seadet",
      "deal_badges": {
        "under_committed": "{mwh} MWh katmata",
        "volume_over": "{mwh} MWh üle tehingu mahtu",
        "volume_under": "{mwh} MWh alla tehingu mahtu"
      },
      "deal_text": {
        "description_help": "Trükitakse tootjate arvetele ja näidatakse tootjatele nende müükide nimekirjas.",
        "internal_notes": "Sisemised märkmed",
        "internal_notes_help": "Ainult töötajatele: tootjatele ega ostjatele neid kunagi ei näidata ega trükita."
      }
    },
    "overview": {
      "title": "Forward-müük",
      "description": "Tähelepanu vajavad punktid, tootmisaastate kaupa müüdud forward-maht, eelseisvad tarned ja sinu hallatavad tehingud.",
      "year_totals": {
        "title": "Forward-müük tootmisaasta kaupa",
        "description": "Iga tootmisaasta kohta müüdud forward-maht ja selle keskmine ostja hind.",
        "loading": "Aastaseid kogusummasid laaditakse",
        "empty": "Forward-müüki veel pole.",
        "load_failed": "Aastaseid forward-kogusummasid ei õnnestunud laadida.",
        "volume": "{mwh} MWh",
        "average": "keskm. {price} €/MWh",
        "no_average": "hinnastatud mahtu veel pole",
        "unpriced": "{mwh} MWh hinnata",
        "contents": {
          "intro": "Maht hõlmab kinnitatud ja lõpetatud tehinguid ning seda, mille tühistatud tehingud olid juba teele saatnud, kuid mitte mustandeid. Tehingu liigi kaupa:",
          "fixed_volume": "Fikseeritud mahuga tehingud: nende tarneplaan, iga periood arvestatud aastasse, milles see algab, olenemata sellest, kas see on teele saadetud.",
          "pay_as_produced": "Toodangupõhised lepingud: iga kuu teele saadetud maht või kuni saatmiseni selle nomineeritud maht."
        }
      },
      "attention": {
        "title": "Tähelepanu vajab",
        "description": "Selle konto kogumite ja tehingute punktid. Need kaovad ise, kui probleem on lahendatud.",
        "loading": "Laadin tähelepanu vajavaid punkte",
        "empty": "Midagi ei vaja sinu tähelepanu.",
        "load_failed": "Tähelepanu vajavaid punkte ei õnnestunud laadida.",
        "status": {
          "stale_draft": "Seisev mustand",
          "open_slices": "Katmata",
          "escrow_shortfall": "Puudujääk",
          "swap_terms_missing": "Tingimused puudu",
          "delivery_unpriced": "Hind puudu",
          "free_escrow": "Tagatis tagastada",
          "infeasible": "Ülemüüdud",
          "pool_escrow_missing": "Puudu",
          "other": "Muu",
          "coarse_issuance": "Väljastamine",
          "allocation_not_ready": "Ei jaotata",
          "contango_discouraged": "Contango 20%"
        },
        "reason": {
          "stale_draft": "Mustandtehing, {days} päeva kinnitamata. Selle sidumised hoiavad varu kinni, kuid midagi ei eraldata.",
          "open_slices": "{mwh} MWh sellest tehingust ei kata ükski kogum.",
          "escrow_shortfall": "{mwh} MWh seotud mahust ei ole veel tagatisel.",
          "swap_terms_missing": "Vahetustehingu tarne tähtajaga {date}: {missing}.",
          "delivery_unpriced": "Ühelgi tarnel ei puudu ostja hind. | {count} tarnel ({mwh} MWh) pole ostja hinda, seega jätavad aastased forward-kogusummad selle välja. | {count} tarnel ({mwh} MWh) pole ostja hinda, seega jätavad aastased forward-kogusummad need välja.",
          "free_escrow": "{mwh} MWh on tagatisel, kuid ükski tarne ei vaja seda enam. Tagasta see omanikettevõtetele.",
          "infeasible": "Eeldatav toodang jääb perioodil {period} kogumi kohustustest {mwh} MWh võrra väiksemaks.",
          "pool_escrow_missing": "Perioodiks {period} seotud {mwh} MWh puudub tagatiselt; register oleks pidanud selle juba välja andma.",
          "coarse_issuance": "Sertifikaadid väljastatakse {issued}, kuid kogum pakub {listed}: need seadmed ei saa selle pakutud mahtusid tarnida. Paku {widest} või pikemalt.",
          "allocation_not_ready": "Öine jaotus jätab vahele {companies} (jaotuseks pole valmis), seega nende toodang ei jõua kunagi tagatisele selle kogumi tehingute jaoks.",
          "contango_discouraged": "See kogum müüb ainult vähemalt 20% üle hetkehinna, mida juhtub harva, seega müüakse selle mahtu harva. Kaalu valikut „Müü ainult contango korral”."
        },
        "swap_terms": {
          "producer_price": "tootja real pole tootja hinda, seega arveldatakse see müügihinnaga",
          "trade_owner": "tehingu vahendaja pole määratud, seega marginaalilt vahendustasu ei maksta"
        },
        "issued_in_region": "{width} ({region})",
        "width_adverb": {
          "month": "igakuiselt",
          "quarter": "kvartaalselt",
          "half_year": "poolaastati",
          "year": "aastati"
        }
      },
      "deliveries": {
        "title": "Eelseisvad tarned",
        "description": "Sinu hallatavate tehingute planeeritud tarned, lähima tähtaja järgi. Puuduolev maht on see, mida tarne tagatisel veel napib, rühmitatuna seda katvate kogumite seadmeriikide järgi. Toodangupõhist kuud näidatakse nomineeritud sihtmahu suhtes, mida jälgitakse, kuid mis ei ole kohustus.",
        "loading": "Laadin tarneid",
        "empty": "Filtritele vastavaid tarneid ei ole.",
        "load_failed": "Eelseisvaid tarneid ei õnnestunud laadida.",
        "download_xlsx": "Laadi alla xlsx",
        "transaction": "Tehing",
        "window": "Tarneaken",
        "deal": "Tehing",
        "escrowed_of_planned": "Tagatisel / planeeritud · puudu riikide kaupa",
        "open_transaction": "Ava müügitehing",
        "open_deal": "Ava tehing",
        "escrowed_of_target": "{escrowed} / {target} MWh (sihtmaht)",
        "on_or_before": "hiljemalt {date}",
        "short": "puudu",
        "due_today": "tähtaeg täna",
        "due_tomorrow": "tähtaeg homme",
        "due_in_days": "{days} päeva pärast",
        "overdue_one_day": "1 päev üle tähtaja",
        "overdue_days": "{days} päeva üle tähtaja",
        "transaction_status": {
          "draft": "Mustand",
          "pending_buyer_details": "Ootab ostja andmeid",
          "pending_contracts": "Ootab lepinguid",
          "ready_to_transfer": "Ülekandeks valmis",
          "delivered": "Tarnitud",
          "completed": "Lõpetatud"
        },
        "delivered_awaiting_completion": "üle antud, ootab makset",
        "filters": {
          "status": "Tehingu staatus",
          "window_end": "Tarneakna lõpp",
          "window_end_any": "Suvaline kuupäev",
          "deal_name": "Tehingu nimi"
        }
      },
      "deals": {
        "title": "Sinu hallatavad tehingud",
        "description": "Kogu detail (tarneplaan, sidumised, tagatise jaotus) on tehingu lehel.",
        "loading": "Laadin tehinguid",
        "empty": "Ükski tehing ei vasta neile filtritele.",
        "load_failed": "Tehinguid ei õnnestunud laadida.",
        "new_deal": "Uus forward-mustand",
        "new_pap_deal": "Uus toodangupõhine tehing",
        "no_buyer": "Määramata",
        "no_price": "Määramata",
        "price_range": "{min} - {max}",
        "deliveries_of": "{done} / {total}",
        "stale": "{days} p vana",
        "infeasible": "Teostamatu",
        "filters": {
          "status": "Staatus",
          "status_all": "Kõik staatused",
          "name": "Tehingu nimi",
          "name_placeholder": "Suvaline nimi",
          "pool": "Sisaldab kogumit",
          "pool_placeholder": "Kogumi nimi",
          "company": "Sisaldab ettevõtet",
          "company_placeholder": "Ettevõtte nimi"
        },
        "columns": {
          "deal": "Tehing",
          "buyer": "Ostja",
          "quarters": "Tootmine",
          "volume": "Tehingu maht (MWh)",
          "price": "Hind (€/MWh)",
          "deliveries": "Tarneid tehtud",
          "status": "Staatus"
        }
      }
    },
    "pools": {
      "intro": {
        "title": "Müü oma tulevast toodangut ette",
        "body": "Tulevikumüügiga müüd päritolutunnistusi toodangu eest, mille tunnistusi pole veel välja antud, täna kokku lepitud hinnaga. Soldera tulevikumüügi teenus aitab sul kindlustada prognoositava tulu ja vähendada hinnakõikumiste riske, ilma et peaksid ise igapäevaselt tulevikumüükide haldamisega tegelema. Alustamiseks loo kogum: vali, millised sinu ettevõtted osalevad ja kui palju nad igal perioodil pakuvad. Soldera müüb selle mahu oma võrgustiku ostjatele ning tunnistused tarnitakse siis, kui register need välja annab.",
        "cta": "Loo oma esimene kogum"
      },
      "guide": {
        "title": "Tulevikumüügist",
        "pool_definition": "Kogum on sinu ettevõtete grupp, mille toodangut pakutakse forward-müügiks koos.",
        "pool_balancing": "Kui üks ettevõte toodab oodatust vähem, saavad kogumi teised ettevõtted puudujäägi oma lisatoodanguga katta.",
        "setup_title": "Kogumite seadistamine",
        "setup_intro": "Rühmita kokku seadmed, mida samad ostjad aktsepteeriksid, et ükski seade ei jätaks kogumit tehingust välja:",
        "setup_unsupported": "Toetuseta hüdro-, päikese- ja tuuleenergia ühest riigist ühte kogumisse. Enamik ostjaid aktsepteerib neid.",
        "setup_biomass": "Biomass ja biogaas eraldi kogumisse, sest paljud ostjad välistavad need.",
        "setup_issuance": "Seadmed registritest, mis ei väljasta päritolutunnistusi iga kuu, eraldi kogumisse, mille perioodi pikkus vastab sellele, kui sageli register neid väljastab.",
        "setup_devices": "Ettevõte võib kuuluda mitmesse kogumisse. Selle seadmete jagamiseks kogumite vahel kasuta kogumi muutmise vaates seadmete valikut."
      },
      "loading": "Kogumite laadimine",
      "empty": "Ükski kogum ei vasta neile filtritele.",
      "load_failed": "Kogumite ajajoont ei õnnestunud laadida.",
      "attention": {
        "description": "Mida oma kogumite juures muuta. Kirjed kaovad, kui need on lahendatud."
      },
      "restricted_access": "Sinu ettevõte kuulub sellesse kogumisse. Üksikasjade vaatamiseks peab sul olema juurdepääs kõigile liikmesettevõtetele.",
      "status_filter": "Staatus",
      "status_filter_all": "Kõik staatused",
      "company_filter": "Ettevõtted",
      "company_filter_all": "Kõik ettevõtted",
      "name_filter": "Kogumi nimi",
      "name_filter_placeholder": "Otsi nime järgi",
      "name_filter_no_matches": "Ükski kogum ei vasta sellele nimele.",
      "status": {
        "active": "Aktiivne",
        "archived_open": "Arhiveeritud, kohustused täitmata",
        "archived_settled": "Arhiveeritud ja lõpetatud"
      },
      "year_previous": "Eelmine aasta",
      "year_next": "Järgmine aasta",
      "band_title": "Kõik kogumid",
      "band_column": "{quarter}: pakutud {listed} MWh, seotud {committed} MWh, tagatisel {escrowed} MWh, vaba {available} MWh",
      "band_available": "{quarter}: vaba {value} MWh, pakutud {listed} MWh",
      "band_committed": "{quarter}: seotud, veel tagatiseta {value} MWh (kokku seotud {committed} MWh)",
      "band_escrowed": "{quarter}: tagatisel {value} MWh",
      "infeasible_periods": "See kogum on müünud rohkem, kui selle seadmed eeldatavasti toodavad perioodil {periods}.",
      "row_subtitle": "{companies} · {devices} · {shape}",
      "row_companies": "{count} ettevõtet | {count} ettevõte | {count} ettevõtet",
      "pap_window": "Lepinguperiood · tagatisel {escrowed} MWh · tarnitud {delivered} MWh",
      "cell_figure": "{committed} / {listed}",
      "cell_escrowed_figure": "{value} tagatisel",
      "cell_available": "{pool}, {quarter}: veel vaba {value} MWh",
      "available_help": "Iga perioodi kohta suurim kogus, mida üks uus tehing veel võtta saaks. Laiemate perioodide kohustused on perioodide vahel jagatud, seega neid arve kokku liita ei saa.",
      "cell_committed": "{pool}, {quarter}: seotud {value} MWh, sellest tagatisel {escrowed} MWh",
      "cell_stranded": "{pool}, {quarter}: tagatisel {value} MWh, millel pole kehtivat kohustust",
      "cell_empty": "{pool}, {quarter}: midagi pole pakutud",
      "cell_deal_tooltip": "{deal} · {value} MWh, tagatisel {escrowed} MWh · {status} · tarne hiljemalt {window}",
      "entry_width": {
        "quarter": "Kvartaalne",
        "month": "Kuine",
        "half_year": "Poolaastane",
        "half_year_recommended": "Poolaastane (soovitatud)",
        "year": "Aastane"
      },
      "listing_kind": {
        "one_off": "Ühekordne",
        "recurring": "Korduv",
        "pay_as_produced": "Toodangupõhine"
      },
      "options": {
        "title": "Seaded",
        "minimum_price": "Miinimumhind",
        "minimum_price_placeholder": "Piirhind puudub",
        "minimum_price_hint": "Tehing ei tohi selle kogumi mahtu odavamalt hinnastada.",
        "minimum_price_negative": "Miinimumhind ei saa olla negatiivne.",
        "minimum_price_too_precise": "Miinimumhinnal võib olla kõige rohkem {decimals} komakohta.",
        "contango": {
          "label": "Contango",
          "help": "Contango tähendab, et forward-hind on müügipäeva hetkehinnast kõrgem.",
          "none": "Müü hetkehinnast sõltumata",
          "any": "Müü ainult contango korral",
          "at_least_20_percent": "Müü ainult contango korral, vähemalt 20% üle hetkehinna (ei soovitata)",
          "discouraged": "20% lisatasu hetkehinna suhtes on haruldane, seega müüakse selle kogumi mahtu harva. Kaalu valikut „Müü ainult contango korral”."
        },
        "archive_on_delivery": "Arhiveeri kogum, kui selle viimane kohustus on tarnitud",
        "archive_on_delivery_hint": "Sobib kogumile, mis on loodud ühe lepingu jaoks."
      },
      "advanced_listing": {
        "label": "Näita täpsemaid pakkumise valikuid",
        "hint": "Kõik, kes seda kogumit muudavad, näevad kõiki pakkumise kujusid: ühekordne, muud perioodi pikkused ja toodangupõhine. Ilma selleta pakub redaktor ainult korduva pakkumise kvartaleid.",
        "locked": "Jääb sisse, kuni pakkumine on midagi muud kui korduv ja kvartaalne või kuni kogum müüb ette."
      },
      "volumes": {
        "title": "Pakutud maht",
        "intro": "Sisesta, kui palju see kogum igal perioodil forward-müügiks pakub. Maht kehtib kogu kogumile, mitte igale ettevõttele eraldi. Pakutud maht ei ole siduv ja seda saab igal ajal muuta. See muutub siduvaks, kui see seotakse tehinguga, ja seotud maht tuleb tarnida ka siis, kui pakutud mahtu hiljem vähendad. Võid sisestada MWh või % prognoositud toodangust. % salvestatakse MWh-na.",
        "previewing": "Uuendamine",
        "mode": "Kuidas mahud on esitatud",
        "entry_width": "Perioodi pikkus",
        "entry_width_hint": "Iga pakutava perioodi pikkus. Sinu mahtu võib müüa koos sinu teiste perioodidega pikema perioodina, kuid mitte kunagi lühemateks osadeks jagatuna.",
        "month_note": "Kasutatav ainult registrites, kus päritolutunnistusi väljastatakse iga kuu.",
        "month_warning": "See on täiustatud funktsioon. Kuupõhised pakkumised ei võimalda tasakaalustamist: ühe kuu ületoodang ei saa katta teise kuu alatoodangut.",
        "half_year_note": "Poolaastane kogum saab tarnetes katta ainult poolaasta ja terve aasta tootmisperioode.",
        "year_note": "Aastane kogum saab tarnetes katta ainult terve aasta tootmisperioode.",
        "pay_as_produced_note": "Toodangupõhine kogum müüb oma seadmete kogu toodangu, seega mahte ei pakuta ja selle seadmed ei tohi kuuluda ühessegi teise kogumisse.",
        "period": "Periood",
        "share_of_estimate": "% prognoosist",
        "feedback": "Seotud · vaba · prognoos",
        "mwh_for": "Perioodiks {period} pakutud MWh",
        "share_for": "Osakaal prognoosist perioodil {period}",
        "remove_period": "Eemalda {period}",
        "no_rows": "Ühtegi perioodi pole veel pakutud.",
        "add_period": "Lisa periood",
        "whole_year": "Terve aasta",
        "no_estimate": "Prognoos puudub",
        "feedback_line": "seotud {committed} · vaba {free} · prognoos {estimated}",
        "free_hint": "Vaba on see, mida saab veel täna müüa: mitte midagi, kui perioodi tootmine on läbi, mitte midagi, mida müügistrateegia pole veel vabastanud, ja mitte rohkem, kui seda ümbritseval kvartalil, poolaastal ja aastal on alles.",
        "over_committed": "Seotud on rohkem kui pakutud",
        "over_committed_note": "Nendes perioodides on seotud rohkem kui pakutud. Kohustused täidetakse sellest hoolimata; neist perioodidest ei saa midagi uut müüa.",
        "over_committed_period": "{period}: seotud {committed} MWh, pakutud {listed} MWh",
        "over_estimate": "{percent}% prognoosist",
        "errors": {
          "period_duplicate": "See periood on juba teisel real."
        },
        "how_it_works": "Kuidas pakkumine toimib"
      },
      "production_range": {
        "limited": "Piira pakkumine kindla tootmisperioodiga",
        "first_month": "Esimene toodangukuu",
        "last_month": "Viimane toodangukuu",
        "hint": "Uued tehingud võivad hõlmata ainult nende kuude toodangut. Korduv pakkumine ei paku midagi väljaspool neid kuid; toodangupõhine leping peab jääma nende sisse. Jäta kuu tühjaks, kui sellel poolel piirangut pole.",
        "no_limit": "Piiranguta",
        "last_before_first": "Viimane kuu ei saa olla enne esimest."
      },
      "members": {
        "title": "Ettevõtted",
        "description": "Kelle toodangut see kogum müüb.",
        "search": "Otsi ettevõtteid",
        "not_enabled": "Forward-müük ei ole lubatud. Võta ühendust klienditoega.",
        "not_allocation_ready": "Öine jaotus ei ole seadistatud, seega selle jaoks midagi tagatisele ei liigu.",
        "no_candidates": "Ükski ettevõte ei sobi.",
        "at_least_one": "Kogumis peab olema vähemalt üks ettevõte."
      },
      "devices": {
        "title": "Seadmed",
        "description": "Kõik ülalolevate ettevõtete registreeritud seadmed. Prognoosidest on PPA maha arvatud.",
        "use_allowlist": "Müü ainult valitud seadmetest",
        "empty": "Seadmeid ei ole.",
        "loading": "Ettevõtete seadmete laadimine…",
        "include": "Lisa {device}",
        "device": "Seade",
        "company": "Ettevõte",
        "obligations": "Kohustused",
        "pool_count": "{n} kogum | {n} kogumit",
        "ppa_count": "{n} PPA | {n} PPA-t",
        "obligations_note": "Kõik, mis seda seadet juba nõuab: kogumid, kuhu see kuulub (kattumine on lubatud, konkureerivad pakutud mahud), ja PPA-d, mis seda katavad. PPA teenindatakse forvarditest ees, nii et selle maht ei jõua kunagi kohustuseni. Toodangupõhise kogumi seade kuulub ainult sellele kogumile ja seda ei saa siia lisada.",
        "country": "Riik",
        "technology": "Tehnoloogia",
        "cod": "Kasutuselevõtt",
        "support": "Toetus",
        "ecolabel": "Ökomärgise nõuetele vastav",
        "estimate": "Prognoos (MWh)",
        "estimate_note": "Prognoos katab kogumi pakutud perioodid ja arvestab juba maha iga seadme PPA osa.",
        "unnamed": "Seade {id}",
        "stale_deleted_by_registry": "Register on selle kustutanud. Eemalda linnuke, et see kogumist eemaldada.",
        "stale_not_registered": "Pole enam registreeritud. Eemalda linnuke, et see kogumist eemaldada.",
        "include_all": "Kaasa kõik seadmed"
      },
      "eligibility": {
        "title": "Tehingu sobivus",
        "description": "Mida leiaks siit tehing, mis iga mõõdet piirab. Iga väärtuse määrab kõige nõrgem seade.",
        "country_tier": "Riigid",
        "tier": {
          "standard_aib_gc": "Standardne AIB GC",
          "aib_outside_standard": "AIB, väljaspool standardvalikut",
          "pl_be": "Poola / Belgia",
          "non_aib": "Väljaspool AIB-d",
          "unknown": "Määramata"
        },
        "technology_mix": "Tehnoloogiad",
        "oldest_cod": "Vanim kasutuselevõtu kuupäev",
        "cod_claim_year": "Aruandeaastal {year} on eelistatud käikuandmise kuupäev {cutoff} või hilisem. See kontroll hindab ainult vanust.",
        "cod_preferred": "Kõik seadmed vastavad sellele vanuseelistusele.",
        "cod_not_preferred": "Kogum ei vasta sellele vanuseelistusele või käikuandmise kuupäevad puuduvad.",
        "supported": "Tootmistoetus",
        "ecolabels": "Ökomärgised",
        "through_year": "kuni aastani {year}",
        "failing_device_count": "ei täida {count} seadet {total}-st",
        "failing_device_count_named": "ei täida {count} seadet {total}-st: {devices}",
        "blocker_device_count": "{count} seadet {total}-st",
        "blocker_device_count_named": "{count} seadet {total}-st: {devices}",
        "no_issues": "Selle näitaja puhul probleeme ei tuvastatud. Tehingupõhised piirangud kehtivad endiselt.",
        "no_devices": "Selles kogumis pole seadmeid.",
        "all_qualify": "Kõik seadmed kvalifitseeruvad"
      },
      "commitments": {
        "title": "Selle kogumi kohustused",
        "description": "Mis on siit müüdud.",
        "loading": "Kohustuste laadimine",
        "empty": "Sellest kogumist ei ole midagi müüdud.",
        "all_completed": "Kõik selle kogumi kohustused on lõpetatud.",
        "show_completed": "Näita lõpetatuid ({count})",
        "period": "Tootmisperiood",
        "escrowed": "Tagatisel",
        "window": "Tarneaken",
        "status": "Staatus",
        "deal": "Tehing",
        "open_deal": "Ava tehing",
        "committed_on": "Kohustus võetud",
        "on_or_before": "hiljemalt {date}"
      },
      "escrow_remaining": {
        "description": "Sinu ettevõtted ei kuulu enam sellesse kogumisse, kuid alljärgnevad sertifikaadid jäävad tagatiskontole, kuni nendega kaetud tarned on saadetud või tagastatud. Muud kogumi kohta ei kuvata.",
        "empty": "Sulle ei ole siia kogumisse midagi jäänud.",
        "period": "Periood",
        "escrowed": "Tagatiskontol",
        "status": "Tehingu olek",
        "window_end": "Tarne hiljemalt"
      },
      "editor": {
        "loading": "Kogumi laadimine",
        "not_found_title": "See kogum ei ole kättesaadav",
        "not_found_body": "Seda ei ole olemas või see kuulub ettevõtetele, millele sul ligipääsu ei ole.",
        "title": "Kogum",
        "new_title": "Uus kogum",
        "description": "Kogum määrab, millist mahtu selle ettevõtted forward-müügiks pakuvad ja millistest seadmetest.",
        "name": "Nimi",
        "name_hint": "Nähtav kõigile, kes seda kogumit näevad, sealhulgas liikmesettevõtte omanikele, kes seda avada ei saa, ning Solderale tehingute koostamisel. Nimeta grupp ja see, mida see müüb, nt „Acme tuul 2027“. Ära lisa ostjate nimesid ega hindu.",
        "pool_description": "Kirjeldus",
        "pool_description_hint": "Märkmed liikmesettevõtetele, näiteks grupi kokkulepped, kontaktisik või muu, mida selle kogumi müümisel arvestada. Seda saavad lugeda kõik, kes saavad kogumit avada. See on ainult informatiivne: müüdava mahu määravad pakutud mahud ja seaded.",
        "delete": "Kustuta",
        "confirm_delete": "Kustutada see kogum? Selle vastu ei ole kunagi kohustusi võetud, seega midagi ei lähe kaotsi.",
        "archive": "Arhiveeri",
        "unarchive": "Taasta arhiivist",
        "discard": "Tühista muudatused",
        "save": "Salvesta",
        "save_anyway": "Salvesta siiski",
        "save_failed": "Kogumit ei õnnestunud salvestada. Kontrolli vormi ja proovi uuesti.",
        "unsaved_changes": "Sul on salvestamata muudatusi.",
        "close_confirm": "Sulgeda kogum ja loobuda salvestamata muudatustest?",
        "read_only": "Sa näed seda kogumit, aga ei saa seda muuta.",
        "details_title": "Nimi ja kirjeldus",
        "name_required": "Sisesta kogumi nimi."
      },
      "wizard": {
        "step_members": "Ettevõtted ja seadmed",
        "step_listing": "Pakkumine",
        "step_confirm": "Kinnitamine",
        "create": "Loo kogum"
      },
      "summary": {
        "title": "Kokkuvõte",
        "companies": "Ettevõtted",
        "devices": "Seadmed",
        "devices_all": "Kõik seadmed ({count})",
        "devices_allowlisted": "Ühtegi seadet pole valitud | {count} valitud seade | {count} valitud seadet",
        "listing": "Pakkumine",
        "obligation_note": "Need on täpsed mahud, mitte tootmise hinnangud. Nende pakkumine ei ole siduv, kuid kui tehing võtab sellest kogumist mahtu, on kogumi ettevõtted juriidiliselt kohustatud tarnima täpselt tehingu võetud mahu, olenemata sellest, kui palju nende seadmed toodavad.",
        "obligation_note_pay_as_produced": "Kui tehing võtab sellest kogumist mahtu, on kogumi ettevõtted juriidiliselt kohustatud tarnima kõik, mida nende seadmed tehingu perioodil toodavad."
      },
      "cell_sellable_now": "Praegu müüdav: {value} MWh"
    },
    "sales_strategy": {
      "title": "Müügistrateegia",
      "help": "Kuidas selle kogumi pakutud maht aja jooksul müüki lastakse. Tootmisaasta müümine osade kaupa, eri aegadel, hajutab selle hinnariski.",
      "split": {
        "asap": "Nii kiiresti kui võimalik",
        "half_yearly": "Müü kaks korda aastas",
        "quarterly": "Müü neli korda aastas"
      },
      "split_help": {
        "asap": "laseb kogu mahu müüki korraga",
        "half_yearly": "laseb mahu müüki kahes võrdses osas",
        "quarterly": "laseb mahu müüki neljas võrdses osas (soovitatav)"
      },
      "sell_ahead": {
        "label": "Müü ette",
        "help": "Kui suur osa igast tootmisaastast müüakse kaks aastat enne tootmist. Ülejäänu müüakse tootmisele eelneval aastal.",
        "next_year_only": "Ainult järgmine aasta",
        "preset": "{percent}%",
        "lead_next_year": "Iga tootmisaasta müüakse sellele eelneval aastal.",
        "lead_ahead": "Iga tootmisaasta müüakse kahe aasta jooksul: {early}% kaks aastat enne tootmist ja ülejäänud {rest}% tootmisele eelneval aastal.",
        "cadence": {
          "asap": "Kogu maht lastakse müüki 1. jaanuaril.",
          "half_yearly": "See lastakse müüki kahes võrdses osas, 1. jaanuaril ja 1. juulil.",
          "quarterly": "See lastakse müüki neljas võrdses osas, 1. jaanuaril, 1. aprillil, 1. juulil ja 1. oktoobril."
        },
        "cadence_ahead": {
          "asap": "Kumbki osa lastakse müüki korraga, 1. jaanuaril.",
          "half_yearly": "Kumbki osa lastakse müüki kahes võrdses osas, 1. jaanuaril ja 1. juulil.",
          "quarterly": "Kumbki osa lastakse müüki neljas võrdses osas, 1. jaanuaril, 1. aprillil, 1. juulil ja 1. oktoobril."
        },
        "bar_caption": "{year}. aasta toodang",
        "bar_segment": "Müüakse {year}. aastal · {percent}%",
        "release_more": "Salvestamine laseb kohe müüki {mwh} MWh rohkem {year}. aasta toodangut, sest selle varasemad müügiaknad on juba avanenud.",
        "release_less": "Salvestamine hoiab tagasi {mwh} MWh {year}. aasta toodangut, mis on täna müügiks vabastatud."
      },
      "summary": "{split}, {horizon}",
      "summary_split": {
        "asap": "nii kiiresti kui võimalik",
        "half_yearly": "kaks korda aastas",
        "quarterly": "neli korda aastas"
      },
      "summary_next_year": "järgmise aasta toodang",
      "summary_ahead": "{percent}% kaks aastat ette",
      "future_only": "Muudatus kehtib ainult tulevastele müükidele. Juba seotud maht jääb kehtima.",
      "schedule_title": "Müügi ajakava",
      "schedule_open": "Näita müügi ajakava",
      "schedule_pending": "Müügi ajakava ilmub siia, kui kogumi eelvaade on saadaval.",
      "schedule_empty": "Eelolevateks tootmisaastateks pole veel midagi pakutud.",
      "schedule_timeline": "{year}. aasta müügigraafik",
      "schedule_production": "Toodang",
      "schedule_auction": "Q{quarter} oksjon",
      "schedule_total": "Kokku",
      "schedule_opens_on": "Avaneb {date}",
      "schedule_group_early": "{year}. aasta toodang · varajane osa {percent}%",
      "schedule_group_early_note": "(ülejäänud {percent}% {year}. aastal)",
      "schedule_group_rest": "{year}. aasta toodang · ülejäänud {percent}%",
      "schedule_group_rest_note": "({percent}% vabastati {year}. aastal)",
      "commitments_stand_inline": "Osa kohustusi ületab seda, mida see strateegia täna müüki laseb. Need jäävad kehtima; strateegia kehtib uutele müükidele.",
      "held_back": "Müügistrateegia ({strategy}) hoiab tagasi {mwh} MWh.",
      "held_back_next_release": "Müügistrateegia ({strategy}) hoiab tagasi {mwh} MWh; veel {next} MWh lastakse müüki {date}.",
      "held_back_reason": "müügistrateegia hoiab tagasi",
      "held_back_reason_until": "müügistrateegia hoiab tagasi kuni {date}",
      "override": {
        "label": "Eira kõiki müügistrateegiaid (OHTLIK)",
        "banner_title": "Müük ületab tootja müügistrateegia",
        "subject": "{pool}: {period}",
        "beyond_line": "{subject} — {mwh} MWh üle müügistrateegia ({strategy}).",
        "beyond_line_next_release": "{subject} — {mwh} MWh üle müügistrateegia ({strategy}); järgmine müükilaskmine {date}.",
        "ignored_nothing_beyond": "Müügistrateegiat eiratakse — ükski võetud kogus seda veel ei ületa",
        "ignored_figures_unknown": "Müügistrateegiat eiratakse — selle näitajaid ei õnnestunud lugeda; salvestamine teatab kogusest, mis seda ületab"
      }
    },
    "picker": {
      "mode": {
        "existing_inventory": "Olemasolev laoseis",
        "future_inventory": "Tulevane toodang"
      },
      "new_pap_deal": "Uus toodangupõhine tehing →",
      "deal": {
        "title": "Tehing",
        "description": "Ostja, hinnad ja tarnekava määratakse tehingu lehel, kui see mustand on loodud."
      },
      "filters": {
        "title": "Tootmisperiood ja kiirfiltrid"
      },
      "pools": {
        "title": "Vali kogumid"
      },
      "cancel": "Loobu",
      "confirm": "Loo tehingu mustand",
      "confirming": "Loon…",
      "footer_note": "Tehingu loomine kirjutab mustandi, milles on iga kogumi kohta üks kohustus ja tarnete kavand. Ostja andmed, hinnad ja tarnekava määratakse tehingu lehel.",
      "criteria": {
        "description": "Millega ostja end seob. Tehing peab neile tingimustele vastama kogu oma eluea.",
        "name": "Tehingu nimi",
        "name_placeholder": "nt Nordic buyer 2026",
        "description_label": "Kirjeldus",
        "description_placeholder": "Vabatahtlik tekst arve reale",
        "countries": "Riigid",
        "countries_all": "Kõik riigid",
        "countries_hint": "Eeltäidetud standardsete AIB GC riikidega. Tühjenda väli, et lubada kõik riigid.",
        "technologies": "Tehnoloogiad",
        "technologies_all": "Kõik tehnoloogiad",
        "technologies_advanced": "Täiendav",
        "cod_from": "Kasutuselevõtt alates",
        "cod_until": "Kasutuselevõtt kuni",
        "cod_hint": "Piirab tehingu seadmetega, mille kasutuselevõtu kuupäev jääb sellesse vahemikku.",
        "support": "Tootmistoetus",
        "support_any": "Ükskõik",
        "support_no": "Ainult toetuseta",
        "ecolabels": "Ökomärgised",
        "ecolabels_all": "Ökomärgise nõuet pole",
        "ecolabels_hint": "OK-power new aegub seadme vanusega, seega võib kogum vastata varasemale tootmisaastale ja hilisemale mitte.",
        "min_price_filter": "Peida kogumid hinnaga üle",
        "min_price_filter_hint": "Ainult vaatefilter. Seda ei salvestata tehinguga.",
        "quick_filters": "Kiirfiltrid",
        "quick_aib_gc": "Standardne AIB GC",
        "quick_hsw": "HSW",
        "quick_biomass": "@:common.technology.biomass",
        "quick_nuclear": "Tuumaenergia",
        "name_required": "Anna tehingule nimi."
      },
      "ecolabel": {
        "ekoenergy": "EKOenergy eelkinnitatud",
        "okpower": "OK-power ühilduv",
        "okpower_new": "OK-power new ühilduv"
      },
      "period": {
        "title": "Tootmisperioodid",
        "from": "Alates",
        "until": "Kuni",
        "invalid_range": "Vahemik lõpeb enne algust.",
        "selected": "{count} perioodi: {periods}",
        "month_warning": "Kuupõhiseid perioode saab katta ainult seal, kus register väljastab kuiseid tõendeid. Kogumid, mille seadmed väljastavad laiemate perioodide kaupa, on tabelis märgitud.",
        "half_year_warning": "Iga kogum tarnib kvartalite kaupa, kui selle pakkumised ja register seda võimaldavad, muidu poolaasta kaupa: iga osa tarnitakse pärast kvartalit, millega see lõpeb.",
        "year_warning": "Iga kogum tarnib kvartalite kaupa, kui selle pakkumised ja register seda võimaldavad, muidu poolaasta või aasta kaupa: iga osa tarnitakse pärast kvartalit, millega see lõpeb."
      },
      "take": {
        "filter_pool": "Kogum või ettevõte",
        "auto_distribute": "Jaota automaatselt",
        "spread": "Jaota kogumite vahel",
        "target": "MWh",
        "target_label": "Sihtmaht",
        "clear": "Tühjenda",
        "pool": "Kogum",
        "technology": "Tehnoloogia",
        "country": "Riik",
        "cod": "Vanim kasutuselevõtt",
        "ecolabels": "Ökomärgised",
        "support": "Toetus",
        "conditions": "Tingimused",
        "take": "Võta (MWh)",
        "no_floor": "Alampiir puudub",
        "floor_value": "{value} €/MWh",
        "contango": {
          "any": "müüb ainult contango korral",
          "at_least_20_percent": "müüb ainult ≥ 20% üle hetkehinna"
        },
        "contango_filter": {
          "none": "Contango tingimuseta",
          "any": "Mis tahes contango",
          "at_least_20_percent": "Contango ≥ 20%"
        },
        "cadence": "Need seadmed väljastavad valitud vahemikust laiemate perioodide kaupa.",
        "allocation_not_ready": "Jaotamine on välja lülitatud: {companies}. Nende eest ei panda midagi tagatisele.",
        "capacity_cap": "Valitud vahemikus kuni {value} MWh.",
        "capacity_period": "{period}: {value}",
        "row_subtitle": "{companies} · {devices}",
        "empty": "Ükski kogum ei kata seda toodet selles vahemikus.",
        "loading": "Otsin kogumeid",
        "refreshing": "Värskendan",
        "refresh_pending": "Enne tehingu loomist oota, kuni kogumite tabel värskeneb.",
        "load_failed": "Kogumite tabelit ei õnnestunud laadida.",
        "hint_floor": "Selle valiku tarnet ei tohi hinnastada alla {value} €/MWh.",
        "warnings_title": "Tasub üle vaadata",
        "ineligible_title": "Välja jäetud ({count})",
        "ineligible_hint": "Kogumid, mida saaksid kasutada, kuid mille see toode või vahemik välistab."
      },
      "summary": {
        "all": "Kõik kogumid",
        "taken": "Võetud",
        "pools_count": "{count} kogumit",
        "by_period": "Tootmisperioodi järgi",
        "by_period_estimate": "Hinnanguline jaotus. Täpne selgub tehingu loomisel.",
        "by_country": "Riigi järgi",
        "by_price": "Hinnatingimuse järgi",
        "by_technology": "Tehnoloogia järgi",
        "by_cod": "Käikuandmise kuupäev",
        "re100": "RE100 sobivus",
        "by_ecolabel": "Ökomärgise staatus",
        "by_support": "Toetuse staatus",
        "cod_young": "COD ≤5 aastat",
        "cod_middle": "COD 6–15 aastat",
        "cod_old": "COD >15 aastat",
        "pool_qualifications": "Omadused kirjeldavad terveid kogumeid, mitte eraldatud sertifikaate. COD lähtub vanimast seadmest; RE100 ja ökomärgised nõuavad kõigi seadmete vastavust kogu perioodil.",
        "judged_at": "hinnatud seisuga {date}",
        "nothing_taken": "Midagi pole veel võetud."
      },
      "errors": {
        "no_takes": "Võta mahtu vähemalt ühest kogumist.",
        "create_failed": "Tehingut ei õnnestunud luua.",
        "over_capacity": "Mõni võetud kogus ületab seda, mida kogum müüa võib. Vähenda see enne kogumi piirini."
      }
    },
    "pap": {
      "title": "Uus toodangupõhine tehing",
      "description": "Toodangupõhine tehing ostab ühe kogumi kogu toodangu kuu haaval kokkulepitud graafiku alusel.",
      "pool": "Toodangupõhine kogum",
      "pool_hint": "Seda tehingut saavad katta ainult toodangupõhised kogumid; nende seadmed ei kuulu ühtegi teise kogumisse.",
      "pool_empty": "Toodangupõhist kogumit veel pole. Loo see esmalt tootja töölaual.",
      "pool_devices": "{devices} seadet · {companies} ettevõtet",
      "pool_blocked_choose_another": "Tehingu loomiseks vali teine kogum.",
      "name": "Tehingu nimi",
      "name_placeholder": "nt Hüdrotoodang 2027",
      "description_label": "Kirjeldus",
      "description_placeholder": "Vabatahtlik tekst arve reale",
      "unit_price": "Ühikuhind",
      "unit_price_hint": "Iga lepingukuu arveldatakse selle hinnaga.",
      "window": "Lepinguperiood",
      "window_start": "Esimene kuu",
      "window_end": "Viimane kuu",
      "window_invalid": "Periood lõpeb enne algust.",
      "window_missing": "Vali perioodi esimene ja viimane kuu.",
      "window_too_long": "Lepinguperiood on kuni {count} kuud.",
      "schedule": "Kokkulepitud graafik",
      "schedule_hint": "Üks siht iga perioodi kuu kohta. Toodangut võrreldakse sellega kuu haaval.",
      "schedule_total": "{value} MWh {count} kuu peale",
      "tolerance": "Mahu hälve",
      "tolerance_hint": "Kui palju võib kuu sihist kõrvale kalduda, enne kui see märgitakse.",
      "context_failed": "Omaniku valikuid ei õnnestunud laadida.",
      "create": "Loo tehing",
      "creating": "Loon…",
      "cancel": "Loobu",
      "create_failed": "Tehingut ei õnnestunud luua.",
      "load_failed": "Kogumeid ei õnnestunud laadida.",
      "loading": "Laadin kogumeid",
      "production_range_from_until": "See kogum müüb ainult toodangut ajavahemikus {from} kuni {until}.",
      "production_range_from": "See kogum müüb ainult toodangut alates {from}.",
      "production_range_until": "See kogum müüb ainult toodangut kuni {until}.",
      "window_outside_range": "Lepingu periood peab jääma selle kogumi müüdava toodangu piiresse."
    },
    "transaction_header": {
      "title": "Forward-tarne",
      "deal": "Tehing",
      "window_open": "Tarne hiljemalt {date}",
      "window_range": "Tarne vahemikus {start} kuni {end}",
      "escrowed_of_planned": "{escrowed} / {planned} MWh tagatisel",
      "managed_note": "Kogused, summad, ostja andmed ja hinnad tulevad tehingust ning neid muudetakse seal.",
      "open_deal": "Ava tehing",
      "deal_notes": "Tehingu sisemärkmed",
      "delivery_notes": "Tarne sisemärkmed"
    },
    "deals": {
      "loading": "Laadin tehingut…",
      "not_found_title": "Tehingut ei leitud",
      "not_found_body": "Sellist tehingut ei ole või sul ei ole sellele ligipääsu.",
      "load_failed_title": "Tehingut ei õnnestunud laadida",
      "load_failed_body": "Midagi läks meie poolel valesti. Proovi hetke pärast uuesti.",
      "draft_warning": "Mustandtehing: selle tarneid ei näidata eelseisvate tarnete all ja sertifikaate ei jaotata enne tehingu kinnitamist.",
      "common": {
        "cancel": "Tühista",
        "close": "Sulge",
        "commitment_gone": "Seda seotud kogust tehingus enam ei ole."
      },
      "header": {
        "back": "← Forvardid",
        "buyer": "Ostja: {buyer}",
        "buyer_missing": "Ostjat ei ole veel sisestatud",
        "signed_at": "sõlmitud {date}"
      },
      "badges": {
        "escrow_shortfall": "tagatisel puudu {mwh} MWh",
        "infeasible": "{pool} ei kata perioodi {period} — puudu {mwh} MWh",
        "stale_draft": "Vana mustand",
        "drift_report": "{count} seadet ei sobi enam | {count} seade ei sobi enam | {count} seadet ei sobi enam",
        "drift_report_line": "{device}: {reasons}",
        "device_number": "Seade {id}",
        "free_escrow": "{mwh} MWh tagatist ootab tagastamist"
      },
      "metadata": {
        "title": "Ostja ja leping",
        "edit": "Muuda",
        "edit_title": "Ostja ja lepingu andmed",
        "save": "Salvesta",
        "name": "Tehingu nimi",
        "description": "Kirjeldus",
        "buyer": "Ostja",
        "emails": "Ostja e-postiaadressid",
        "registration_authority": "Registripidaja",
        "billing_country": "Arveldusriik",
        "deal_volume": "Tehingu maht",
        "signed_at": "Sõlmitud",
        "created_at": "Loodud",
        "confirmed_at": "Kinnitatud",
        "links": "Lingid",
        "contract_links": "Leping",
        "transaction_link": "Tehing",
        "offering_sheets": "Pakkumislehed",
        "offering_sheets_help": "Komadega eraldatud lingid, vanim esimesena. Lehe koostamine lisab lingi siia; kui loend on täis, kustuta vanad siit.",
        "transaction_link_invalid": "Sisesta üks http:// või https:// algusega link.",
        "shipped_keep_details": "Selle tehingu {count} tarnet on teele saadetud. Nende tehingud ja arved säilitavad ostja ja lepingu andmed, millega need saadeti; siinne muudatus jõuab ainult veel saatmata tarneteni. | Selle tehingu {count} tarne on teele saadetud. Selle tehing ja arved säilitavad ostja ja lepingu andmed, millega see saadeti; siinne muudatus jõuab ainult veel saatmata tarneteni. | Selle tehingu {count} tarnet on teele saadetud. Nende tehingud ja arved säilitavad ostja ja lepingu andmed, millega need saadeti; siinne muudatus jõuab ainult veel saatmata tarneteni.",
        "not_set": "Määramata"
      },
      "criteria": {
        "title": "Sobivustingimused",
        "edit": "Muuda",
        "save": "Salvesta tingimused",
        "locked": "Lukus",
        "countries": "Riigid",
        "technologies": "Tehnoloogiad",
        "cod": "Kasutuselevõtu kuupäev",
        "cod_from": "Kasutusele alates",
        "cod_until": "Kasutusele kuni",
        "cod_range": "{from} — {until}",
        "any": "vabalt",
        "support": "Tootmistoetus",
        "support_any": "Ükskõik",
        "support_unsupported_only": "Ainult toetuseta",
        "ecolabels": "Ökomärgised",
        "unrestricted": "Piiranguteta",
        "conflicts_help": "Salvestamine kontrollib muudatust esmalt. Muudatus, mis on vastuolus kogustega või tagatisega, mida tehing veel tarnib, lükatakse tagasi; selle tõttu ei vabastata ega tagastata midagi.",
        "conflicts_blocking": "See muudatus on vastuolus sellega, mida tehing veel tarnib. Lahenda need esmalt ja salvesta uuesti:",
        "conflicts_warning": "Juba tarnitud kehtivate tingimuste alusel. Salvestamine jätab need nii, nagu need on:",
        "save_anyway": "Salvesta siiski",
        "ecolabel": {
          "ekoenergy": "EKOenergy eelheakskiidetud",
          "okpower": "OK-power sobiv",
          "okpower_new": "OK-power new sobiv"
        }
      },
      "plan": {
        "title": "Tarneplaan",
        "generate_offering_sheet": "Koosta pakkumisleht",
        "offering_sheet_link": "Ava viimane pakkumisleht",
        "edit_plan": "Muuda plaani",
        "empty": "Sellel tehingul ei ole veel tarneid.",
        "delivery": "Tarne",
        "period": "Tootmisperiood",
        "escrowed_of": "Tagatisel / planeeritud",
        "backed_by": "Tagab",
        "backed_by_commitment": "Kaetud kohustusega {id}. Vt tabelit Kohustused.",
        "open_volume": "Katmata",
        "no_slices": "Selles tarnes ei ole veel midagi planeeritud.",
        "n_short": "puudu {mwh}",
        "n_open": "katmata {mwh}",
        "remove": "Eemalda",
        "actions": {
          "menu": "Toimingud: {period}",
          "resize": "Muuda kogust",
          "resize_tooltip": "Muuda selle tootmisperioodi seotud mahtu. Mahtu ei saa vähendada juba tagatisel olevast mahust väiksemaks.",
          "split_move": "Jaga ja liiguta",
          "split_move_tooltip": "Liiguta kogu see seotud maht või osa sellest teise tarnesse; tagatis liigub kaasa.",
          "narrow": "Kitsenda",
          "narrow_tooltip": "Jaga seotud tootmisperiood lühemateks perioodideks, näiteks aasta kvartaliteks, muutmata kogumahtu.",
          "remove_backing": "Eemalda kate",
          "remove_backing_tooltip": "Eemalda sellelt mahult kogumi kate, et mõni teine kogum saaks selle katta.",
          "remove_backing_escrowed_tooltip": "Selle mahu vastu on tagatishoiul {mwh} MWh. Tagasta see omanikule enne katte eemaldamist.",
          "pull_to_escrow": "Tõmba tagatisele…",
          "pull_to_escrow_tooltip": "Vali sellest kogumist saadaolevad sertifikaadid ja liiguta need selle kohustuse tagatiseks.",
          "back": "Kata…",
          "back_tooltip": "Kata see katmata maht sobiva kogumi kohustusega."
        },
        "window_on_or_before": "Hiljemalt {end}",
        "window_range": "{start} — {end}",
        "unit_price": "{price} €/MWh",
        "no_price": "Hind määramata",
        "delivery_shortfall": "puudu {mwh} MWh",
        "deliver": "Tarni →",
        "deliver_anyway": "Tarni siiski",
        "transaction_link": "Tehing #{id}",
        "outside_window_title": "Väljaspool tarneakent",
        "outside_window_body": "Tänane kuupäev jääb selle tarne aknast ({window}) välja. Kas tarnida siiski?",
        "summary_open": "{mwh} MWh katmata",
        "summary_fully_committed": "Kogu planeeritud maht on seotud",
        "summary_totals": "{planned} planeeritud · {committed} seotud · {escrowed} tagatisel",
        "summary_deal_volume": "tehingu maht {mwh} MWh",
        "summary_no_deal_volume": "tehingu mahtu ei ole salvestatud",
        "confirm": "Kinnita tehing",
        "cancel_deal": "Tühista tehing",
        "cancel_title": "Kas tühistada see tehing?",
        "cancel_body": "Tühistamine vabastab kõik seotud kogused ja tühistab kõik tarnimata mustandid. Juba tagatisel olev maht jääb alles kuni omanikele tagastamiseni.",
        "cancel_body_pap": "Tühistamisel tühistatakse kõik veel tarnimata kuud. Nende kuude jaoks juba tagatisel olevad sertifikaadid jäävad ootama tagastamist: tagasta need omanikele kaardilt „Tagatis ootab tagastamist“. Juba tarnitud kuud jäävad alles.",
        "unconfirm": "Tagasi mustandiks",
        "unconfirm_title": "Kas viia tehing tagasi mustandiks?",
        "unconfirm_body": "Tehing lahkub jaotusjärjekorrast, nii et sellele ei panda enam sertifikaate tagatisele, ning selle tingimusi saab jälle muuta. Seotud kogused jäävad alles ja maht püsib broneerituna. Ilma sõlmimiskuupäevata kaotavad tarned oma hinnakuupäeva. Uuesti kinnitamisel läheb tehing järjekorra lõppu."
      },
      "editor": {
        "title": "Plaani muutmine",
        "discard": "Loobu",
        "save": "Salvesta plaan",
        "window_start": "Akna algus · valikuline",
        "window_end": "Akna lõpp",
        "unit_price": "Ühikuhind",
        "remove_delivery": "Eemalda tarne",
        "add_period": "Lisa periood",
        "add_delivery": "Lisa tarne",
        "period_placeholder": "2026-Q1, 2026-04 või 2026",
        "planned_for": "Planeeritud maht perioodil {period}",
        "backed_caption": "{mwh} MWh kaetud",
        "below_backed": "Siin on kaetud {mwh} MWh. Planeeri vähemalt nii palju.",
        "remove_row_backed": "{mwh} MWh on kaetud. Eemalda esmalt kate plaanist.",
        "duplicate_period": "See tootmisperiood on selles tarnes juba olemas."
      },
      "correction": {
        "editor_hint": "Tarnitud ja tühistatud tarnete perioodid jäävad samaks. Superadministraatorina saad siiski parandada nende akent ja hinda; juba koostatud arved jäävad muutmata.",
        "schedule_hint": "Tarnitud kuu hinda saab parandada. Juba koostatud arved jäävad vana hinnaga.",
        "voided_delivery": "See tarne on tühistatud: muudatus on näha ainult tehingu lehel ning ükski arve ega aruanne seda ei loe.",
        "buyer_invoice_replaceable": "Ostja arve {number} jääb vana hinnaga. Loo see uuesti, kui seda pole veel saadetud.",
        "buyer_invoice_sent": "Ostja arve {number} on saadetud ja jääb vana hinnaga. Seda ei saa enam uuesti luua.",
        "completion_invoices_issued": "Lõpetamisel arveldatud tootja väljamakse ja võimalik vahendustasu jäävad vana hinnaga.",
        "dashboard_period_moves": "Ükski arve ei loe tarneakent. Ainult finantsülevaade viib müügi uue akna lõpu perioodi."
      },
      "commitments": {
        "title": "Seotud kogused",
        "empty": "Sellel tehingul ei ole veel katet.",
        "description": "Iga rida on üks mahu võtmine kogumist. Maht ja hinnatingimused fikseeriti võtmise hetkel; kogumi pakkumine ja hinnad võivad olla vahepeal muutunud.",
        "granularity": "Detailsus: {width}",
        "id_header": "ID",
        "pool_header": "Kogum",
        "pulled_on": "Võetud",
        "volume": "Tagatisel / seotud",
        "price_conditions": "Hinnatingimused",
        "released": "Vabastatud",
        "released_tooltip": "Päev, mil see tagatis täielikult eemaldati: maht läks tagasi kogumi saadavusse ja kohustus ei nõua enam selle laoseisu.",
        "floor": "alampiir {price} €/MWh",
        "no_floor": "alampiir puudub",
        "contango": {
          "any": "ainult contango korral",
          "at_least_20_percent": "ainult ≥ 20% üle hetkehinna"
        },
        "show_escrow": "Tagatishoius…",
        "show_escrow_tooltip": "Näita, milliste ettevõtete sertifikaadid seda kohustust katavad; peaadministraator saab need siit omanikele tagastada.",
        "contributions": "Panused · tagatis ettevõtete kaupa",
        "escrow_title": "{pool} · võetud {date}",
        "company": "Ettevõte",
        "no_escrow": "Selle koguse vastu ei ole veel midagi tagatisel.",
        "entry_width": {
          "quarter": "kvartaalne",
          "month": "kuine",
          "half_year": "poolaastane",
          "year": "aastane"
        },
        "pay_as_produced": "toodangupõhine",
        "strategy_overridden": "Müüdud üle müügistrateegia",
        "sold_beyond_strategy": "{pool} — {mwh} MWh müüdi üle müügistrateegia."
      },
      "free_escrow": {
        "title": "Tagatis ootab tagastamist",
        "subtitle": "{mwh} MWh, millel ei ole enam kehtivat tarnet",
        "return": "Tagasta omanikule…",
        "company": "Ettevõte",
        "period": "Tootmisperiood"
      },
      "add_commitment": {
        "title_back": "Kata {period}",
        "submit": "Lisa kogus",
        "search": "Otsi kogumeid",
        "search_placeholder": "Sisesta osa kogumi nimest",
        "searching": "Otsin kogumeid…",
        "no_pools": "Ükski sulle kättesaadav kogum ei vasta sellele otsingule.",
        "listed": "pakutud {mwh} MWh",
        "no_availability": "{period} pole midagi saadaval",
        "takes_title": "Kui palju sellest perioodist võtta",
        "open": "Katmata",
        "take": "Võta",
        "take_for": "Võetav kogus perioodil {period}",
        "max": "kuni {mwh}",
        "over_max": "siit saab võtta kuni {mwh} MWh",
        "impact": "Katmata maht väheneb {from} MWh-lt {to} MWh-le.",
        "submit_beyond_strategy": "Lisa kogus üle müügistrateegia"
      },
      "resize": {
        "title": "Muuda seotud kogust",
        "submit": "Muuda",
        "body": "{period} · {pool} · praegu seotud {mwh} MWh.",
        "new_volume": "Uus seotud maht",
        "escrow_floor": "Selle osa vastu on juba {mwh} MWh tagatisel, seega alla selle minna ei saa.",
        "shrink_warning": "Loovutatav {mwh} MWh muutub katmata mahuks ja läheb tagasi kogumi saadaolevasse mahtu. Kohustus säilitab ülejäänud mahu jaoks oma salvestatud hinnatingimused; hiljem selle mahu uuesti katmine loob uue kohustuse tolle päeva tingimustega.",
        "submit_beyond_strategy": "Muuda üle müügistrateegia"
      },
      "move": {
        "title": "Liiguta või jaga",
        "submit": "Liiguta",
        "body": "{period} · {mwh} MWh. Juba tagatisel olev maht liigub kaasa.",
        "target": "Sihttarne",
        "target_placeholder": "Vali tarne",
        "volume": "Liigutatav maht",
        "volume_placeholder": "Kogu osa",
        "volume_hint": "Jäta tühjaks, et liigutada kogu osa.",
        "volume_out_of_range": "1 kuni {mwh} MWh, viilu maht"
      },
      "narrow": {
        "title": "Kitsenda perioodi",
        "submit": "Kitsenda",
        "body": "{period} · {mwh} MWh. Maht jaotatakse alamperioodide vahel vastavalt sellele, kui palju kogum igas neist pakub.",
        "width": "Kitsenda ühikuks",
        "already_narrowest": "See periood on juba kõige kitsam võimalik.",
        "hint": "Juba tagatisel olev maht kinnitatakse ümber sellele alamperioodile, kuhu iga sertifikaat kuulub."
      },
      "remove_backing": {
        "title": "Kas eemaldada selle kogumi kate?",
        "pull": "Võetud {date} · {conditions}",
        "released_whole": "{mwh} MWh läheb tagasi kogumi {pool} saadaolevasse mahtu ja see kohustus vabastatakse täielikult, sest see on selle viimane kaetud maht.",
        "released_part": "{mwh} MWh läheb tagasi kogumi {pool} saadaolevasse mahtu ja see kohustus vabastatakse osaliselt, sest selle ülejäänud kaetud maht jääb alles.",
        "snapshot_lost": "Võtmise hetkel salvestatud hinnatingimused lähevad kaotsi. Hiljem selle mahu uuesti katmine loob uue kohustuse tolle päeva kogumitingimustega ja ainult siis, kui maht on veel saadaval.",
        "confirm": "Eemalda kate"
      },
      "return_escrow": {
        "section_title": "Tagasta omanikule",
        "title": "Tagasta tagatis omanikule",
        "submit": "Tagasta valitud",
        "loading": "Laadin tagatisel olevaid sertifikaate…",
        "body": "Valitud sertifikaadid jäävad Soldera registrikontole ja määratakse iga omaniku uude virtuaalportfelli. Iga rea saab tagastada ka osaliselt.",
        "nothing": "Selle tehingu jaoks ei ole midagi tagatisel.",
        "company": "Ettevõte",
        "device": "Seade",
        "month": "Tootmiskuu",
        "escrowed": "Tagatisel",
        "return_count": "Tagastada",
        "select_all": "Vali kõik read",
        "select_row": "Vali {device}",
        "count_for": "Tagastatav kogus seadmelt {device}",
        "over_count": "sellel real on tagatisel kuni {mwh} MWh",
        "summary_title": "Tagastatakse",
        "results_title": "Tagastatud {moved} MWh, {failed} rida ebaõnnestus.",
        "result_line": "{count} MWh kirjelt {item}"
      },
      "pull_escrow": {
        "title": "Tõmba tagatisele",
        "submit": "Tõmba tagatisele",
        "body": "Liiguta sertifikaadid, mis forvardisammust mööda läksid, selle koguse tagatisele. Omanik jääb samaks.",
        "company": "Ettevõte",
        "company_placeholder": "Vali kogumi liige",
        "source_portfolio": "Lähteportfell",
        "portfolio_placeholder": "Vali portfell",
        "allowed_sources": "Tõmmata saab ainult jaotamata, ootel, spot- ja virtuaalportfellidest.",
        "loading_items": "Laadin sertifikaate…",
        "no_items": "Selles portfellis ei ole midagi, mida saaks tõmmata.",
        "items_failed": "Sertifikaate ei õnnestunud laadida. Uuesti proovimiseks sulge see vorm ja ava see uuesti.",
        "after_move": "Selle koguse tagatis kasvab {from} MWh-lt {to} MWh-le seotud {total} MWh-st.",
        "results_title": "Liigutatud {moved} rida, {failed} rida ebaõnnestus.",
        "result_line": "{count} MWh kirjelt {item}"
      },
      "producer_prices": {
        "button": "Tootjate hinnad…",
        "title": "Tootjate hinnad · {window}",
        "body": "Mida iga tootja selle tarne eest arveldab. Need on Soldera ostuhinnad ja neid ei näidata kunagi tehingu omanikule.",
        "no_lines": "Ühelgi tootjal pole selles tarnes veel sertifikaate. Nende read ilmuvad siia, kui sertifikaadid tagatisele jõuavad.",
        "company": "Tootja",
        "amount": "MWh",
        "price": "Ühikuhind",
        "price_for": "Ettevõtte {company} ühikuhind",
        "delivery_price_note": "Tühjaks jäetud tootja arveldab tarne enda hinnaga: {price}.",
        "trade_owner": "Tehingu vahendaja",
        "trade_owner_help": "Saab vahendustasu vahetustehingu marginaalilt.",
        "trade_owner_placeholder": "Vali tehingu vahendaja…",
        "trade_owner_none": "Puudub",
        "submit": "Salvesta",
        "lines_removed": "{count} tootja rida lahkus vahepeal tarnest ja jäeti välja | {count} tootja rida lahkus vahepeal tarnest ja jäeti välja | {count} tootja rida lahkus vahepeal tarnest ja jäeti välja",
        "shipped_meanwhile": "See tarne saadeti sinu muutmise ajal teele. Selle hinnad on nüüd ajalugu, seega sinu muudatusi ei salvestatud.",
        "delivery_gone": "Seda tarnet pole enam tehingus, seega sinu muudatusi ei salvestatud.",
        "blank_price": "tühi (tarne hind)",
        "default_price": "Tootja vaikehind",
        "default_price_help": "Tühjaks jäetud tootjad ja tootjad, kelle sertifikaadid jõuavad tarnesse hiljem, arveldavad selle hinnaga. Jäta tühjaks, et kasutada tarne enda hinda.",
        "default_price_note": "Tühjaks jäetud tootja arveldab tootja vaikehinnaga: {price}.",
        "default_price_none": "Puudub (tarne enda hind)",
        "blank_follows_default": "tühi (tootja vaikehind)",
        "no_escrow_yet": "Escrow puudub",
        "kept_outside_pools": "Pole toetavas kogumis",
        "kept_outside_pools_help": "Säilinud ajast, mil see tootja kuulus tarnet toetavatesse kogumitesse. Kehtib uuesti, kui tootja naaseb; eemalda, kui see ei peaks kehtima.",
        "add_producer": "Määra tootja hind enne escrow'd",
        "add_producer_placeholder": "Vali tarnet toetava basseini liige…",
        "add_producer_help": "Tarnet toetava basseini liikmele saab määrata oma hinna enne, kui tema sertifikaadid saabuvad.",
        "eligible_error": "Toetavate basseinide liikmeid ei õnnestunud laadida.",
        "pool_floor": "{pool} (miinimum {price})",
        "remove_producer": "Eemalda ettevõtte {company} hind"
      },
      "delivery_notes": {
        "button": "Märkmed…",
        "title": "Sisemärkmed · {window}",
        "label": "Sisemärkmed",
        "help": "Ainult töötajatele: ei kopeerita tarne tehingule ega näidata tootjatele ega ostjatele.",
        "submit": "Salvesta",
        "heading": "Sisemärkmed",
        "default_producer_price": "Tootjate vaikehind: {price}"
      },
      "pap": {
        "schedule_title": "Nomineeritud graafik ja lubatud hälve",
        "edit_schedule": "Muuda graafikut",
        "save_schedule": "Salvesta graafik",
        "window": "{start} — {end}",
        "no_window": "Lepinguperiood on määramata",
        "no_schedule": "Ühtegi kuud ei ole veel nomineeritud.",
        "tolerance": "Lubatud hälve ± {percent} %",
        "pools": "Kogumid | Kogum | Kogumid",
        "tolerance_label": "Lubatud hälve ± %",
        "tolerance_hint": "Kui palju võib kuu nomineeritud mahust üle või alla jääda, enne kui see märgitakse.",
        "month": "Kuu",
        "nominated": "Nomineeritud",
        "target_for": "Nomineeritud maht kuul {month}",
        "monitoring_title": "Kuine jälgimine",
        "monitoring_loading": "Laadin jälgimist…",
        "monitoring_empty": "Jälgida ei ole veel midagi.",
        "nominated_vs_escrowed": "Nomineeritud vs tagatisel",
        "delta": "Vahe nomineeritust",
        "status": "Olek",
        "status_pending": "Ootel",
        "status_within": "Vahemikus",
        "status_over": "Üle vahemiku",
        "status_under": "Alla vahemiku",
        "status_delivered": "Tarnitud",
        "ship_early_title": "Kas tarnida see kuu kohe?",
        "ship_early_body": "See kuu ei ole veel lõppenud: tootmine võib jätkuda ja tarnitakse ainult see, mis on praegu tagatisel. Tarnimine külmutab kuu, seega hiljem sellele kuule väljastatud sertifikaadid jäävad vabaks tagatiseks, mis tuleb käsitsi tagastada.",
        "ship_early_confirm": "Tarni siiski",
        "sell_price": "Müügihind",
        "sell_price_for": "Müügihind kuul {month}",
        "sell_price_invalid": "Sisesta hind, mis on suurem kui 0 ja kuni 3 komakohaga.",
        "months_shipped": "{months} tarniti vahepeal; sinu muudatused nende kuude kohta jäeti välja | {months} tarniti vahepeal; sinu muudatused selle kuu kohta jäeti välja | {months} tarniti vahepeal; sinu muudatused nende kuude kohta jäeti välja"
      },
      "transaction_status": {
        "DRAFT": "Mustand",
        "PENDING_BUYER_DETAILS": "Ostja andmed puuduvad",
        "PENDING_CONTRACTS": "Lepingud puuduvad",
        "READY_TO_TRANSFER": "Valmis ülekandeks",
        "DELIVERED": "Tarnitud",
        "COMPLETED": "Lõpetatud",
        "voided": "Tühistatud"
      },
      "merge": {
        "changed_meanwhile": "Keegi teine salvestas sinu muutmise ajal siia muudatusi. Sinu muudatused on alles ja ühendatud tema omadega. Kontrolli tulemust ja salvesta uuesti.",
        "unaffected": "Keegi teine salvestas sinu muutmise ajal tehingu, kuid siin näidatust ei muutunud midagi. Salvesta uuesti, et oma muudatused rakendada.",
        "taken_over": "Üle võeti {count} salvestatud muudatust | Üle võeti {count} salvestatud muudatus | Üle võeti {count} salvestatud muudatust",
        "conflicts": "{count} välja muudeti mõlemal poolel; vali allpool igale väärtus | {count} välja muudeti mõlemal poolel; vali allpool sellele väärtus | {count} välja muudeti mõlemal poolel; vali allpool igale väärtus",
        "yours": "Sinu: {value}",
        "saved_now": "Praegu salvestatud: {value}",
        "keep_yours": "Jäta sinu oma",
        "use_saved": "Kasuta salvestatut"
      }
    }
  },
  "soldera_inventory": {
    "title": "Soldera laoseis",
    "description": "Päritolutunnistused, mida Soldera saab tarnida kohe või tulevasest tootmisest. Valige kogus ja saatke Solderale oma pakkumine.",
    "not_enabled": "Soldera laoseis ei ole sinu kontole avatud. Ligipääsu saamiseks võta ühendust: {email}.",
    "purchase_details": "Ostu andmed",
    "counterparty_emails": "Arvete e-posti aadressid",
    "counterparty_emails_hint": "Eralda mitu aadressi komaga.",
    "price": "Hind",
    "price_hint": "Sinu hind sertifikaadi (1 MWh) kohta. Sertifikaate, mille tootja küsib rohkem, ei kuvata.",
    "select_certificates": "Vali sertifikaadid",
    "create_purchase": "Saada siduv pakkumine",
    "regions": "Piirkonnad",
    "blocked": {
      "no_selection": "Vali sertifikaadid, mida soovid osta.",
      "no_price": "Sisesta nullist suurem hind.",
      "mixed_authorities": "Vali sertifikaadid ühest sertifikaadiskeemist.",
      "no_company": "Vali ettevõte, kelle nimel ostad."
    },
    "created_title": "Siduv pakkumine saadetud",
    "created_description": "Sinu siduv pakkumine {mwh} MWh kohta saadeti Solderale. Võtame sinuga kinnitamiseks ühendust.",
    "billing_country": "Arveldusriik",
    "generate_breakdown": "Loo Exceli ülevaade",
    "open_breakdown": "Ava ülevaade",
    "breakdown_ready_title": "Ülevaade valmis",
    "breakdown_ready_description": "Ülevaade avati uuel vahelehel ja jagati aadressiga {email}.",
    "tabs": {
      "spot": "Saadaval kohe",
      "forward": "Tulevane tootmine"
    },
    "forward": {
      "select_pools": "Valige tulevane tootmine",
      "price_hint": "Teie hind MWh kohta, iga tarne jaoks. Tootmist, mille tootjad küsivad rohkem, ei kuvata.",
      "no_pools": "Nendel perioodidel ja selle hinnaga ei ole tulevast tootmist pakkuda.",
      "spread_over_pools": "@:forwards.picker.take.spread",
      "all_technologies": "Kõik tehnoloogiad",
      "all_countries": "Kõik riigid",
      "columns": {
        "technology": "@:forwards.picker.take.technology",
        "country": "@:forwards.picker.take.country",
        "scheme": "Skeem",
        "cod_age": "Vanim COD (aastat)",
        "support": "@:forwards.picker.take.support",
        "ecolabels": "@:forwards.picker.take.ecolabels",
        "capacity": "Saadaval MWh",
        "take": "Teie MWh"
      },
      "blocked": {
        "no_takes": "Sisestage soovitud MWh vähemalt ühest kogumist."
      },
      "warnings": {
        "pl_be_mixed": "Teie valik segab {flagged} ja {others}, mida ostetakse tavaliselt eraldi toodetena.",
        "standard_aib_gc_mixed": "Teie valik segab Standard AIB GC riike ({standard}) ja riike väljaspool standardnimekirja ({outside}).",
        "technology_mixed": "Teie valik segab {advanced} ja {hsw}; HSW (hüdro, päike, tuul) tooted seda tavaliselt ei sisalda."
      }
    }
  },
  "inventory_selection": {
    "quick_filters": "@:forwards.picker.criteria.quick_filters",
    "standard_aib_gc": "@:forwards.pools.eligibility.tier.standard_aib_gc",
    "vintage": "Tootmisaasta",
    "tech_filters": {
      "hsw": "Hüdro, päike, tuul",
      "biomass": "@:common.technology.biomass",
      "nuclear": "Tuumaenergia"
    },
    "auto_select": "Automaatne valik",
    "target": "@:forwards.picker.take.target",
    "target_label": "@:forwards.picker.take.target_label",
    "spread_over_companies": "Jaota ettevõtete vahel",
    "clear": "@:forwards.picker.take.clear",
    "available": "Saadaval",
    "selected": "Valitud",
    "row_count": "{count} rida | {count} rida",
    "breakdowns": {
      "production_months": "Tootmiskuud",
      "support_status": "@:forwards.picker.summary.by_support",
      "technology": "@:forwards.picker.take.technology",
      "commercial_operations_date": "@:forwards.picker.summary.by_cod",
      "re100_applicable": "@:forwards.picker.summary.re100",
      "ecolabel_status": "@:forwards.picker.summary.by_ecolabel",
      "supported": "Toetatud",
      "unsupported": "Toetuseta",
      "unknown": "@:common.unknown",
      "cod_le_5": "@:forwards.picker.summary.cod_young",
      "cod_6_15": "@:forwards.picker.summary.cod_middle",
      "cod_gt_15": "@:forwards.picker.summary.cod_old",
      "ekoenergy_pre_approved": "@:forwards.picker.ecolabel.ekoenergy",
      "okpower_new_compatible": "@:forwards.picker.ecolabel.okpower_new"
    }
  }
}
